var isLw100Personalization = false;
var isAs022Personalization = false;
var isPlaettchenPreviewPersonalization = false;
var isEngravingOnlyPopup = isLw100Personalization || isAs022Personalization;
(function($) {
  var CHAR_MAX_LINE1 = isAs022Personalization ? 12 : 10;
  /* Zeile 2: 10 statt 4 (Yin 2026-08-23: „2 zeilen. 第二行给 10 个字符").
     Aus der Klonquelle kamen 4 — dort war die zweite Zeile als Jahreszahl
     gedacht ("2024"). Jetzt gleich lang wie Zeile 1.
     ⚠️ Damit wird die Breitenkappe fuer Zeile 2 zum bestimmenden Wert:
     zehn Zeichen sind breiter als das Plaettchen, sie MUESSEN von
     MK006_TUNE.limitBreiteZeile2 heruntergerechnet werden. */
  var CHAR_MAX_LINE2 = 10;
  var SYMBOL_COST = 3;
  /* Vierte Gravur-Art (Yin 2026-08-18: „参考 A221"): Name oben, darunter ein
     Motiv. Kuerzer als die freie 1. Zeile, weil unter dem Namen noch das
     Motiv steht — Wert wie auf A221/LW100. */
  var MK006_TM_LAYOUT = 'text_oben_motiv_unten';
  var CHAR_MAX_TM_TEXT = 8;
  /* Zwei Gravur-Arten ohne freien Text (Yin 2026-09-03: „Bei MK006 bitte die
     Optionen ‚Koordinaten' und ‚römische Zahlen' hinzufügen"). Bauplan aus
     K532/HK004; das KOORDINATENFORMAT kommt bewusst von R002 — Grad und
     Minuten, KEINE Sekunden. Sekunden brauchen ein doppeltes
     Anfuehrungszeichen, das nicht jede Gravurschrift fuehrt.
     Vorlagenschluessel und Vorschau-Modus sind hier absichtlich DASSELBE
     Wort: bei „Text oben, Motiv unten" laufen zwei Namen fuer eine Sache
     (text_oben_motiv_unten / text_motiv), und genau daran hat sich am
     2026-09-03 ein Regler vergriffen. */
  var MK006_KOORD_LAYOUT = 'koordinaten';
  var MK006_ROMAN_LAYOUT = 'roemische_zahlen';
  var MK006_ROMAN_MAX = 20;
  /* Feste Gravurschrift fuer beide, wortgleich aus K532 uebernommen: Ziffern,
     Gradzeichen und roemische Zahlzeichen sehen in den Schreibschriften
     G04/G05/G06 unruhig aus. Folge: beide Stile zeigen KEINE Schriftzeile und
     stehen deshalb nicht in MK006_FONT_LAYOUTS — und jeder Regler, der an
     (Vorlage x Schrift) haengt, muss sie aussparen, sonst stuende er im
     Fenster und bewegte nichts. */
  var MK006_FESTE_SCHRIFT = 'G02';
  function mk006IstFesteSchriftStil(schluessel) {
    return schluessel === MK006_KOORD_LAYOUT || schluessel === MK006_ROMAN_LAYOUT;
  }
  var ALLOWED_FONTS = ['G02', 'G04', 'G05', 'G06'];
  var AS022_ALLOWED_FONTS = ['G02', 'G03', 'G04', 'G05', 'G06', 'G07', 'G08'];
  var AS022_G07_ONLY_LAYOUT = '1_zeile';
  var AS022_G07_CHAR_MAX = 8;
  var SIDE_LABELS = ['Vorderseite', 'Rückseite'];
  var sideLayouts = ['1_zeile', '1_zeile'];
  var previewSideCount = 1;
  var physicalSideMap = [0];
  var globalFont = null;
  var fontsCache = null;
  var symbolsCache = null;

  function setPhysicalSideMap(map) {
    physicalSideMap = Array.isArray(map) && map.length ? map.slice() : [0];
  }

  function getPhysicalSideIndex(uiSideIndex) {
    if (physicalSideMap[uiSideIndex] != null) return physicalSideMap[uiSideIndex];
    return uiSideIndex;
  }

  window.lw043SetPhysicalSideMap = setPhysicalSideMap;

  /* Vorschau-Basisbilder — Konvention einzel/paar (MK003-Schule).
       einzel = EINE Kette          -> einseitig
       paar   = ZWEI Ketten         -> beidseitig (links Vorderseite, rechts Rueckseite)
     Die Endung im Schluessel heisst bewusst "Einzel" und nicht "Vorder":
     bei LW043/A183/MK002 hiessen die Dateien "-vorder", enthielten aber
     einzel/paar — genau daran ist A183 aufgelaufen (DEV-PROCESS Abschnitt 3).
     Farbschluessel deutsch ("silber"), deckungsgleich mit dem Optionswert
     "Silber", damit Schluessel und Dateiname nicht auseinanderlaufen. */
  var MK006_PREVIEW_IMAGES = {
    silber:         window.VIV_MK006.bild_mk006_preview_silber_paar_png,
    gold:           window.VIV_MK006.bild_mk006_preview_gold_paar_png,
    rosegold:       window.VIV_MK006.bild_mk006_preview_rosegold_paar_png,
    silberEinzel:   window.VIV_MK006.bild_mk006_preview_silber_einzel_png,
    goldEinzel:     window.VIV_MK006.bild_mk006_preview_gold_einzel_png,
    rosegoldEinzel: window.VIV_MK006.bild_mk006_preview_rosegold_einzel_png
  };

  /* Geburtsstein-Katalog (2026-08-01, Stufe 3).
     Frueher stand hier eine feste Tabelle "Dateiname-Wert -> Vorschaugrafik".
     Der Schluessel kam aus dem Dateinamen, deshalb haette jede Umbenennung im
     Katalog die Vorschau leer laufen lassen. Jetzt liefert das Metaobject
     geburtsstein_serie "G · MK006" beide Werte selbst: Vorschaugrafik und
     Anzeigename. Ein neuer Stein braucht damit keine Code-Aenderung mehr.
     Beide Schluessel werden eingetragen (alt_wert UND name), damit die
     Zuordnung sowohl vor als auch nach Stufe 2 trifft.

     ★ EIGENE SERIE, nicht die runde Serie D mitbenutzt (Yin 2026-08-30:
     "还是用 mk006 的, 我怕出错"). Die zwoelf Eintraege
     gs-g-01-januar-mk006 … gs-g-12-dezember-mk006 tragen MK006s eigene
     Bilder; eine Aenderung an Serie D beruehrt MK006 nicht und umgekehrt.
     Ableitung der Monatszuordnung: docs/PREVIEW-UPLOAD-MK006.md. */
  /* Die Geburtstein-Tabellen werden aus dem Metaobjekt gebaut und stehen deshalb
     weiterhin inline im Snippet (Liquid); hier nur die Bindung daran. */
  var MK006_GEBURTSSTEIN_FILES = window.VIV_MK006.geburtssteinFiles;
  var MK006_GEBURTSSTEIN_NAMEN = window.VIV_MK006.geburtssteinNamen;

  /* ---- Motive: W-Reihe (2026-08-07) --------------------------------------
     Loest die alte C-Reihe ab — Beschluss Yin: eine einzige Icon-Familie im
     ganzen Shop, Referenz ist KE008. Satz = KE008s zehn + Pfote (W31) = elf.

     ★ Der Bestand kommt jetzt aus DIESER Datei. Frueher wurde er aus dem
     Template-Picker (.product_info_image_json, die alten C1–C50) gefiltert —
     das Snippet hing also daran, dass im Template noch der alte Picker steckt.
     Diese Abhaengigkeit ist weg.

     ⚠️ Dateinamen sind unregelmaessig: w01–w10 zweistellig, ab W11
     dreistellig (w011, w027, w031 …). Nicht "vereinheitlichen". */
  var MK006_SYMBOL_NAMES = {
    'w01.png': 'Mini Herz', 'w02.png': 'Herz', 'w03.png': 'Doppelherz', 'w05.png': 'Infinity',
    'w06.png': 'Jesusfisch', 'w07.png': 'Kreuz', 'w09.png': 'Engel', 'w027.png': 'Anker',
    'w031.png': 'Pfote', 'w036.png': 'Fee', 'w041.png': 'Stern'
  };

  /* Motivsatz MK006 — VOLLSTAENDIGE W-Reihe, 42 Motive (Yin 2026-08-23:
     „nur Motiv 所有的图标都要上"). Der Rest des Ladens bleibt bei den elf
     Motiven, die am 2026-08-07 store-weit festgelegt wurden (siehe
     docs/ROLLBACK-W-ICONS.md) — auf Yins ausdrueckliche Ansage nur hier
     erweitern, 19 andere Snippets bleiben unberuehrt.

     Die Namen sind NICHT erfunden, sondern aus Yins eigenem C-Katalog
     uebernommen (der alte Template-Picker C1-C50, er steht weiterhin in rund
     162 Templates). Vier Motive kommen im C-Katalog nicht vor; die tragen
     einen neu vergebenen Namen und sind unten so markiert.

     W21 „Buchstabe mit Kranz" ist auf Yins Wunsch 2026-08-23 raus: der
     Kranz umschliesst einen Buchstaben, den es hier nicht zu setzen gibt.
     Die Datei bleibt in den Shopify Files, damit Altbestellungen mit
     diesem Motiv weiter aufloesbar sind.

     Der Bestellwert ist "Name | CODE". Das Bild findet die Werkstatt ueber
     den CODE — ein Name, den Yin spaeter anders haben will, laesst sich also
     gefahrlos aendern, ohne alte Bestellungen zu brechen. */
  var MK006_SYMBOLS_FIXED = [
    { code: 'W01', text: 'Mini Herz',             image: window.VIV_MK006.bild_w01_png },
    { code: 'W02', text: 'Herz',                  image: window.VIV_MK006.bild_w02_png },
    { code: 'W03', text: 'Doppelherz',            image: window.VIV_MK006.bild_w03_png },
    { code: 'W04', text: 'Love',                  image: window.VIV_MK006.bild_w04_png },
    { code: 'W05', text: 'Infinity',              image: window.VIV_MK006.bild_w05_png },
    { code: 'W06', text: 'Jesusfisch',            image: window.VIV_MK006.bild_w06_png },
    { code: 'W07', text: 'Kreuz',                 image: window.VIV_MK006.bild_w07_png },
    { code: 'W08', text: 'Engelflügel',           image: window.VIV_MK006.bild_w08_png },
    { code: 'W09', text: 'Engel',                 image: window.VIV_MK006.bild_w09_png },
    { code: 'W11', text: 'Bester Papa',           image: window.VIV_MK006.bild_w011_png },   /* Name neu vergeben — steht so in keinem Katalog */
    { code: 'W12', text: 'Lieblingsmensch',       image: window.VIV_MK006.bild_w012_png },
    { code: 'W13', text: 'Kleiner Finger Schwur', image: window.VIV_MK006.bild_w013_png },
    { code: 'W14', text: 'Händchenhalten',        image: window.VIV_MK006.bild_w014_png },
    { code: 'W15', text: 'Hand Herz',             image: window.VIV_MK006.bild_w015_png },
    { code: 'W16', text: 'Faustgruß',             image: window.VIV_MK006.bild_w016_png },   /* Name neu vergeben — steht so in keinem Katalog */
    { code: 'W17', text: 'Babyfüße',              image: window.VIV_MK006.bild_w017_png },   /* Name neu vergeben — steht so in keinem Katalog */
    { code: 'W18', text: 'Herzschlag',            image: window.VIV_MK006.bild_w018_png },
    { code: 'W19', text: 'Blumenstrauß',          image: window.VIV_MK006.bild_w019_png },
    { code: 'W20', text: 'Pusteblume',            image: window.VIV_MK006.bild_w020_png },
    { code: 'W22', text: 'Friedenstaube',         image: window.VIV_MK006.bild_w022_png },
    { code: 'W23', text: 'Baum',                  image: window.VIV_MK006.bild_w023_png },   /* Name neu vergeben — steht so in keinem Katalog */
    { code: 'W24', text: 'Lebensbaum',            image: window.VIV_MK006.bild_w024_png },
    { code: 'W25', text: 'Berg',                  image: window.VIV_MK006.bild_w025_png },
    { code: 'W26', text: 'Welle',                 image: window.VIV_MK006.bild_w026_png },
    { code: 'W27', text: 'Anker',                 image: window.VIV_MK006.bild_w027_png },
    { code: 'W28', text: 'Kompassrose',           image: window.VIV_MK006.bild_w028_png },
    { code: 'W29', text: 'Hufeisen',              image: window.VIV_MK006.bild_w029_png },
    { code: 'W30', text: 'Kleeblatt',             image: window.VIV_MK006.bild_w030_png },
    { code: 'W31', text: 'Pfote',                 image: window.VIV_MK006.bild_w031_png },
    { code: 'W32', text: 'Hund',                  image: window.VIV_MK006.bild_w032_png },
    { code: 'W33', text: 'Katze',                 image: window.VIV_MK006.bild_w033_png },
    { code: 'W34', text: 'Pferd',                 image: window.VIV_MK006.bild_w034_png },
    { code: 'W35', text: 'Biene',                 image: window.VIV_MK006.bild_w035_png },
    { code: 'W36', text: 'Fee',                   image: window.VIV_MK006.bild_w036_png },
    { code: 'W37', text: 'Einhorn',               image: window.VIV_MK006.bild_w037_png },
    { code: 'W38', text: 'Regenbogen',            image: window.VIV_MK006.bild_w038_png },
    { code: 'W39', text: 'Sonne',                 image: window.VIV_MK006.bild_w039_png },
    { code: 'W40', text: 'Lotus',                 image: window.VIV_MK006.bild_w040_png },
    { code: 'W41', text: 'Stern',                 image: window.VIV_MK006.bild_w041_png },
    { code: 'W42', text: 'Mädchen',               image: window.VIV_MK006.bild_w042_png },
    { code: 'W43', text: 'Junge',                 image: window.VIV_MK006.bild_w043_png },
  ];
  /* Altwerte: KH1–KH8 aus der ersten Generation, plus die eine echte
     Umbenennung beim Wechsel auf die W-Reihe (Fisch → Jesusfisch). Ohne den
     Alias faende getSymbolByName() ein altes "Fisch" nicht mehr und das Motiv
     fiele im wiederhergestellten Warenkorb stillschweigend weg. */
  var MK006_KH_LEGACY = {
    'KH1': 'Mini Herz', 'KH2': 'Herz', 'KH3': 'Doppelherz', 'KH4': 'Infinity',
    'KH5': 'Jesusfisch', 'KH6': 'Anker', 'KH7': 'Engel', 'KH8': 'Pfote',
    'Fisch': 'Jesusfisch', 'Christenfisch': 'Jesusfisch'
  };

  /* ════════ GEOMETRIE — alle Werte an den MK006-Bildern gemessen ════════
     Quelle und Messprotokoll: docs/PREVIEW-UPLOAD-MK006.md
     KEIN Wert ist von LW043 uebernommen. Die Buehne hat aspect-ratio:1, das
     Bild ist 1600x1600 mit object-fit:contain und ohne Zoom — Bildprozente
     sind damit unveraendert Buehnenprozente.

     Slot-Zuordnung:
       einseitig   -> einzel-Bild, Ebene "front"
       beidseitig  -> paar-Bild,   Ebene "front" = linke Kette (Vorderseite)
                                   Ebene "back"  = rechte Kette (Rueckseite)
     "front" gilt in BEIDEN Modi, weil die linke Bildhaelfte des paar-Bilds
     byteidentisch zum einzel-Bild ist (so wurde das einzel-Bild erzeugt).
     Das ist gemessen, nicht angenommen.

     ⚠️ MK006 ist eine SPIEGELKOPIE (bei LW065/A182/A183 war es eine
     Verschiebung — deren Vorzeichenlogik gilt hier NICHT). Eng zugeschnitten
     gemessen: Spiegel-RMS 9,43 gegen Verschiebungs-RMS 65,05, Faktor 7.
     Rechnerisch: 25,34 + 74,59 = 99,93 (perfekt waere 100,0), die y-Mitten
     liegen 0,5 px auseinander. Trotzdem stehen beide Werte ABSOLUT im Code
     und werden nicht auseinander berechnet — so bleibt jede Seite einzeln
     kalibrierbar (TUNER-PATTERN: keine Ableitung, kein geteilter Skalar). */

  /* Steinfassung — an der Vorderseite (linke Kette bzw. einzel-Bild).
     Gemessen an der texturierten Innenflaeche der Fassung (lokale
     Standardabweichung, Ring glatt / Innenflaeche rau):
       Innenflaeche 116 x 116 px, Mitte (537,5 | 914,5) px
       = left 33,59 %, top 57,16 %, Durchmesser 7,25 %
     Die Fassung selbst (Aussenkante) misst 132 px = 8,25 %.

     ⚠️ NUR EINE Gem-Ebene, wie bei der Klonquelle: der Stein sitzt vorne.
     Anders als bei LW065 sind MK006s beide Fassungen im paar-Bild
     spiegelgleich und sehen daher identisch aus — im beidseitig-Modus zeigt
     die rechte Kette also eine ungefaerbte Fassung. Ob das so bleiben soll
     oder ob beide Fassungen den Stein tragen sollen, ist eine Produktfrage
     fuer Yin (im Reglerfenster sofort sichtbar). rotate ist ein Saatwert. */
  var PREVIEW_GEM = { top: 57.16, left: 33.59, width: 7.25, rotate: 0 };

  /* Plaettchenmitte = Gravurmitte. Durchmesser 17,25 % der Buehne
     (276 px bei 1600). LW065 hat 19,44 % — daher ist KEIN Positions- oder
     Groessenwert direkt uebernommen, sondern umgerechnet:
       Wert_MK006 = Scheibenmitte_MK006 + (Wert_LW065 - Scheibenmitte_LW065) * 0,8873
     mit 0,8873 = 17,25 / 19,44 und den gemessenen Scheibenmitten
     LW065 front 24,08 / back 76,19 / y 65,62  ->  MK006 front 25,34 /
     back 74,59 / y front 66,47, back 66,44. */
  /* 1 ZEILE — container position; text/icon size via CSS --mk006-1zeile-* */
  var PREVIEW_1_ZEILE = {
    front: { top: 67.25, left: 25.34 },
    back: { top: 67.24, left: 74.59 }
  };
  var LW100_DUAL_1_ZEILE = {
    front: { top: 45, left: 25 },
    back: { top: 45, left: 75.5 }
  };
  var AS022_PLAETTCHEN_POS = {
    front: { top: 47, left: 25.8 },
    back: { top: 47, left: 74.5 }
  };
  var AS022_2ZEILEN_LINE2 = {
    front: { top: 53, left: 25.8 },
    back: { top: 53, left: 74.5 }
  };
  var AS022_NUR_MOTIV = {
    front: { top: 49, left: 25.8 },
    back: { top: 49, left: 74.5 }
  };
  var AS022_2ZEILEN_ROW_GAP_EXTRA = 1; /* +1% on base line1→line2 gap */
  var AS022_PREVIEW_TEXT_MAX_WIDTH_PCT = 24; /* 384px @ 1600 canvas */
  var PREVIEW_LETTER_ONLY_SCALE = 1.5; /* Phase 1①: letter_only only; not letter_icon */
  /* 2 ZEILEN — line1/line2 position; text/icon size via CSS --mk006-2zeilen-* */
  var PREVIEW_2_ZEILEN = {
    line1: {
      front: { top: 65.92, left: 25.34 },
      back: { top: 65.91, left: 74.59 }
    },
    line2: {
      front: { top: 68.58, left: 25.34 },
      back: { top: 68.57, left: 74.59 }
    }
  };
  var PREVIEW_TEXT_MAX_WIDTH_1600 = 221;
  /* ★ BREITENKAPPE — fuer MK006 NEU GERECHNET, nicht von LW065 uebernommen.
     LW065s Scheibe misst 19.44 % der Buehne, MK006s nur 17.25 % — dieselbe
     Zahl waere hier 13 % zu breit und der Text liefe ueber die Gravurkante.

     Rechnung (Kreis, alle Angaben in Prozent der Buehnenbreite):
       Durchmesser 2R = 17.25  ->  R = 8.625,  R^2 = 74.39
       Zeile 1 sitzt auf der Plaettchenmitte, dort steht die volle Sehne
       17.25 zur Verfuegung. Mit Sicherheitsrand 80 %: 0.80 x 17.25 = 13.80
     Der Rand ist noetig, weil Text sonst bis an die Gravurkante liefe.

     Zeile 2 sitzt bei MK006 2.11 pp unter der Mitte (68.58 - 66.47). Sehne:
       2 x sqrt(74.39 - 2.11^2) = 2 x sqrt(69.94) = 16.73
       Verjuengung = 16.73 / 17.25 = 0.970  ->  0.97
     (LW065 hatte 0.99, weil dort Zeile 2 nur 1.5 pp tief sitzt.)

     Rueckfallwert PREVIEW_TEXT_MAX_WIDTH_1600 = 221 px (= 0.138 x 1600, der
     geometrische Saatwert). Er greift nur, wenn limitBreite leer oder 0 ist.

     ★ Der Startwert in MK006_TUNE ist NICHT der Saatwert 13.80, sondern
     12.0 — abgeleitet aus Yins fertiger LW065-Kalibrierung: sie hat dort
     13.5 bei 19.44 % Scheibe eingestellt, also 69.5 % des Durchmessers.
     69.5 % von 17.25 = 12.0. Ihre bereits geleistete Kalibrierarbeit wird so
     mituebernommen statt bei Null anzufangen (SOP: vorhandene kalibrierte
     Werte suchen, bevor geschaetzt wird). Bleibt selbstverstaendlich Regler.

     ★ EINHEITEN — die beiden Regler heissen aehnlich und meinen Verschiedenes:
       limitBreite        PROZENT der Buehnenbreite
       limitBreiteZeile2  FAKTOR auf limitBreite  (1 = Zeile 2 so breit wie Zeile 1)
     2026-08-23 kam ein Export mit limitBreiteZeile2 = 13.5 herein — offenbar
     als Prozentwert gemeint. Das haette die Kappe fuer Zeile 2 praktisch
     abgeschaltet (13.5 x 13.5 % = 182 % der Buehne). Nach Ruecksprache mit Yin
     auf 1 gesetzt. Wer die Beschriftung im Panel aendert: die Endungen % und ×
     sind das einzige Unterscheidungsmerkmal.

     Beide Zahlen sind Regler in TUNE und ueber scripts/mk006/bake.py backbar. */
  var PREVIEW_TEXT_MAX_WIDTH_AS022 = 384;

  function getPreviewTextMaxWidthBase() {
    return isAs022Personalization ? PREVIEW_TEXT_MAX_WIDTH_AS022 : PREVIEW_TEXT_MAX_WIDTH_1600;
  }
  /* Nur Motiv tab only — container position; text/icon size via CSS --mk006-nur-motiv-* */
  var PREVIEW_NUR_MOTIV = {
    front: { top: 67.25, left: 25.34 },
    back: { top: 67.24, left: 74.59 }
  };
  var MK006_1ZEILE_ICON_GAP_DEFAULT = '-0.1em';
  var MK006_2ZEILEN_ICON_GAP_DEFAULT = '-0.1em';
  var MK006_1ZEILE_ICON_GAP = {
    /* Gemessen 2026-08-07 (Alpha-bbox der PNGs, GOTCHAS 14): beim Wechsel auf
       die W-Reihe wuchs der leere Rand links bei Infinity und Jesusfisch um je
       11.4 % der Box (= 0.159em bei 1.1em Bildhoehe), bei Doppelherz um 2.9 %.
       Die Gap-Werte ziehen genau das wieder ab, damit der SICHTBARE Abstand
       bleibt wie vorher. Die uebrigen neun Motive aendern sich um <1 % und
       laufen weiter ueber den Default. */
    'Doppelherz': '0.06em',
    'Infinity': '-0.06em',
    'Jesusfisch': '-0.06em'
  };
  var MK006_2ZEILEN_ICON_GAP = {
    /* Gemessen 2026-08-07 (Alpha-bbox der PNGs, GOTCHAS 14): beim Wechsel auf
       die W-Reihe wuchs der leere Rand links bei Infinity und Jesusfisch um je
       11.4 % der Box (= 0.159em bei 1.1em Bildhoehe), bei Doppelherz um 2.9 %.
       Die Gap-Werte ziehen genau das wieder ab, damit der SICHTBARE Abstand
       bleibt wie vorher. Die uebrigen neun Motive aendern sich um <1 % und
       laufen weiter ueber den Default. */
    'Doppelherz': '0.06em',
    'Infinity': '-0.06em',
    'Jesusfisch': '-0.06em'
  };

  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function imageFileFromUrl(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function normalizeSymbolName(text, imageUrl) {
    var file = imageFileFromUrl(imageUrl);
    if (MK006_SYMBOL_NAMES[file]) return MK006_SYMBOL_NAMES[file];
    if (MK006_KH_LEGACY[text]) return MK006_KH_LEGACY[text];
    return text;
  }

  function normalizeStoredSymbol(name) {
    return name ? (MK006_KH_LEGACY[name] || name) : '';
  }

  function symbolSlug(name) {
    return String(normalizeStoredSymbol(name) || name || '')
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  function getLayoutIconGap(name, previewMode) {
    var key = normalizeStoredSymbol(name) || name;
    var map = previewMode === '2_zeilen' ? MK006_2ZEILEN_ICON_GAP : MK006_1ZEILE_ICON_GAP;
    var fallback = previewMode === '2_zeilen' ? MK006_2ZEILEN_ICON_GAP_DEFAULT : MK006_1ZEILE_ICON_GAP_DEFAULT;
    return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : fallback;
  }

  /* Nur noch die eigene Liste — kein Umweg mehr ueber den Template-Picker. */
  /* „Text oben, Motiv unten": nur ZEHN Motive, nicht alle 42 (Yin 2026-08-23:
     „aber 10 Motiv, nicht alles uebernehmen"). In dieser Vorlage sitzt das
     Motiv klein unter dem Namen — Schriftbilder (Love, Bester Papa,
     Lieblingsmensch) und breite Szenen (Berg, Welle, Baum) sind dort nicht
     lesbar. Ausgewaehlt sind die schmalen, klaren Zeichen.

     Nur diese eine Zeile aendern, wenn Yin die Auswahl anders haben will —
     die Codes stehen bei MK006_SYMBOLS_FIXED. „Nur Motiv" bleibt bei allen 42. */
  var MK006_TM_MOTIVE = ['W01', 'W02', 'W03', 'W05', 'W06', 'W07', 'W09', 'W30', 'W31', 'W41'];

  function loadSymbols() {
    if (symbolsCache) return symbolsCache;
    symbolsCache = MK006_SYMBOLS_FIXED.slice();
    return symbolsCache;
  }

  /* Bestellwert = "Anzeigename | CODE" (z. B. "Jesusfisch | W06"). Der Code ist
     der einzige Weg, wie der Auftrags-Parser das Bild findet; der Name steht
     davor, damit die Werkstatt ihn ohne Tabelle liest. */
  function formatSymbolOrderValue(name) {
    var resolved = normalizeStoredSymbol(name);
    if (!resolved) return '';
    var symbols = loadSymbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved) {
        return symbols[i].code ? (resolved + ' | ' + symbols[i].code) : resolved;
      }
    }
    return resolved;
  }

  /* ★ Der Feldname entscheidet, ob der Auftrags-Parser ueberhaupt ein Bild
     zeigt. Er kennt nur zwei Muster:
       • Label endet auf "Motiv"        → er loest den Code auf
       • Label endet auf "Text + Motiv" → er trennt "Text(Motiv)" selbst auf
     Ein Motiv, das (wie frueher) unter dem Label "Text" mitfaehrt, landet bei
     ihm als reiner Text und bleibt fuer immer bildlos. Deshalb wechselt das
     Label, sobald die Zeile ein Motiv enthaelt.
     withCode = true fuer die Bestellzeile, false fuer die Bestaetigung, die
     der Kunde sieht — dort waere "| W06" nur Rauschen. */
  function lineOrderRow(title, plainLabel, mixedLabel, text, symbol, withCode) {
    var t = String(text || '');
    var symName = normalizeStoredSymbol(symbol);
    if (!symName) return { name: title + ' ' + plainLabel, value: t };
    var symOut = withCode ? formatSymbolOrderValue(symName) : symName;
    return { name: title + ' ' + mixedLabel, value: t + '(' + symOut + ')' };
  }

  function loadFonts() {
    if (fontsCache) return fontsCache;
    fontsCache = [];
    $('.product_info_font_json').each(function() {
      try {
        var arr = JSON.parse($(this).html());
        for (var i = 0; i < arr.length; i++) {
          if (isAs022Personalization) {
            if (arr[i] && arr[i].font_name && AS022_ALLOWED_FONTS.indexOf(arr[i].font_name) !== -1) {
              fontsCache.push(arr[i]);
            }
          } else if (ALLOWED_FONTS.indexOf(arr[i].font_name) !== -1) {
            fontsCache.push(arr[i]);
          }
        }
      } catch (e) {}
    });
    if (!isAs022Personalization) {
      ALLOWED_FONTS.forEach(function(code) {
        if (!fontsCache.some(function(f) { return f.font_name === code; })) {
          fontsCache.push({ font_name: code, text: code, image: '' });
        }
      });
      fontsCache.sort(function(a, b) {
        return ALLOWED_FONTS.indexOf(a.font_name) - ALLOWED_FONTS.indexOf(b.font_name);
      });
    } else {
      fontsCache.sort(function(a, b) {
        return AS022_ALLOWED_FONTS.indexOf(a.font_name) - AS022_ALLOWED_FONTS.indexOf(b.font_name);
      });
    }
    return fontsCache;
  }

  function isAs022G07FontAllowed() {
    if (!isAs022Personalization) return true;
    var zu = getActiveSideCount();
    if (zu < 1) return true;
    for (var i = 0; i < zu; i++) {
      if (getSideLayout(i) !== AS022_G07_ONLY_LAYOUT) return false;
    }
    return true;
  }

  function getSelectableFonts() {
    var fonts = loadFonts();
    if (!isAs022Personalization || isAs022G07FontAllowed()) return fonts;
    return fonts.filter(function(f) { return f.font_name !== 'G07'; });
  }

  function ensureAs022GlobalFontForLayout() {
    if (!isAs022Personalization || isAs022G07FontAllowed()) return false;
    if ((getGlobalFont().font_name || '') !== 'G07') return false;
    var fonts = getSelectableFonts();
    globalFont = fonts.length ? fonts[0] : { font_name: 'G02', text: 'NirmalaS' };
    applyFontToInputs();
    return true;
  }

  function getGlobalFont() {
    if (!globalFont) {
      var fonts = loadFonts();
      globalFont = fonts.length ? fonts[0] : { font_name: 'G02', text: 'NirmalaS' };
    }
    return globalFont;
  }

  /* „Zeilenartig" = die Lage kommt aus PREVIEW_2_ZEILEN (Zeile 1 oben,
     Zeile 2 darunter). Text-oben-Motiv-unten benutzt genau diese beiden
     Anker — deshalb faellt es hier mit hinein und braucht keine eigenen. */
  function isZeilenLikeMode(previewMode) {
    return previewMode === '2_zeilen' || previewMode === 'text_motiv';
  }

  /* „Zwei Marken uebereinander" ist eine LAGE-Frage; isZeilenLikeMode ist
     darueber hinaus der Schluessel fuer je-Schrift-Regler (mk006ZeilenVersatz)
     UND fuer die Reglerzeilen im Tuner. „Koordinaten" braucht nur die Lage:
     wuerde es in isZeilenLikeMode mitlaufen, stuenden im Fenster sieben
     „2 Zeilen · <Schrift>"-Regler, die in diesem Stil (feste Schrift) nichts
     bewegen — genau der Fehlbestand, den docs/REGELN.md verbietet. Darum ein
     eigener, ausschliesslich in getPreviewPos benutzter Helfer. */
  function mk006IstZweizeiligeLage(previewMode) {
    return isZeilenLikeMode(previewMode) || previewMode === MK006_KOORD_LAYOUT;
  }

  function getLineMaxLen(lineNum, sideIndex) {
    if (sideIndex != null && String(lineNum) !== '2' && getSideLayout(sideIndex) === MK006_TM_LAYOUT) {
      return CHAR_MAX_TM_TEXT;
    }
    if (isAs022Personalization && (getGlobalFont().font_name || '') === 'G07' && String(lineNum) !== '2') {
      return AS022_G07_CHAR_MAX;
    }
    return String(lineNum) === '2' ? CHAR_MAX_LINE2 : CHAR_MAX_LINE1;
  }

  /* Einfache Anfuehrungszeichen, KEINE doppelten (Phase-3-Regel „字体栈引号
     单引号化"): die Stacks landen per String-Konkatenation in style="…" —
     ein doppeltes Anfuehrungszeichen beendet dort das Attribut, und alles ab
     font-family (inkl. scale-Regler) faellt stumm weg. 2026-08-19 im
     Vollmatrix-Pruefstand erwischt: G04/G05/G06 verloren so ihre
     Groessen-Regler, G02 (ohne Anfuehrungszeichen) nicht. */
  var MK006_FONT_STACK = {
    G01: 'MingLiU-ExtB, serif',
    G02: 'NirmalaS, sans-serif',
    G03: "'Time New Man', serif",
    G04: "'Monotype Corsiva', sans-serif",
    G05: "'Bradley Hand ITC', sans-serif",
    G06: "'Murray Hill BT', sans-serif",
    G07: 'Chloe, sans-serif',
    G08: 'fatskinny, sans-serif'
  };

  function getFontFamilyCss() {
    var font = getGlobalFont();
    var code = font.font_name || 'G02';
    if (MK006_FONT_STACK[code]) return MK006_FONT_STACK[code];
    if (font.text) return font.text.indexOf(',') !== -1 ? font.text : font.text + ', sans-serif';
    return MK006_FONT_STACK.G02;
  }

  function getPreviewFontCodeClass() {
    var code = (getGlobalFont().font_name || 'G02').toLowerCase();
    return ' mk006-preview-font-' + code;
  }

  function isUppercaseOnlyFont() {
    return (getGlobalFont().font_name || 'G02') === 'G08';
  }

  function sanitizeUppercaseLetters(text) {
    return String(text || '').toUpperCase().replace(/[^A-ZÄÖÜẞ0-9.]/g, '');
  }

  function isValidSymbolToken(inner) {
    return !!getSymbolByName(normalizeStoredSymbol(inner)) || !!getSymbolByName(inner);
  }

  function countPreviewLetters(raw) {
    raw = String(raw || '');
    var total = 0, re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      total += (match.index - last);
      if (!isValidSymbolToken(match[1])) total += match[0].length;
      last = re.lastIndex;
    }
    total += raw.length - last;
    return total;
  }

  function countPreviewIcons(raw) {
    var count = 0, re = /\(([^)]+)\)/g, match;
    raw = String(raw || '');
    while ((match = re.exec(raw)) !== null) {
      if (isValidSymbolToken(match[1])) count++;
    }
    return count;
  }

  function isAs022PreviewLetterOnly(raw, previewMode, symbolOnly, sideClass) {
    if (!isAs022Personalization) return false;
    if (symbolOnly || previewMode === 'nur_motiv') return false;
    if (previewMode !== '1_zeile') return false;
    if (sideClass.indexOf('--front') === -1) return false;
    return countPreviewLetters(raw) === 1 && countPreviewIcons(raw) === 0;
  }

  function getPreviewLetterOnlyClass(raw, previewMode, symbolOnly, sideClass) {
    return isAs022PreviewLetterOnly(raw, previewMode, symbolOnly, sideClass)
      ? ' mk006-preview-text--letter-only' : '';
  }

  function getPreviewLetterOnlyScaleMultiplier(el) {
    if (!el || !el.classList) return 1;
    if (el.classList.contains('mk006-preview-text--letter-only')) return PREVIEW_LETTER_ONLY_SCALE;
    return 1;
  }

  function normalizeG08RawLine(raw) {
    raw = String(raw || '');
    var result = '', re = /\(([^)]*)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      result += sanitizeUppercaseLetters(raw.substring(last, match.index));
      var inner = match[1];
      if (isValidSymbolToken(inner)) {
        var sym = getSymbolByName(normalizeStoredSymbol(inner)) || getSymbolByName(inner);
        result += '(' + sym.text + ')';
      } else {
        result += sanitizeUppercaseLetters(inner);
      }
      last = re.lastIndex;
    }
    result += sanitizeUppercaseLetters(raw.substring(last));
    return result;
  }

  function trimToWeightedMax(str, maxLen) {
    var s = String(str || '');
    while (weightedLength(s) > maxLen && s.length) s = s.slice(0, -1);
    return s.replace(/\([^)]*$/, '');
  }

  function lineHasSymbolAndText(raw) {
    if (!raw) return false;
    var hasSym = false, hasText = false;
    var re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      if (!isValidSymbolToken(match[1])) continue;
      hasSym = true;
      if (sanitizeUppercaseLetters(raw.substring(last, match.index))) hasText = true;
      last = re.lastIndex;
    }
    if (sanitizeUppercaseLetters(raw.substring(last))) hasText = true;
    return hasSym && hasText;
  }

  function hasInlineSymbolTokens(raw) {
    if (!raw) return false;
    var re = /\(([^)]+)\)/g, match;
    while ((match = re.exec(raw)) !== null) {
      if (!isValidSymbolToken(match[1])) continue;
      if (match.index + match[0].length < raw.length) return true;
    }
    return false;
  }

  function getG08LineRaw($input, sideIndex, lineNum) {
    var raw = normalizeG08RawLine($input.val() || '');
    var storedSym = getLineSymbol(sideIndex, lineNum);
    if (storedSym && !/\([^)]+\)/.test(raw)) raw = composeLine(raw, storedSym);
    return raw;
  }

  function appendOrReplaceTrailingG08Symbol(raw, symName) {
    raw = normalizeG08RawLine(raw || '');
    var token = '(' + normalizeStoredSymbol(symName) + ')';
    var trailing = raw.match(/\(([^)]+)\)$/);
    if (trailing && isValidSymbolToken(trailing[1])) {
      return raw.slice(0, raw.length - trailing[0].length) + token;
    }
    return raw + token;
  }

  function setG08LineRaw($input, sideIndex, lineNum, raw, maxLen) {
    setLineSymbol(sideIndex, lineNum, '');
    raw = trimToWeightedMax(normalizeG08RawLine(raw), maxLen);
    $input.val(raw);
    toggleLineClear($input, raw);
    return raw;
  }

  function normalizeLineTextForFont(text) {
    if (!isUppercaseOnlyFont()) return text || '';
    return sanitizeUppercaseLetters(text);
  }

  function applyFontToInputs() {
    var fontCode = getGlobalFont().font_name || 'G02';
    var fontCss = getFontFamilyCss();
    $('.up-Fenster-p-personalization-1 .mk006-line-input')
      .attr('data-mk006-font', fontCode)
      .css('font-family', fontCss);
  }

  function weightedLength(str) {
    if (!str) return 0;
    var total = 0, re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(str)) !== null) {
      total += match.index - last;
      total += SYMBOL_COST;
      last = re.lastIndex;
    }
    total += str.length - last;
    return total;
  }

  function composeLine(text, symbol) {
    return (text || '') + (symbol ? '(' + normalizeStoredSymbol(symbol) + ')' : '');
  }

  function isSymbolOnlyRaw(raw) {
    if (!raw) return false;
    if (isUppercaseOnlyFont()) {
      var normalized = normalizeG08RawLine(raw);
      var only = normalized.match(/^\(([^)]+)\)$/);
      return !!(only && isValidSymbolToken(only[1]));
    }
    var parsed = parseLineValue(raw);
    return !!parsed.symbol && !parsed.text;
  }

  function parseLineValue(raw) {
    var val = raw || '';
    var match = val.match(/\(([^)]+)\)$/);
    if (match) {
      var symName = normalizeStoredSymbol(match[1]);
      if (getSymbolByName(symName) || getSymbolByName(match[1])) {
        return { text: val.substring(0, val.length - match[0].length), symbol: symName };
      }
    }
    return { text: val, symbol: '' };
  }

  function getSymbolByName(name) {
    if (!name) return null;
    var resolved = normalizeStoredSymbol(name);
    var symbols = loadSymbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved || symbols[i].text === name) return symbols[i];
    }
    return null;
  }

  function getSideIndexFromEl($el) {
    var $side = $el.closest('[class*="product_info_main_"]');
    if (!$side.length) return NaN;
    var match = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function getSideLabel(index) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
    var title = $.trim($side.find('.pattles-message-header span').first().text());
    return title || SIDE_LABELS[index] || ('Seite ' + (index + 1));
  }

  function getActiveSideCount() {
    var domCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return domCount > 0 ? domCount : previewSideCount;
  }

  function getSelectedGeburtssteinValue() {
    var val = $('[name="properies"]:checked').attr('data-value');
    return val ? String(val).trim() : '';
  }

  function formatGeburtssteinLabel(value) {
    if (!value) return '';
    // Katalogname gewinnt (z. B. "Januar · Granat"); ohne Treffer wie frueher
    // aus dem Dateinamen-Wert ableiten.
    if (MK006_GEBURTSSTEIN_NAMEN && MK006_GEBURTSSTEIN_NAMEN[value]) {
      return MK006_GEBURTSSTEIN_NAMEN[value];
    }
    return value.replace(/-G$/i, '').split('-').map(function(part, idx) {
      if (!part) return '';
      var lower = part.toLowerCase();
      if (idx === 0) return lower.charAt(0).toUpperCase() + lower.slice(1);
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    }).join(' – ');
  }

  /* Optionswerte am Produkt: "Gold" / "Silber" / "Roségold".
     "Roségold" enthaelt selbst "gold", deshalb muss die ros-Pruefung zuerst
     laufen. Rueckfall ist 'silber' — deckungsgleich mit MK006_PREVIEW_IMAGES. */
  function getColorKeyFromOption1() {
    var label = ($('[name="option1"]').attr('data-value') || '').toLowerCase();
    if (label.indexOf('ros') !== -1) return 'rosegold';
    if (label.indexOf('gold') !== -1) return 'gold';
    return 'silber';
  }

  function getActiveGravurConfig() {
    return window.lw100GravurConfig || window.lw043GravurConfig || window.lwGravurConfig || null;
  }

  function ensureMk006GravurConfig() {
    if (getActiveGravurConfig() || typeof window.lwGravurResolveOption2 !== 'function') {
      return;
    }
    var config = window.lwGravurResolveOption2($('[name="option2"]').attr('data-value') || '');
    if (!config) return;
    window.lwGravurConfig = config;
    if (isEngravingOnlyPopup) {
      window.lw100GravurConfig = config;
    } else {
      window.lw043GravurConfig = config;
    }
  }

  /* true = nur EINE physische Seite wird graviert (Optionswert "einseitig").
     Dann zeigt die Buehne das einzel-Bild (eine Kette). Bei "beidseitig"
     kommt das paar-Bild (zwei Ketten) auf EINE Buehne, mit zwei Textebenen. */
  function usesEinzelPreviewBase() {
    ensureMk006GravurConfig();
    var sides = getActiveGravurConfig() && getActiveGravurConfig().physicalSides;
    return Array.isArray(sides) && sides.length === 1 && sides[0] === 0;
  }

  function getColorPreviewUrl() {
    var colorKey = getColorKeyFromOption1();
    if (usesEinzelPreviewBase()) {
      return MK006_PREVIEW_IMAGES[colorKey + 'Einzel']
        || MK006_PREVIEW_IMAGES[colorKey]
        || MK006_PREVIEW_IMAGES.silberEinzel
        || MK006_PREVIEW_IMAGES.silber;
    }
    return MK006_PREVIEW_IMAGES[colorKey] || MK006_PREVIEW_IMAGES.silber;
  }

  function getSideLayout(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    return $side.attr('data-mk006-layout') || sideLayouts[sideIndex] || '1_zeile';
  }

  function getLineSymbol(sideIndex, lineNum) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    return normalizeStoredSymbol($side.attr('data-mk006-symbol-line' + lineNum) || '');
  }

  function setLineSymbol(sideIndex, lineNum, sym) {
    $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex)
      .attr('data-mk006-symbol-line' + lineNum, normalizeStoredSymbol(sym || ''));
  }

  /* ---- Koordinaten und roemische Zahlen: JE STIL EIN EIGENER SPEICHER -----
     Bewusst eigene data-Attribute statt Mitbenutzung der Zeilen-/Motivfelder.
     Der Motivspeicher der 2. Zeile hat bei MK006 schon zwei Besitzer
     („2 Zeilen" und „Text oben, Motiv unten") und hat genau daraus am
     2026-09-03 einen Fehler erzeugt: ein Motiv blieb nach dem Kartenwechsel
     stehen. Diese zwei Stile teilen mit niemandem.

     Zweiter Zweck: das Attribut haengt an .product_info_main_N, nicht am
     Panel. setSideLayout wirft .mk006-dynamic weg und baut es neu — die
     Eingabe waere sonst nach jedem Kartenwechsel verschwunden. */
  function mk006SideAttr(sideIndex, name, wert) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (wert === undefined) return $side.attr(name) || '';
    $side.attr(name, wert || '');
    return wert || '';
  }
  function mk006KoordGms(sideIndex)  { return mk006SideAttr(sideIndex, 'data-mk006-koord-gms'); }
  function mk006KoordOrt(sideIndex)  { return mk006SideAttr(sideIndex, 'data-mk006-koord-ort'); }
  function mk006SetKoord(sideIndex, gms, ort) {
    mk006SideAttr(sideIndex, 'data-mk006-koord-gms', gms || '');
    mk006SideAttr(sideIndex, 'data-mk006-koord-ort', ort || '');
  }
  function mk006RomanDatum(sideIndex) { return mk006SideAttr(sideIndex, 'data-mk006-roman-datum'); }
  function mk006SetRomanDatum(sideIndex, wert) {
    mk006SideAttr(sideIndex, 'data-mk006-roman-datum', wert || '');
  }

  /* Umrechnung roemisch — Rechnung wortgleich aus K532 (dort wiederum aus
     HK004). Bereich 1–3999, alles darueber oder darunter faellt weg und wird
     der Kundin als Grund gemeldet statt stumm zu verschwinden. */
  function mk006ToRoman(num) {
    num = parseInt(num, 10);
    if (!num || num < 1 || num > 3999) return '';
    var map = [[1000,'M'],[900,'CM'],[500,'D'],[400,'CD'],[100,'C'],[90,'XC'],
               [50,'L'],[40,'XL'],[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']];
    var out = '';
    for (var i = 0; i < map.length; i++) {
      while (num >= map[i][0]) { out += map[i][1]; num -= map[i][0]; }
    }
    return out;
  }
  /* Trennzeichen ohne Leerraum („I·I·MMXXVI"), anders als K532 mit „ · ".
     MK006 ist eine RUNDE Scheibe: 28.12.2024 ergibt schon ohne Leerzeichen
     17 Zeichen, mit Leerzeichen 21 — die Breitenkappe drueckt das sonst
     unnoetig weit herunter. */
  var MK006_ROMAN_TRENNER = '\u00b7';
  function mk006RomanDatumErgebnis(raw) {
    raw = String(raw || '').trim();
    var teile = raw ? raw.split(/[.\-\/\s]+/) : [];
    var out = [], anyBad = false, anyGood = false;
    for (var i = 0; i < teile.length; i++) {
      if (!teile[i]) continue;
      var r = mk006ToRoman(teile[i]);
      if (r) { out.push(r); anyGood = true; } else { anyBad = true; }
    }
    return { text: out.join(MK006_ROMAN_TRENNER), anyBad: anyBad, anyGood: anyGood };
  }
  function mk006FormatRomanDatum(raw) { return mk006RomanDatumErgebnis(raw).text; }

  /* ---- Geokodierung: derselbe Schluessel wie HK004 / K532 / R002 ----------
     KEIN neuer Schluessel. Er ist an die Shop-Domain gebunden; offline und in
     jedem Pruefstand antwortet Google mit RefererNotAllowedMapError — die
     Suche ist dort also grundsaetzlich nicht pruefbar, nur der Weg danach. */
  var MK006_GEOCODE_API_KEY = 'AIzaSyAghNIu6qTkOQQxFf8oMQQgg9E_QsHzSeU';
  var MK006_GEOCODE_ENDPOINT = 'https://maps.googleapis.com/maps/api/js';
  function mk006LoadGoogleMapsApi(onReady, onFail) {
    if (window.google && window.google.maps && window.google.maps.Geocoder) { onReady(); return; }
    var q = (window.__vivGmapsCallbacks = window.__vivGmapsCallbacks || []);
    q.push({ ok: onReady, fail: onFail });
    if (window.__vivGmapsLoading) return;
    window.__vivGmapsLoading = true;
    window.__vivGmapsReady = function() {
      var cb;
      while ((cb = q.shift())) { try { cb.ok(); } catch (e) {} }
    };
    var el = document.createElement('script');
    el.src = MK006_GEOCODE_ENDPOINT + '?key=' + encodeURIComponent(MK006_GEOCODE_API_KEY) +
      '&v=weekly&language=de&region=DE&loading=async&callback=__vivGmapsReady';
    el.async = true;
    el.onerror = function() {
      window.__vivGmapsLoading = false;
      var cb;
      while ((cb = q.shift())) { try { cb.fail(); } catch (e) {} }
    };
    document.head.appendChild(el);
  }
  function mk006GeocodeAddress(address, onOk, onErr) {
    if (!MK006_GEOCODE_API_KEY) { onErr('no-key'); return; }
    mk006LoadGoogleMapsApi(function() {
      try {
        new window.google.maps.Geocoder().geocode({ address: address, region: 'DE' }, function(res, status) {
          if (status === 'OK' && res && res.length) {
            var loc = res[0].geometry.location;
            onOk(loc.lat(), loc.lng(), res[0].formatted_address || '');
          } else if (status === 'ZERO_RESULTS') { onErr('not-found'); }
          else { onErr('network'); }
        });
      } catch (e) { onErr('network'); }
    }, function() { onErr('network'); });
  }
  /* Kompaktformat von R002: Grad und Minuten, keine Sekunden. Auf der runden
     Scheibe stehen die beiden Haelften UNTEREINANDER (zwei Zeilen à 7
     Zeichen) statt nebeneinander (17 Zeichen) — nebeneinander muesste die
     Breitenkappe sie auf ein Drittel herunterdruecken. */
  function mk006KoordTeil(v, istLat) {
    var h = istLat ? (v >= 0 ? 'N' : 'S') : (v >= 0 ? 'E' : 'W');
    var a = Math.abs(v), g = Math.floor(a), m = Math.round((a - g) * 60);
    if (m === 60) { g += 1; m = 0; }
    return g + '\u00b0' + (m < 10 ? '0' : '') + m + "'" + h;
  }
  function mk006KoordGmsAus(lat, lon) {
    return mk006KoordTeil(lat, true) + '|' + mk006KoordTeil(lon, false);
  }
  /* Eine Zeile fuer Menschen (Bestellung, Bestaetigung): „53\u00b033'N 10\u00b000'E". */
  function mk006KoordEinzeilig(gms) {
    return String(gms || '').split('|').filter(Boolean).join(' ');
  }

  function getLineInputVal(sideIndex, lineNum) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.mk006-line-input[data-line="' + lineNum + '"]');
    return $input.length ? ($input.val() || '') : '';
  }

  function getLineParts(sideIndex, lineNum) {
    var raw = getLineInputVal(sideIndex, lineNum);
    if (isUppercaseOnlyFont()) {
      raw = normalizeG08RawLine(raw);
      var storedSym = getLineSymbol(sideIndex, lineNum);
      if (storedSym && !/\([^)]+\)/.test(raw)) raw = composeLine(raw, storedSym);
      return { text: raw, symbol: '' };
    }
    var parsed = parseLineValue(raw);
    var symbol = parsed.symbol || getLineSymbol(sideIndex, lineNum);
    return { text: parsed.text, symbol: symbol };
  }

  function toggleLineClear($input, value) {
    var hasContent = !!(value && String(value).trim());
    $input.siblings('.mk006-line-clear').css('display', hasContent ? 'block' : 'none');
  }

  function syncLineInputComposed($input, text, symbol) {
    var composed = composeLine(text, symbol);
    $input.val(composed);
    toggleLineClear($input, composed);
    return composed;
  }

  function getSideData(sideIndex) {
    var layout = getSideLayout(sideIndex);
    var data = { layout: layout, line1: '', line2: '', sym1: '', sym2: '', symOnly: '',
                 koordOrt: '', romanDatum: '' };

    if (layout === '1_zeile') {
      var p1 = getLineParts(sideIndex, 1);
      data.line1 = p1.text;
      data.sym1 = p1.symbol;
    } else if (layout === '2_zeilen') {
      var p1b = getLineParts(sideIndex, 1);
      var p2 = getLineParts(sideIndex, 2);
      data.line1 = p1b.text;
      data.line2 = p2.text;
      data.sym1 = p1b.symbol;
      data.sym2 = p2.symbol;
    } else if (layout === 'nur_motiv') {
      var pMotiv = getLineParts(sideIndex, 1);
      data.symOnly = pMotiv.symbol || getLineSymbol(sideIndex, 1);
    } else if (layout === MK006_TM_LAYOUT) {
      // Text steht im Feld der 1. Zeile, das Motiv im Symbolspeicher der 2.
      data.line1 = getLineParts(sideIndex, 1).text;
      data.sym2 = getLineSymbol(sideIndex, 2);
    } else if (layout === MK006_KOORD_LAYOUT) {
      /* Der gefundene Ort wird NICHT graviert, er faehrt nur als eigene
         Bestellzeile mit — die Werkstatt soll sehen, wonach gesucht wurde. */
      var teile = mk006KoordGms(sideIndex).split('|');
      data.line1 = teile[0] || '';
      data.line2 = teile[1] || '';
      data.koordOrt = mk006KoordOrt(sideIndex);
    } else if (layout === MK006_ROMAN_LAYOUT) {
      data.romanDatum = mk006RomanDatum(sideIndex);
      data.line1 = mk006FormatRomanDatum(data.romanDatum);
    }
    return data;
  }

  function sideHasContent(sideIndex) {
    var d = getSideData(sideIndex);
    if (d.layout === 'nur_motiv') return !!d.symOnly;
    if (d.layout === MK006_KOORD_LAYOUT) return !!(d.line1 || d.line2);
    if (d.layout === MK006_ROMAN_LAYOUT) return !!d.line1;
    if (d.layout === MK006_TM_LAYOUT) return !!(d.line1 || d.sym2);
    if (d.layout === '2_zeilen') {
      return !!(composeLine(d.line1, d.sym1) || composeLine(d.line2, d.sym2));
    }
    return !!composeLine(d.line1, d.sym1);
  }

  /* Steuert NUR, ob die Bestellung eine „Font"-Zeile bekommt. Die zwei neuen
     Stile gravieren zwar Zeichen, aber in FESTER Schrift — eine Font-Zeile
     waere dort eine Falschaussage ueber die vom Kunden gewaehlte Schrift. */
  function sideHasText(d) {
    if (d.layout === 'nur_motiv') return false;
    if (mk006IstFesteSchriftStil(d.layout)) return false;
    if (d.layout === '2_zeilen') return !!(d.line1 || d.line2);
    return !!d.line1;
  }

  function getPreviewMode(d) {
    if (d.layout === 'nur_motiv') return 'nur_motiv';
    /* Eigener Modus statt Mitbenutzung von '2_zeilen'/'1_zeile': daran haengen
       je-Schrift-Groessen und -Lagen, die diese Stile mit fester Schrift gar
       nicht haben duerfen. Gleicher Name wie der Vorlagenschluessel. */
    if (d.layout === MK006_KOORD_LAYOUT) return MK006_KOORD_LAYOUT;
    if (d.layout === MK006_ROMAN_LAYOUT) return MK006_ROMAN_LAYOUT;
    if (d.layout === MK006_TM_LAYOUT) return 'text_motiv';
    if (d.layout === '2_zeilen') return '2_zeilen';
    return '1_zeile';
  }

  function getLw100SinglePos() {
    if (isAs022Personalization) return AS022_PLAETTCHEN_POS.front;
    return { top: 45, left: 25 };
  }

  function getLw100DualPos(sideIndex) {
    if (isAs022Personalization) {
      var as022Pos = sideIndex === 1 ? AS022_PLAETTCHEN_POS.back : AS022_PLAETTCHEN_POS.front;
      return { top: as022Pos.top, left: as022Pos.left };
    }
    var pos = sideIndex === 1 ? LW100_DUAL_1_ZEILE.back : LW100_DUAL_1_ZEILE.front;
    return { top: pos.top, left: pos.left };
  }

  function getAs0222ZeilenLine1Pos(sideIndex) {
    if (usesEinzelPreviewBase()) return AS022_PLAETTCHEN_POS.front;
    return sideIndex === 1 ? AS022_PLAETTCHEN_POS.back : AS022_PLAETTCHEN_POS.front;
  }

  function getAs0222ZeilenLine2Pos(sideIndex) {
    var pos = sideIndex === 1 ? AS022_2ZEILEN_LINE2.back : AS022_2ZEILEN_LINE2.front;
    return { top: pos.top, left: pos.left };
  }

  function getPreviewPos(sideIndex, previewMode, lineNum) {
    if (isPlaettchenPreviewPersonalization) {
      if (mk006IstZweizeiligeLage(previewMode) && lineNum === 2) {
        if (isAs022Personalization) {
          return getAs0222ZeilenLine2Pos(sideIndex);
        }
        if (usesEinzelPreviewBase()) {
          return { top: 50, left: 25 };
        }
        var dualLine2Pos = getLw100DualPos(sideIndex);
        return { top: 50, left: dualLine2Pos.left };
      }
      if (previewMode === 'nur_motiv') {
        if (usesEinzelPreviewBase()) {
          if (isAs022Personalization) return AS022_NUR_MOTIV.front;
          return PREVIEW_NUR_MOTIV.front;
        }
        if (isAs022Personalization) {
          var as022Nm = sideIndex === 1 ? AS022_NUR_MOTIV.back : AS022_NUR_MOTIV.front;
          return { top: as022Nm.top, left: as022Nm.left };
        }
        var nm = sideIndex === 1 ? PREVIEW_NUR_MOTIV.back : PREVIEW_NUR_MOTIV.front;
        return { top: nm.top, left: nm.left };
      }
      if (usesEinzelPreviewBase()) {
        return getLw100SinglePos();
      }
      return getLw100DualPos(sideIndex);
    }
    if (previewMode === 'nur_motiv') {
      if (isAs022Personalization) {
        var as022Npos = sideIndex === 1 ? AS022_NUR_MOTIV.back : AS022_NUR_MOTIV.front;
        return { top: as022Npos.top, left: as022Npos.left };
      }
      var npos = sideIndex === 1 ? PREVIEW_NUR_MOTIV.back : PREVIEW_NUR_MOTIV.front;
      return { top: npos.top, left: npos.left };
    }
    if (mk006IstZweizeiligeLage(previewMode)) {
      var lcfg = lineNum === 2 ? PREVIEW_2_ZEILEN.line2 : PREVIEW_2_ZEILEN.line1;
      var lpos = sideIndex === 1 ? lcfg.back : lcfg.front;
      return { top: lpos.top, left: lpos.left };
    }
    var pos = sideIndex === 1 ? PREVIEW_1_ZEILE.back : PREVIEW_1_ZEILE.front;
    return { top: pos.top, left: pos.left };
  }


  /* Reglerfenster ?mk006tuner=1 — siehe docs/TUNER-VOLLAUSBAU.md.
     Alles neutral (0 bzw. 1): der Einbau veraendert kein bestehendes
     Vorschaubild. Position laeuft durch buildPreviewStyle(), Groesse
     ueber CSS-Faktoren an der Buehne — beides genau eine Stelle, der
     Gesamt-Layer kann also keinen Renderpunkt verfehlen.
     zeile2 ist eigenstaendig: die zweite Gravurzeile sitzt sonst starr
     an der ersten und liesse sich nie fuer sich ausrichten.

     ⚠️ IN DIESES LITERAL GEHOEREN KEINE KOMMENTARE. scripts/mk006/bake.py
     schreibt das ganze Literal aus dem Tuner-Export neu (js_dump baut es aus
     den geparsten Werten auf) — alles, was drin steht und kein Wert ist,
     verschwindet beim ersten Backen lautlos. Begruendungen also hier oben.

     limitBreite 12 = Yins LW065-Kalibrierung (13.5 bei 19.44 % Scheibe
       = 69.5 % des Durchmessers), uebertragen auf MK006s 17.25 %.
     limitBreiteZeile2 0.97 = Sehne 2.11 pp unter der Mitte / Sehne Mitte,
       fuer MK006 gerechnet (LW065 hatte 0.99 bei nur 1.5 pp Tiefe).
     Herleitung beider Zahlen steht bei PREVIEW_TEXT_MAX_WIDTH_1600.

     stein = Feinlage des Geburtssteins, ABSICHTLICH als Delta auf
     PREVIEW_GEM statt als Absolutwert: die Fassung ist am Bild gemessen und
     soll als Messwert erkennbar bleiben.
     ⚠️ HIER BEWUSST AUF NULL. In der Klonquelle stand
     { dx: 0.6, dy: 0.4, scale: 1.42, rot: -35 } — Yins Kalibrierung fuer
     LW065s HERZ-Fassung, die perspektivisch schraeg haengt. MK006 hat eine
     runde, gerade sitzende Fassung; die -35 Grad waeren schlicht falsch und
     der Faktor 1.42 haette den Stein ueber die Fassung hinaus gedehnt.
     PREVIEW_GEM ist fuer MK006 direkt an der Innenflaeche gemessen, das
     Delta startet deshalb neutral.

     schrift: dx/dy stehen auf NULL, scale ist uebernommen. Begruendung der
     Trennung — dx/dy sind Verschiebungen gegen die ANKER, und die Anker sind
     bei MK006 andere (25.34/74.59 statt 24.08/76.19); ein uebernommener
     Versatz waere kein Vorsprung, sondern ein stiller Fehler, den Yin
     spaeter fuer ihren eigenen halten wuerde. scale dagegen korrigiert die
     Schriftarten GEGENEINANDER (G04 laeuft von Haus aus groesser als G02) —
     das haengt an den Schriftdateien, nicht an der Scheibe, und gilt weiter.
     Dieselbe Trennung gilt fuer MK006_KOMBI_BY_FONT und
     MK006_TM_TEXT_NUDGE_BY_FONT weiter unten.
     MK006_ICON_ADJ bleibt dagegen vollstaendig erhalten: die Werte dort
     gleichen die unterschiedlich grossen Leerraender der W-Reihen-PNGs aus
     (GOTCHAS Nr. 14) — eine Eigenschaft der Bilddateien, nicht der Scheibe. */
  var MK006_TUNE = {
    blockDx: 0,
    blockDy: -1,
    blockScale: 0.7,
    motivScale: 1,
    limitBreite: 14,
    limitBreiteZeile2: 0.88,
    zeile2: { dx: 0, dy: 0 },
    stein: { dx: 0.3, dy: -0.2, scale: 0.94, rot: 0 },
    schrift: {
      G02: { dx: 0, dy: 0, scale: 1 },
      G04: { dx: 0, dy: 0, scale: 0.88 },
      G05: { dx: 0, dy: 0, scale: 0.96 },
      G06: { dx: 0, dy: 0, scale: 0.86 }
    },
    motivDx: 0,
    motivDy: 0
  };

  var MK006_ICON_ADJ = {
    front: {
      text_motiv: {
        herz: { scale: 0.9 },
        infinity: { scale: 1.25 },
        doppelherz: { scale: 0.85 },
        pfote: { scale: 0.85 }
      },
      nur_motiv: {
        herz: { scale: 0.9, dy: 0.16, dx: 0.06 },
        'mini-herz': { scale: 0.95, dy: 0.22 },
        doppelherz: { dy: 0.12 },
        love: { scale: 1.55, dy: 0 },
        infinity: { scale: 1.15, dy: 0.22, dx: 0.06 },
        jesusfisch: { scale: 1.05, dy: 0.26 },
        kreuz: { dy: 0.28 },
        engelflgel: { scale: 1.3, dy: 0.24 },
        engel: { dy: 0.28 },
        'bester-papa': { scale: 1.25, dy: 0.18 },
        lieblingsmensch: { scale: 1.25, dy: 0.26 },
        'kleiner-finger-schwur': { scale: 1.5, dy: 0.12 },
        hndchenhalten: { scale: 1.4, dy: 0.32 },
        'hand-herz': { scale: 1.45, dy: 0.18 },
        faustgru: { scale: 2, dy: 0.22 },
        babyfe: { scale: 1.3, dy: 0.26 },
        herzschlag: { scale: 1.5, dy: 0.06 },
        blumenstrau: { scale: 1.65, dy: 0.38 },
        pusteblume: { scale: 1.8, dy: 0.22 },
        friedenstaube: { scale: 1.3, dy: 0.2, dx: -0.04 },
        baum: { scale: 1.3, dy: 0.28 },
        lebensbaum: { scale: 1.1, dy: 0.18 },
        berg: { scale: 1.55, dy: 0.18 },
        welle: { scale: 1.55, dy: 0.08 },
        anker: { dy: 0.22 },
        kompassrose: { scale: 1.3, dy: 0.32 },
        hufeisen: { scale: 1, dy: 0.26, dx: 0.08 },
        kleeblatt: { dy: 0.2, dx: 0.06 },
        pfote: { dy: 0.24 },
        hund: { dy: 0.2 },
        katze: { dy: 0.3 },
        pferd: { dy: 0.2, dx: 0.06, scale: 1.2 },
        biene: { dy: 0.22 },
        fee: { dy: 0.26, scale: 1.25, dx: 0.12 },
        einhorn: { dy: 0.14, scale: 1.35, dx: 0.12 },
        regenbogen: { dy: 0.08, scale: 1.3, dx: 0.08 },
        sonne: { dy: 0.18, dx: 0.06 },
        lotus: { dy: 0.18, dx: 0.08 },
        stern: { dy: 0.16, dx: 0.08 },
        mdchen: { dy: 0.26, scale: 1.45 },
        junge: { dy: 0.22, scale: 1.45 }
      }
    },
    back: {
      text_motiv: {
        herz: { scale: 0.9 },
        infinity: { scale: 1.25 },
        doppelherz: { scale: 0.85 },
        pfote: { scale: 0.85 }
      },
      nur_motiv: {
        herz: { scale: 0.9, dy: 0.16, dx: 0.06 },
        'mini-herz': { scale: 0.95, dy: 0.22 },
        doppelherz: { dy: 0.12 },
        love: { scale: 1.55, dy: 0 },
        infinity: { scale: 1.15, dy: 0.22, dx: 0.06 },
        jesusfisch: { scale: 1.05, dy: 0.26 },
        kreuz: { dy: 0.28 },
        engelflgel: { scale: 1.3, dy: 0.24 },
        engel: { dy: 0.28 },
        'bester-papa': { scale: 1.25, dy: 0.18 },
        lieblingsmensch: { scale: 1.25, dy: 0.26 },
        'kleiner-finger-schwur': { scale: 1.5, dy: 0.12 },
        hndchenhalten: { scale: 1.4, dy: 0.32 },
        'hand-herz': { scale: 1.45, dy: 0.18 },
        faustgru: { scale: 2, dy: 0.22 },
        babyfe: { scale: 1.3, dy: 0.26 },
        herzschlag: { scale: 1.5, dy: 0.06 },
        blumenstrau: { scale: 1.65, dy: 0.38 },
        pusteblume: { scale: 1.8, dy: 0.22 },
        friedenstaube: { scale: 1.3, dy: 0.2, dx: -0.04 },
        baum: { scale: 1.3, dy: 0.28 },
        lebensbaum: { scale: 1.1, dy: 0.18 },
        berg: { scale: 1.55, dy: 0.18 },
        welle: { scale: 1.55, dy: 0.08 },
        anker: { dy: 0.22 },
        kompassrose: { scale: 1.3, dy: 0.32 },
        hufeisen: { scale: 1, dy: 0.26, dx: 0.08 },
        kleeblatt: { dy: 0.2, dx: 0.06 },
        pfote: { dy: 0.24 },
        hund: { dy: 0.2 },
        katze: { dy: 0.3 },
        pferd: { dy: 0.2, dx: 0.06, scale: 1.2 },
        biene: { dy: 0.22 },
        fee: { dy: 0.26, scale: 1.25, dx: 0.12 },
        einhorn: { dy: 0.14, scale: 1.35, dx: 0.12 },
        regenbogen: { dy: 0.08, scale: 1.3, dx: 0.08 },
        sonne: { dy: 0.18, dx: 0.06 },
        lotus: { dy: 0.18, dx: 0.08 },
        stern: { dy: 0.16, dx: 0.08 },
        mdchen: { dy: 0.26, scale: 1.45 },
        junge: { dy: 0.22, scale: 1.45 }
      }
    }
  };   /* D1: [seite][modus][slug] = { dx, dy, scale }. `back` ist am
          2026-09-03 Zeichen fuer Zeichen aus `front` kopiert worden.

          ⚠️ BEFUND FUER YIN, gemessen, nicht heimlich: das ist die EINZIGE
          Stelle dieses Umbaus, die das Bild veraendert. Vorher stand hier nur
          `front`; die zweite Kette bekam also GAR KEINE Motivkorrektur —
          mk006IconAdj('back', …) lief ins Leere. Die Werte gleichen die
          unterschiedlich grossen Leerraender der W-Reihen-PNGs aus (GOTCHAS
          Nr. 14), und beide Ketten zeigen dieselben PNGs auf gleich grossen,
          gleich hoch sitzenden Scheiben (PREVIEW_NUR_MOTIV: top 67.25 vorne,
          67.24 hinten). Die Rueckseite war damit schlicht unkorrigiert.
          Gemessen im Pruefstand, Vorlage „Nur Motiv", Kette 2: alle 41 Motive
          ruecken, im Mittel wenige Pixel, am staerksten „Faustgruss" um
          15,9 px (Skalierung 2,0). Vorne aendert sich nichts.
          Soll die Rueckseite doch bei null anfangen, genuegt `back: {}`. */

  /* ★ EIN Schluessel fuer die Motivzellen (2026-09-03, Branchen-Pruefung).
     Die Auswahlkarte heisst 'text_oben_motiv_unten', der Renderpfad uebersetzt
     sie in getPreviewMode() zu 'text_motiv'. Bis heute bildete JEDE Seite den
     Schluessel selbst: buildEngravingHtml() las ICON_ADJ[seite]['text_motiv'],
     mk006IconRegler() schrieb nach ICON_ADJ[seite]['text_oben_motiv_unten'].
     Anderer Schluessel, nie gelesen — Motiv-Groesse, Motiv-X und Motiv-Y waren
     in „Text oben, Motiv unten" fuer alle vier Schriften und alle 41 Motive
     tot. Ab jetzt fuehren Renderer UND Regler ueber mk006IconAdj /
     mk006IconAdjSetzen; ein kuenftiger dritter Aufrufer kann den Schluessel
     gar nicht mehr selbst bilden und damit auch nicht danebengreifen. */
  /* ★ SEITEN-EBENE (Yin 2026-09-03: „mk006 背面所有的调整 x y 根据选项都要单独生成").

     „Beidseitig" heisst bei MK006 ZWEI KETTEN nebeneinander — links die
     Vorderseite (sideIndex 0), rechts die Rueckseite (sideIndex 1). Beide
     werden graviert, beide duerfen einen anderen Stil tragen. Bis heute hatte
     nur MK006_ICON_ADJ eine Seiten-Ebene (und auch dort war nur `front`
     gefuellt); JEDE Text-Lagetabelle war seitenlos. Die zweite Kette benutzte
     also zwangslaeufig die Werte der ersten: wer rechts ausrichtete, verschob
     links mit. Vorbild fuer den Umbau ist R008 (TEXT_ADJ[side][layout][font]).

     ⚠️ Kein Rueckfall auf 'front'. Ein Vorgabewert waere genau die Kopplung,
     die dieser Umbau aufloest — die Rueckseite laese dann wieder still die
     Werte der Vorderseite, und niemand saehe es. Fehlt der Zweig, ist die
     Lage NEUTRAL; das faellt in der Branchen-Pruefung als toter Regler auf,
     statt sich als „sieht doch gleich aus" zu tarnen. */
  function mk006SeiteKey(sideIndex) {
    return sideIndex === 1 ? 'back' : 'front';
  }
  function mk006SeitenTeil(tab, seite) {
    return tab[seite] || {};
  }
  function mk006SeitenTeilSetzen(tab, seite) {
    if (!seite) return {};          /* Wegwerf-Objekt, siehe Notiz oben */
    if (!tab[seite]) tab[seite] = {};
    return tab[seite];
  }

  function mk006IconModus(modus) {
    return modus === MK006_TM_LAYOUT ? 'text_motiv' : modus;
  }
  function mk006IconAdj(seite, modus, slug) {
    return (mk006SeitenTeil(MK006_ICON_ADJ, seite)[mk006IconModus(modus)] || {})[slug] || {};
  }
  function mk006IconAdjSetzen(seite, modus, slug) {
    if (!seite) return {};          /* lieber Wegwerf-Objekt als fremde Seite */
    var o = mk006Pfad(MK006_ICON_ADJ, seite, mk006IconModus(modus));
    if (!o[slug]) o[slug] = {};
    return o[slug];
  }
  var MK006_LUFT_ADJ = {
    G04: { stern: 0 }
  };   /* D3: [fontCode][slug] = em auf den Basisabstand */

  /* Regel 7 (KE030-Vorbild 2026-08-18): „Text oben, Motiv unten" sass fest
     auf den 2-Zeilen-Ankern — verrutschte das Motiv an einer Schrift, ging es
     nur im Code. Jetzt: Motiv-Lage/-Groesse und Abstand JE SCHRIFTART.
     Einheiten: motivDx/motivDy und gap in % der Buehne (derselbe Renderpfad
     wie die Anker), motivMult auf die Motivgroesse. Tabelle faengt LEER an
     und waechst beim Kalibrieren (bake schreibt das ganze Literal). */
  /* NEUTRAL gestartet — siehe Begruendung bei MK006_TUNE.schrift. Die Werte
     der Klonquelle (G02 motivDy 0.5 / motivMult 0.94 / gap 0.7 usw.) waren am
     Engel kalibriert und sind auf der runden Scheibe gegenstandslos. */
  /* ★ Aus LW065 UMGERECHNET, nicht kopiert: die Einheit ist % der Buehne
     (siehe Notiz oben), MK006s Scheibe ist aber nur 0.8873 mal so gross.
     Unveraendert uebernommen waere der Abstand Text->Motiv relativ zur
     Scheibe 13 % zu gross. motivMult bleibt 1 (Faktor, keine Laenge). */
  /* ★ Seiten-Ebene 2026-09-03: [seite][layout][font]. `back` ist eine
     wortgleiche Kopie von `front` — NEUTRAL beim Umbau, getrennt ab dem
     ersten Dreh. */
  var MK006_KOMBI_BY_FONT = {
    front: {
      text_oben_motiv_unten: {
        G02: { motivDx: 0.67, motivDy: 0, motivMult: 0.92, gap: -0.1 },
        G04: { motivDx: 0.75, motivDy: 1.25, motivMult: 1.02, gap: -0.6 },
        G05: { motivDx: 0.67, motivDy: 0, motivMult: 1, gap: 1.2 },
        G06: { motivDx: 0.67, motivDy: -0.75, motivMult: 1, gap: 1.3 }
      }
    },
    back: {
      text_oben_motiv_unten: {
        G02: { motivDx: 0.67, motivDy: 0, motivMult: 0.92, gap: -0.1 },
        G04: { motivDx: 0.75, motivDy: 1.25, motivMult: 1.02, gap: -0.6 },
        G05: { motivDx: 0.67, motivDy: 0, motivMult: 1, gap: 1.2 },
        G06: { motivDx: 0.67, motivDy: -0.75, motivMult: 1, gap: 1.3 }
      }
    }
  };
  var MK006_KOMBI_NEUTRAL = { motivDx: 0, motivDy: 0, motivMult: 1, gap: 0 };

  /* D3 fuer „Text oben, Motiv unten": Abstand zwischen Text und Motiv je
     Schrift UND je Motiv. KOMBI_BY_FONT[...].gap kann nur je Schrift — ein
     breites Motiv braucht neben derselben Schrift aber mehr Luft als ein
     schmales. Der Name ist der ladenweite (<P>_TM_ABSTAND_BY_FONT_ICON,
     Vorbild K530); scripts/tuner_audit.py sucht genau danach.
     Wirkt ADDITIV auf den Schrift-Gap, faengt leer an, waechst beim
     Kalibrieren. */
  var MK006_TM_ABSTAND_BY_FONT_ICON = {
    G04: { stern: -2.2 }
  };

  function mk006TmAbstand(font, slug) {
    return ((MK006_TM_ABSTAND_BY_FONT_ICON[font] || {})[slug]) || 0;
  }
  function mk006TmAbstandRegler(font, slug) {
    return { get: function () { return mk006TmAbstand(font, slug); },
             set: function (v) {
               if (!MK006_TM_ABSTAND_BY_FONT_ICON[font]) MK006_TM_ABSTAND_BY_FONT_ICON[font] = {};
               MK006_TM_ABSTAND_BY_FONT_ICON[font][slug] = v;
             } };
  }

  /* Shopweiter Name derselben Sache (Welle 4, 2026-08-19): die Familie K2
     „Motiv in TEXT OBEN/MOTIV UNTEN einzeln verschiebbar" heisst im ganzen
     Laden <P>_TM_ICON_NUDGE_BY_FONT. Hier liegen diese Werte seit dem
     Regel-7-Umbau in KOMBI_BY_FONT[text_oben_motiv_unten] — dieselbe Tabelle,
     nur mit Abstand und Groesse in denselben Zellen. Der Verweis macht den
     Namen auffindbar (tuner_audit) OHNE die Kalibrierung umzuziehen; es ist
     kein Duplikat, sondern dasselbe Objekt. */
  var MK006_TM_ICON_NUDGE_BY_FONT = {
    front: MK006_KOMBI_BY_FONT.front[MK006_TM_LAYOUT],
    back: MK006_KOMBI_BY_FONT.back[MK006_TM_LAYOUT]
  };

  function mk006Kombi(seite, layoutKey, fontName) {
    var tabelle = mk006SeitenTeil(MK006_KOMBI_BY_FONT, seite)[layoutKey];
    if (!tabelle) return MK006_KOMBI_NEUTRAL;
    return tabelle[fontName] || MK006_KOMBI_NEUTRAL;
  }
  function mk006KombiSetzen(seite, layoutKey, fontName) {
    var s = mk006SeitenTeilSetzen(MK006_KOMBI_BY_FONT, seite);
    var tabelle = s[layoutKey];
    if (!tabelle) return MK006_KOMBI_NEUTRAL;   // Layout ohne Kombi-Regler
    if (!tabelle[fontName]) tabelle[fontName] = { motivDx: 0, motivDy: 0, motivMult: 1, gap: 0 };
    return tabelle[fontName];
  }

  /* „2 Zeilen": Schriftgroesse je ZEILE und je SCHRIFTART (Yin 2026-08-19:
     „两行的时候，上下的字体大小要分别调整，尤其是 G06 字体"). Bis dahin
     bekamen beide Zeilen dieselbe Groesse aus derselben CSS-Variablen — bei
     G06 (Murray Hill, die groesste Schrift) wirkt die Datumszeile dadurch zu
     schwer neben dem Namen. Die Werte sind MULTIPLIKATOREN auf die jeweilige
     Schriftgroesse, 1 = unveraendert. Sie gehen als --mk006-zeile-scale ans
     Element, damit alle vier Groessenregeln (Standard + g04/g05/g06)
     mitrechnen und der Block-Faktor eine Ebene darueber bleibt. */
  var MK006_ZEILEN_GROESSE_BY_FONT = {
    G06: { zeile1: 0.92, zeile2: 0.78 },
    G02: { zeile1: 1, zeile2: 0.9 },
    G04: { zeile1: 1, zeile2: 0.88 },
    G05: { zeile1: 1, zeile2: 0.9 }
  };

  function mk006ZeilenGroesse(fontName) {
    return MK006_ZEILEN_GROESSE_BY_FONT[fontName] || { zeile1: 1, zeile2: 1 };
  }
  function mk006ZeilenGroesseSetzen(fontName) {
    if (!MK006_ZEILEN_GROESSE_BY_FONT[fontName]) {
      MK006_ZEILEN_GROESSE_BY_FONT[fontName] = { zeile1: 1, zeile2: 1 };
    }
    return MK006_ZEILEN_GROESSE_BY_FONT[fontName];
  }

  /* ★ „2 Zeilen": Lage BEIDER Zeilen je Schriftart (Yin 2026-08-23:
     „如果在两行的情况下 第一行 第二行都要能左右移动 还要调整间距").

     Vorgeschichte: erst gab es nur MK006_TUNE.zeile2 (global, nur Zeile 2),
     dann MK006_ZEILE2_BY_FONT (je Schrift, nur Zeile 2). Zeile 1 liess sich
     in diesem Layout ueberhaupt nicht einzeln bewegen — sie hing am
     Gesamtblock und am Schrift-Nudge, und die traf immer BEIDE Zeilen.
     Zwei Zeilen buendig untereinander auszurichten war damit unmoeglich.

     Jetzt eine Tabelle mit allen fuenf Groessen je Schrift:
       z1dx / z1dy   Zeile 1 einzeln, in % der Buehne
       z2dx / z2dy   Zeile 2 einzeln, in % der Buehne
       abstand       Zeilenabstand: schiebt Zeile 1 um abstand/2 nach OBEN und
                     Zeile 2 um abstand/2 nach UNTEN. Ein Knopf statt zwei,
                     und die Mitte des Blocks bleibt liegen.

     MK006_ZEILE2_BY_FONT ist darin aufgegangen; die dort kalibrierten Werte
     stehen unveraendert als z2dy. Der alte Exportschluessel ZEILE2_BY_FONT
     wird von bake nicht mehr erkannt und als „unbekannt" gemeldet — ein
     alter Export ueberschreibt also nichts still. */
  /* ★ Seiten-Ebene 2026-09-03: [seite][font]. `back` wortgleich aus `front`. */
  var MK006_ZEILEN_LAGE_BY_FONT = {
    front: {
      G02: { z1dx: 0, z1dy: 0, z2dx: 0, z2dy: 1.75, abstand: 0.25 },
      G04: { z1dx: 0, z1dy: 0, z2dx: 0, z2dy: 1.25, abstand: 0.25 },
      G05: { z1dx: 0, z1dy: 0, z2dx: 0, z2dy: 1.25, abstand: 0.25 },
      G06: { z1dx: 0, z1dy: 0, z2dx: 0, z2dy: 1.25, abstand: 0.75 }
    },
    back: {
      G02: { z1dx: 0, z1dy: 0, z2dx: 0, z2dy: 1.75, abstand: 0.25 },
      G04: { z1dx: 0, z1dy: 0, z2dx: 0, z2dy: 1.25, abstand: 0.25 },
      G05: { z1dx: 0, z1dy: 0, z2dx: 0, z2dy: 1.25, abstand: 0.25 },
      G06: { z1dx: 0, z1dy: 0, z2dx: 0, z2dy: 1.25, abstand: 0.75 }
    }
  };
  var MK006_ZEILEN_LAGE_NEUTRAL = { z1dx: 0, z1dy: 0, z2dx: 0, z2dy: 0, abstand: 0 };

  /* ★ EIGENE Zeilenlage der zwei neuen Stile.
     BEFUND 2026-09-03, im Pruefstand gemessen: die Anker in PREVIEW_2_ZEILEN
     tragen allein nur 2,66 % Abstand — der kalibrierte Rest (z2dy 1,75 +
     abstand 0,25) steckt in der SCHRIFTZELLE MK006_ZEILEN_LAGE_BY_FONT. Die
     Koordinaten laufen aber in fester Schrift und lesen diese Zelle nicht;
     ohne eigenen Wert ueberlappten die beiden Zeilen um 5,3 px.

     Startwerte darum 1:1 aus der kalibrierten G02-Zelle uebernommen, nichts
     dazuerfunden. EIGENE Zelle statt Mitlesen: sonst verstellte ein Dreh an
     „2 Zeilen · G02" heimlich auch die Koordinaten — genau die Kopplung, an
     der sich MK006 schon zweimal verhoben hat. Beide Zellen haengen an
     eigenen Reglern (mk006TunerKontextExtra). */
  /* ★ Seiten-Ebene 2026-09-03: [seite] -> die flache Lage. `back` wortgleich
     aus `front` — beide Ketten koennen denselben Stil tragen und muessen
     trotzdem einzeln ausrichtbar sein. */
  var MK006_KOORD_LAGE = {
    front: { z1dx: 0, z1dy: -0.5, z2dx: 0, z2dy: 0.75, abstand: 0.25, groesse: 0.82 },
    back: { z1dx: 0, z1dy: -0.5, z2dx: 0, z2dy: 0.75, abstand: 0.25, groesse: 0.82 }
  };
  var MK006_ROMAN_LAGE = {
    front: { dx: 0, dy: 0 },
    back: { dx: 0, dy: 0 }
  };

  function mk006KoordLage(seite) {
    return mk006SeitenTeil(MK006_KOORD_LAGE, seite);
  }
  function mk006RomanLage(seite) {
    return mk006SeitenTeil(MK006_ROMAN_LAGE, seite);
  }
  function mk006FesteStilVersatz(seite, previewMode, lineNum) {
    if (previewMode === MK006_ROMAN_LAYOUT) {
      var R = mk006RomanLage(seite);
      return { dx: R.dx || 0, dy: R.dy || 0 };
    }
    if (previewMode !== MK006_KOORD_LAYOUT) return { dx: 0, dy: 0 };
    var L = mk006KoordLage(seite), halb = (L.abstand || 0) / 2;
    return (String(lineNum) === '2')
      ? { dx: (L.z2dx || 0), dy: (L.z2dy || 0) + halb }
      : { dx: (L.z1dx || 0), dy: (L.z1dy || 0) - halb };
  }

  function mk006ZeilenLage(seite, fontName) {
    return mk006SeitenTeil(MK006_ZEILEN_LAGE_BY_FONT, seite)[fontName] || MK006_ZEILEN_LAGE_NEUTRAL;
  }
  function mk006ZeilenLageSetzen(seite, fontName) {
    var s = mk006SeitenTeilSetzen(MK006_ZEILEN_LAGE_BY_FONT, seite);
    if (!s[fontName]) {
      s[fontName] = { z1dx: 0, z1dy: 0, z2dx: 0, z2dy: 0, abstand: 0 };
    }
    return s[fontName];
  }

  /* Versatz der einen Zeile im Layout „2 Zeilen". Ausserhalb dieses Layouts
     neutral — in „1 Zeile" gibt es keine zweite Zeile, und „Text oben, Motiv
     unten" hat mit KOMBI_BY_FONT seine eigene Mechanik. */
  function mk006ZeilenVersatz(seite, previewMode, lineNum) {
    /* Feste Schrift = keine je-Schrift-Lage. Ohne diese Zeile wanderte die
       Koordinate mit einer Schrift, die sie gar nicht benutzt. */
    if (mk006IstFesteSchriftStil(previewMode)) return { dx: 0, dy: 0 };
    if (!isZeilenLikeMode(previewMode)) return { dx: 0, dy: 0 };
    var L = mk006ZeilenLage(seite, getGlobalFont().font_name || 'G02');
    var halb = (L.abstand || 0) / 2;
    return (String(lineNum) === '2')
      ? { dx: (L.z2dx || 0), dy: (L.z2dy || 0) + halb }
      : { dx: (L.z1dx || 0), dy: (L.z1dy || 0) - halb };
  }

  /* K1 (KE030-Vorbild): im Kombi-Layout den TEXT allein verschieben, je
     Schriftart, in % der Buehne. Der Schrift-Regler (D2) traefe auch die
     1-Zeile/2-Zeilen-Marken — dieser hier NUR die TM-Textebene. Zelle wird
     erst beim ersten Drehen angelegt (Export bleibt frei von Schein-Nullen). */
  /* NEUTRAL gestartet — siehe Begruendung bei MK006_TUNE.schrift. */
  /* ★ Seiten-Ebene 2026-09-03: [seite][font]. `back` wortgleich aus `front`. */
  var MK006_TM_TEXT_NUDGE_BY_FONT = {
    front: {
      G02: { dx: 0, dy: 0.5 },
      G04: { dx: -0.75, dy: 1 },
      G05: { dx: -0.5, dy: 0.75 },
      G06: { dx: -0.25, dy: -0.75 }
    },
    back: {
      G02: { dx: 0, dy: 0.5 },
      G04: { dx: -0.75, dy: 1 },
      G05: { dx: -0.5, dy: 0.75 },
      G06: { dx: -0.25, dy: -0.75 }
    }
  };

  function mk006TmTextNudge(seite, fontName) {
    return mk006SeitenTeil(MK006_TM_TEXT_NUDGE_BY_FONT, seite)[fontName] || { dx: 0, dy: 0 };
  }
  function mk006TmTextNudgeSetzen(seite, fontName) {
    var s = mk006SeitenTeilSetzen(MK006_TM_TEXT_NUDGE_BY_FONT, seite);
    if (!s[fontName]) s[fontName] = { dx: 0, dy: 0 };
    return s[fontName];
  }

  /* Abstand Schrift×Motiv — je MODUS, je Schrift, je Motiv (D3).
     Bis 2026-08-23 fehlte die Modus-Ebene: ein Wert, der in „1 Zeile" passte,
     verstellte still auch „Text oben, Motiv unten", wo Text und Motiv ganz
     anders zueinander stehen. tuner_audit meldete das als fehlende Familie.
     Altwerte lagen unter LUFT_ADJ[font][slug]; sie werden weiter gelesen,
     damit eine alte Kalibrierung nicht wortlos verschwindet. */
  function mk006IconLuft(name, previewMode, fontCode) {
    var basis = getLayoutIconGap(name, previewMode);
    var slug = symbolSlug(name);
    var proModus = ((MK006_LUFT_ADJ[previewMode] || {})[fontCode] || {})[slug];
    var alt = (MK006_LUFT_ADJ[fontCode] || {})[slug];
    var zuschlag = (proModus != null ? proModus : (alt != null ? alt : 0)) || 0;
    if (!zuschlag) return basis;
    return ((parseFloat(basis) || 0) + zuschlag) + 'em';
  }
  function istSchriftEbene(previewMode, lineNum, raw) {
    if (raw == null) return false;
    if (previewMode === 'nur_motiv') return false;
    if (previewMode === 'text_motiv' && lineNum === 2) return false;
    if (!String(raw)) return false;
    return !isSymbolOnlyRaw(raw);
  }

  /* ★ Schriftlage UND Schriftgroesse JE GRAVUR-ART (Yin 2026-08-23).
     Der Befund war echt: MK006_TUNE.schrift[font] galt fuer die Textebene in
     ALLEN Vorlagen gleichzeitig — "1 Zeile", "2 Zeilen" und der Text von
     "Text oben, Motiv unten" hingen an derselben Zelle. Wer die Schrift in
     einer Vorlage ausrichtete, verschob sie in den anderen beiden mit; beim
     Zurueckwechseln sah es aus, als haette sich das Motiv bewegt.

     Jetzt eine Zelle je (Vorlage, Schrift). Die Startwerte sind in allen drei
     Vorlagen Yins bisher kalibrierte Werte — der Umbau aendert am Bild also
     zunaechst nichts, ab jetzt driften die Vorlagen aber nicht mehr
     gegeneinander. "Nur Motiv" fehlt bewusst: dort gibt es keinen Text.
     Die Motivlage war schon vorher getrennt (ICON_ADJ[seite][modus][slug]). */
  /* ★ Seiten-Ebene 2026-09-03: [seite][vorlage][font]. `back` wortgleich aus
     `front` — dieselbe Bauart wie R008_TEXT_ADJ[side][layout][font]. */
  var MK006_SCHRIFT_LAGE_BY_MODUS = {
    front: {
      '1_zeile': {
        G02: { dx: 0.25, dy: 0, scale: 1 },
        G04: { dx: -1.25, dy: -0.75, scale: 0.88 },
        G05: { dx: -0.5, dy: 0.75, scale: 0.96 },
        G06: { dx: -1.25, dy: 0, scale: 0.86 }
      },
      '2_zeilen': {
        G02: { dx: 0.25, dy: -0.5, scale: 1 },
        G04: { dx: -1, dy: 0, scale: 0.88 },
        G05: { dx: -0.25, dy: 0.25, scale: 0.96 },
        G06: { dx: -0.75, dy: -0.75, scale: 0.86 }
      },
      text_motiv: {
        G02: { dx: 0.25, dy: -1.25, scale: 1 },
        G04: { dx: -0.25, dy: -1.25, scale: 0.88 },
        G05: { dx: 0.25, dy: -0.5, scale: 0.96 },
        G06: { dx: -1.25, dy: 0, scale: 0.86 }
      }
    },
    back: {
      '1_zeile': {
        G02: { dx: 0.25, dy: 0, scale: 1 },
        G04: { dx: -1.25, dy: -0.75, scale: 0.88 },
        G05: { dx: -0.5, dy: 0.75, scale: 0.96 },
        G06: { dx: -1.25, dy: 0, scale: 0.86 }
      },
      '2_zeilen': {
        G02: { dx: 0.25, dy: -0.5, scale: 1 },
        G04: { dx: -1, dy: 0, scale: 0.88 },
        G05: { dx: -0.25, dy: 0.25, scale: 0.96 },
        G06: { dx: -0.75, dy: -0.75, scale: 0.86 }
      },
      text_motiv: {
        G02: { dx: 0.25, dy: -1.25, scale: 1 },
        G04: { dx: -0.25, dy: -1.25, scale: 0.88 },
        G05: { dx: 0.25, dy: -0.5, scale: 0.96 },
        G06: { dx: -1.25, dy: 0, scale: 0.86 }
      }
    }
  };
  var MK006_SCHRIFT_LAGE_NEUTRAL = { dx: 0, dy: 0, scale: 1 };

  /* Vorlagenname fuer die Reglerbeschriftung — Yin muss im Fenster sehen,
     WELCHE Gravur-Art sie gerade verstellt. */
  var MK006_MODUS_NAME = {
    '1_zeile': '1 Zeile', '2_zeilen': '2 Zeilen',
    'text_motiv': 'Text+Motiv', 'text_oben_motiv_unten': 'Text+Motiv',
    'nur_motiv': 'Nur Motiv',
    'koordinaten': 'Koordinaten', 'roemische_zahlen': 'R\u00f6mische Zahlen'
  };

  /* Der Renderpfad kennt die TM-Vorlage als 'text_motiv', die Auswahlkarte
     heisst 'text_oben_motiv_unten'. Eine Stelle, die beide auf denselben
     Tabellenschluessel bringt — sonst schreibt der Regler in eine Zelle, die
     der Renderer nie liest. */
  /* „Nur Motiv" liefert bewusst NULL statt eines Ersatzschluessels. Bis
     2026-09-03 fiel dieser Fall auf '1_zeile' durch: der Regler „Text-Groesse
     (Font)" stand in „Nur Motiv" im Panel, bewegte dort nichts (istSchriftEbene
     ist fuer nur_motiv immer false — die Vorlage hat gar keine Schriftebene)
     und verstellte still die Kalibrierung der FREMDEN Vorlage „1 Zeile".
     Der Regler ist jetzt aus dem Fenster genommen (Zugriff D2 gibt dort eine
     Begruendung zurueck); NULL hier schliesst die Luecke zusaetzlich an der
     Wurzel, damit ein kuenftiger Aufrufer sie nicht neu aufreisst. */
  function mk006SchriftModus(modus) {
    if (modus === 'nur_motiv') return null;
    /* Dieselbe Falle wie bei „Nur Motiv", nur aus dem anderen Grund: hier GIBT
       es eine Schriftebene, aber sie ist festgenagelt (G02). Ohne dieses NULL
       fiele „Koordinaten"/„Roemische Zahlen" auf '1_zeile' durch und
       verstellte still die Kalibrierung der fremden Vorlage. */
    if (mk006IstFesteSchriftStil(modus)) return null;
    if (modus === MK006_TM_LAYOUT || modus === 'text_motiv') return 'text_motiv';
    if (modus === '2_zeilen') return '2_zeilen';
    return '1_zeile';
  }
  function mk006SchriftLage(seite, modus, fontName) {
    var k = mk006SchriftModus(modus);
    if (!k) return MK006_SCHRIFT_LAGE_NEUTRAL;
    var m = mk006SeitenTeil(MK006_SCHRIFT_LAGE_BY_MODUS, seite)[k] || {};
    return m[fontName] || MK006_SCHRIFT_LAGE_NEUTRAL;
  }
  function mk006SchriftLageSetzen(seite, modus, fontName) {
    var k = mk006SchriftModus(modus);
    /* Wegwerf-Objekt statt Zelle einer fremden Vorlage — oder einer fremden Seite. */
    if (!k) return { dx: 0, dy: 0, scale: 1 };
    var s = mk006SeitenTeilSetzen(MK006_SCHRIFT_LAGE_BY_MODUS, seite);
    if (!s[k]) s[k] = {};
    if (!s[k][fontName]) {
      s[k][fontName] = { dx: 0, dy: 0, scale: 1 };
    }
    return s[k][fontName];
  }

  function getSchriftNudge(seite, previewMode, lineNum, raw) {
    if (!istSchriftEbene(previewMode, lineNum, raw)) return MK006_SCHRIFT_LAGE_NEUTRAL;
    return mk006SchriftLage(seite, previewMode, getGlobalFont().font_name || 'G02');
  }
  function buildPreviewStyle(sideIndex, previewMode, lineNum, raw) {
    var pos = getPreviewPos(sideIndex, previewMode, lineNum);
    /* Die EINE Stelle, an der aus dem physischen Seitenindex der
       Tabellenschluessel wird. Alles darunter bekommt ihn durchgereicht;
       keine Lesefunktion raet ihn sich selbst zusammen. */
    var seite = mk006SeiteKey(sideIndex);
    // Gesamt-Layer additiv auf die berechnete Lage; Zeile 2 zusaetzlich
    // eigenstaendig, damit sie sich unabhaengig ausrichten laesst.
    var t = MK006_TUNE;
    /* Zeile 2: globaler Wert PLUS ein Wert je Schriftart (Yin 2026-08-23:
       „2 zeile 的文字间距也要跟字体不一样的单独调整"). Additiv statt ersetzend,
       damit die bereits kalibrierte globale Lage stehen bleibt und die
       Schriftzelle nur die Abweichung traegt — dieselbe Bauart wie
       KOMBI_BY_FONT. Neutral = 0/0, der Einbau veraendert nichts. */
    var z2g = (lineNum === 2) ? t.zeile2 : { dx: 0, dy: 0 };
    /* Je-Schrift-Lage: gilt fuer BEIDE Zeilen, nicht nur fuer die zweite. */
    var zf = mk006ZeilenVersatz(seite, previewMode, lineNum);
    /* Feinlage der zwei Stile mit fester Schrift — additiv wie alles andere,
       neutral (0/0) fuer jede bestehende Vorlage. */
    var fs = mk006FesteStilVersatz(seite, previewMode, lineNum);
    var z2 = { dx: (z2g.dx || 0) + zf.dx + fs.dx, dy: (z2g.dy || 0) + zf.dy + fs.dy };
    var sn = getSchriftNudge(seite, previewMode, lineNum, raw);
    /* Regel 7: die Motiv-Ebene von „Text oben, Motiv unten" bekommt ihre
       Je-Schrift-Werte obendrauf (gap = Abstand unter dem Text, motivDy =
       Feinlage — beide addieren wie beim KE030-Vorbild). */
    var kb = (previewMode === 'text_motiv' && lineNum === 2)
      ? mk006Kombi(seite, MK006_TM_LAYOUT, getGlobalFont().font_name || 'G02')
      : MK006_KOMBI_NEUTRAL;
    /* D3: zusaetzlicher Abstand je Schrift UND Motiv — nur auf der
       Motiv-Ebene der TM-Vorlage, sonst 0. */
    var tmPaar = 0;
    if (previewMode === 'text_motiv' && lineNum === 2) {
      var tmSym = getLineSymbol(sideIndex, 2);
      if (tmSym) tmPaar = mk006TmAbstand(getGlobalFont().font_name || 'G02', symbolSlug(tmSym));
    }
    /* K1: die TM-TEXTebene allein, je Schrift — die Motiv-Ebene bleibt. */
    var tn = (previewMode === 'text_motiv' && lineNum === 1)
      ? mk006TmTextNudge(seite, getGlobalFont().font_name || 'G02')
      : { dx: 0, dy: 0 };
    /* ⚠️ `scale` wirkt VOR dem `transform: translate(-50%,-50%)` der
       Zentrierung — das halbe Eigenmass wird mitskaliert. Ein Groessenfaktor
       verschiebt die Marke deshalb zwangslaeufig um (1-s)/2 ihres Eigenmasses
       nach rechts/unten (bei 0.94 rund 0.5 px, bei 0.7 schon 2.7 px). Yins
       Kalibrierung ist gegen dieses Verhalten gedreht: wer die Kopplung
       aufloest, macht ihre Werte ungueltig. Gemessen und festgeschrieben in
       scripts/mk006/verify_mk006_gebacken.js. */
    var extra = '';
    if (sn.scale != null && sn.scale !== 1) extra = 'scale:' + sn.scale + ';';
    if (kb.motivMult != null && kb.motivMult !== 1) extra += 'scale:' + kb.motivMult + ';';
    /* „2 Zeilen": jede Zeile ihre eigene Groesse je Schrift. Bewusst NICHT
       ueber `scale` (das verschiebt mit, siehe oben), sondern ueber die
       Schriftgroesse selbst — der Text bleibt an seinem Anker. */
    if (previewMode === '2_zeilen') {
      var zg = mk006ZeilenGroesse(getGlobalFont().font_name || 'G02');   /* Groesse bleibt geteilt — siehe Bericht */
      var zf = lineNum === 2 ? zg.zeile2 : zg.zeile1;
      if (zf != null && zf !== 1) extra += '--mk006-zeile-scale:' + zf + ';';
    }
    /* Koordinaten laufen auf den 2-Zeilen-Klassen, lesen aber keine Schriftzelle —
       eigene Groesse aus KOORD_LAGE.groesse, gleicher CSS-Weg. */
    if (previewMode === MK006_KOORD_LAYOUT) {
      /* ⚠️ Seite mitlesen: KOORD_LAGE traegt seit dem Seiten-Umbau front/back
         als OBERSTE Ebene. Ein flaches MK006_KOORD_LAGE.groesse liefert hier
         undefined — die CSS-Variable faellt dann lautlos weg und Yins 0.82
         („经纬度距离边缘得要留边", 2026-09-08) ist unsichtbar verloren. Genau
         so ist es beim ersten Zusammenlegen am 2026-09-15 passiert; gefunden
         hat es seiten_neutral.mjs, nicht das Auge. */
      var kg = mk006KoordLage(seite).groesse;
      if (kg != null && kg !== 1) extra += '--mk006-zeile-scale:' + kg + ';';
    }
    return 'top:' + (pos.top + t.blockDy + z2.dy + sn.dy + (kb.motivDy || 0) + (kb.gap || 0) + tmPaar + (tn.dy || 0)) + '%;left:' + (pos.left + t.blockDx + z2.dx + sn.dx + (kb.motivDx || 0) + (tn.dx || 0)) + '%;font-family:' + mk006SchriftFamilieFuer(previewMode) + ';' + extra;
  }

  /* Feste Schrift heisst FEST: die Marke bekommt den G02-Stack, gleichgueltig
     was oben gewaehlt ist. Faellt der Katalog aus, bleibt der gewaehlte Stack
     als Notnagel — gar keine Familie waere schlimmer. */
  function mk006SchriftFamilieFuer(previewMode) {
    if (!mk006IstFesteSchriftStil(previewMode)) return getFontFamilyCss();
    return MK006_FONT_STACK[MK006_FESTE_SCHRIFT] || getFontFamilyCss();
  }

  function getPreviewFontClass() {
    var code = getGlobalFont().font_name;
    if (code === 'G04') return ' mk006-preview-text--font-g04';
    if (code === 'G05') return ' mk006-preview-text--font-g05';
    if (code === 'G06') return ' mk006-preview-text--font-g06';
    if (code === 'G07' && isAs022Personalization) return ' mk006-preview-text--font-g07';
    if (code === 'G08' && isAs022Personalization) return ' mk006-preview-text--font-g08';
    return '';
  }

  function isAs022G08MixedLine(raw, previewMode, symbolOnly) {
    if (!isAs022Personalization || previewMode === 'nur_motiv' || symbolOnly) return false;
    if ((getGlobalFont().font_name || 'G02') !== 'G08') return false;
    return lineHasSymbolAndText(raw);
  }

  function isAs022G08SandwichIcon(previewMode, inlineBetween) {
    return isAs022Personalization
      && isUppercaseOnlyFont()
      && previewMode !== 'nur_motiv'
      && (previewMode === '1_zeile' || previewMode === '2_zeilen')
      && inlineBetween;
  }

  function isAs022G03MiniHerzBetween(previewMode, inlineBetween, symText) {
    return isAs022Personalization
      && (getGlobalFont().font_name || 'G02') === 'G03'
      && (previewMode === '1_zeile' || previewMode === '2_zeilen')
      && inlineBetween
      && symbolSlug(symText) === 'mini-herz';
  }

  function getAs022G08MixedFontClass(raw, previewMode, symbolOnly) {
    return isAs022G08MixedLine(raw, previewMode, symbolOnly) ? ' mk006-preview-text--font-g08-mixed' : '';
  }

  function getPreviewTextMaxWidthPx() {
    var stage = $('[data-mk006-preview-stage]')[0];
    if (isAs022Personalization) {
      if (stage && stage.clientWidth) {
        return stage.clientWidth * (AS022_PREVIEW_TEXT_MAX_WIDTH_PCT / 100);
      }
      return PREVIEW_TEXT_MAX_WIDTH_AS022;
    }
    var maxBase = getPreviewTextMaxWidthBase();
    if (!stage || !stage.clientWidth) return maxBase;
    var pct = MK006_TUNE.limitBreite;
    if (pct == null || !(pct > 0)) return stage.clientWidth * (maxBase / 1600);
    return stage.clientWidth * (pct / 100);
  }

  function fitPreviewTextWidths() {
    var maxWBasis = getPreviewTextMaxWidthPx();
    /* Gilt fuer 1 Zeile, 2 Zeilen UND „Text oben, Motiv unten" — dessen
       Textebene traegt die Klasse --2-zeilen und ist damit erfasst (Yin
       2026-08-19: „在一行 两行 和 文字加图标 都要有"). */
    $('[data-mk006-preview-stage] .mk006-preview-text--1-zeile, [data-mk006-preview-stage] .mk006-preview-text--2-zeilen').each(function() {
      var el = this;
      var maxW = el.getAttribute('data-mk006-preview-line') === '2'
        ? maxWBasis * MK006_TUNE.limitBreiteZeile2
        : maxWBasis;
      var contentScale = getPreviewLetterOnlyScaleMultiplier(el);
      el.style.transform = 'translate(-50%, -50%)';
      var w = el.scrollWidth;
      var finalScale = contentScale;
      if (w > 0 && maxW > 0 && w * finalScale > maxW) {
        finalScale = maxW / w;
      }
      if (finalScale !== 1) {
        el.style.transform = 'translate(-50%, -50%) scale(' + finalScale + ')';
      }
    });
  }

  function scheduleFitPreviewTextWidths() {
    requestAnimationFrame(function() {
      fitPreviewTextWidths();
      requestAnimationFrame(fitPreviewTextWidths);
    });
  }

  function getPreviewModeClass(previewMode, lineNum) {
    if (previewMode === 'nur_motiv') return ' mk006-preview-text--nur-motiv';
    // TEXT OBEN, MOTIV UNTEN: die Textzeile erbt die 2-Zeilen-Groessenregeln,
    // die Motivzeile bekommt bewusst KEINE davon.
    if (previewMode === 'text_motiv') {
      return lineNum === 2 ? ' mk006-preview-text--tm-motiv' : ' mk006-preview-text--2-zeilen';
    }
    if (previewMode === '2_zeilen') return ' mk006-preview-text--2-zeilen';
    /* Die zwei neuen Stile erben die GROESSENregeln der bestehenden Klassen —
       und damit auch die Breitenkappe: fitPreviewTextWidths() waehlt genau
       --1-zeile und --2-zeilen aus. Ohne eine dieser Klassen waere der
       LB-Regler fuer sie tot. */
    if (previewMode === MK006_KOORD_LAYOUT) return ' mk006-preview-text--2-zeilen';
    if (previewMode === MK006_ROMAN_LAYOUT) return ' mk006-preview-text--1-zeile';
    return ' mk006-preview-text--1-zeile';
  }

  function getLw100G02ZeilenSizeMultiplier(weightedLen) {
    var len = Math.max(0, Number(weightedLen) || 0);
    var maxLen = isAs022Personalization ? 12 : 10;
    if (len <= 1) return 1.35;
    if (len >= maxLen) return 0.85;
    if (len <= 3) {
      return 1.35 + ((len - 1) / 2) * (1.0 - 1.35);
    }
    return 1.0 + ((len - 3) / (maxLen - 3)) * (0.85 - 1.0);
  }

  function appendLw100G02ZeilenFontStyle(style, raw, previewMode) {
    if (!isPlaettchenPreviewPersonalization || previewMode !== '2_zeilen') return style;
    if ((getGlobalFont().font_name || 'G02') !== 'G02') return style;
    var mult = getLw100G02ZeilenSizeMultiplier(weightedLength(raw || ''));
    return style + 'font-size:calc(var(--mk006-2zeilen-text-size) * ' + mult + ');';
  }

  function getLw100G02ZeilenDynamicClass(raw, previewMode) {
    if (!isPlaettchenPreviewPersonalization || previewMode !== '2_zeilen') return '';
    if ((getGlobalFont().font_name || 'G02') !== 'G02') return '';
    if (!raw) return '';
    return ' lw100-g02-zeilen-dynamic';
  }

  function getLw100Dual1ZeileClass(sideClass, previewMode) {
    if (!isPlaettchenPreviewPersonalization || usesEinzelPreviewBase() || previewMode !== '1_zeile') {
      return '';
    }
    if (sideClass.indexOf('--front') !== -1) return ' lw100-dual-front-1zeile';
    if (sideClass.indexOf('--back') !== -1) return ' lw100-dual-back-1zeile';
    return '';
  }

  function appendPreviewLine($layers, sideClass, style, raw, previewMode, lineNum) {
    if (!raw) return;
    var modeClass = getPreviewModeClass(previewMode, lineNum);
    var symbolOnly = previewMode !== 'nur_motiv' && isSymbolOnlyRaw(raw);
    /* Feste Schrift: weder die je-Schrift-Groessenklasse noch die
       Familienklasse der gewaehlten Schrift duerfen mit — sonst stuende die
       Koordinate zwar im G02-Stack, traege aber die Groessenregel von G06. */
    var festeSchrift = mk006IstFesteSchriftStil(previewMode);
    var fontCodeClass = festeSchrift
      ? ' mk006-preview-font-' + MK006_FESTE_SCHRIFT.toLowerCase()
      : getPreviewFontCodeClass();
    var fontBoostClass = (previewMode === 'nur_motiv' || symbolOnly || festeSchrift) ? '' : getPreviewFontClass();
    var symbolOnlyClass = symbolOnly ? ' mk006-preview-symbol-only' : '';
    var g08MixedFontClass = getAs022G08MixedFontClass(raw, previewMode, symbolOnly);
    var g08MixedTextScale = isAs022G08MixedLine(raw, previewMode, symbolOnly);
    var letterOnlyClass = getPreviewLetterOnlyClass(raw, previewMode, symbolOnly, sideClass);
    var lw100Dual1ZeileClass = getLw100Dual1ZeileClass(sideClass, previewMode);
    var lw100G02ZeilenDynamicClass = getLw100G02ZeilenDynamicClass(raw, previewMode);
    style = appendLw100G02ZeilenFontStyle(style, raw, previewMode);
    var adjSideKey = sideClass.indexOf('--back') !== -1 ? 'back' : 'front';
    var engravingHtml = buildEngravingHtml(raw, previewMode, g08MixedTextScale, adjSideKey);
    $layers.append(
      '<div class="mk006-preview-text' + modeClass + sideClass + fontBoostClass + g08MixedFontClass + symbolOnlyClass + letterOnlyClass + lw100Dual1ZeileClass + lw100G02ZeilenDynamicClass + fontCodeClass +
      '" data-mk006-preview-mode="' + previewMode + '" data-mk006-preview-line="' + lineNum + '" style="' + style + '">' +
      engravingHtml + '</div>'
    );
  }

  function buildEngravingHtml(raw, previewMode, g08MixedTextScale, adjSideKey) {
    if (!raw) return '';
    var html = '', re = /\(([^)]+)\)/g, last = 0, match;
    var wrapNextAsG03AfterMiniHerz = false;
    function appendTextSegment(text, afterG03MiniHerz) {
      if (!text) return;
      var chunk = esc(text);
      if (g08MixedTextScale) {
        chunk = '<span class="mk006-preview-g08-text-scale">' + chunk + '</span>';
      }
      if (afterG03MiniHerz) {
        chunk = '<span class="mk006-preview-g03-after-mini-herz">' + chunk + '</span>';
      }
      html += chunk;
    }
    while ((match = re.exec(raw)) !== null) {
      if (match.index > last) {
        appendTextSegment(raw.substring(last, match.index), false);
        wrapNextAsG03AfterMiniHerz = false;
      }
      var sym = getSymbolByName(match[1]);
      if (sym && sym.image) {
        var hasTextAfter = re.lastIndex < raw.length;
        var inlineBetween = match.index > 0 && hasTextAfter;
        var sandwichClass = isAs022G08SandwichIcon(previewMode, inlineBetween)
          ? ' mk006-preview-symbol--as022-g08-sandwich'
          : '';
        if (isAs022G03MiniHerzBetween(previewMode, inlineBetween, sym.text)) {
          sandwichClass += ' mk006-preview-symbol--as022-g03-mini-herz-between';
          wrapNextAsG03AfterMiniHerz = true;
        } else {
          wrapNextAsG03AfterMiniHerz = false;
        }
        /* G1/D1/D3 — Ueberlagerung (Familienmuster); neutral = alter Stil. */
        var iAdj = mk006IconAdj(adjSideKey, previewMode, symbolSlug(sym.text));
        var iconTeile = '';
        if (previewMode !== 'nur_motiv') {
          iconTeile += 'margin-left:' + esc(mk006IconLuft(match[1], previewMode, getGlobalFont().font_name || 'G02')) + ';';
        }
        var iDx = (iAdj.dx || 0) + MK006_TUNE.motivDx;
        var iDy = (iAdj.dy || 0) + MK006_TUNE.motivDy;
        if (iDx || iDy) iconTeile += 'translate:' + iDx + 'em ' + iDy + 'em;';
        if (iAdj.scale != null && iAdj.scale !== 1) iconTeile += 'scale:' + iAdj.scale + ';';
        var gapStyle = iconTeile ? ' style="' + iconTeile + '"' : '';
        html += '<img class="mk006-preview-symbol mk006-preview-symbol--' + esc(symbolSlug(sym.text)) +
          sandwichClass + '"' + gapStyle +
          ' src="' + esc(sym.image) + '" alt="' + esc(match[1]) + '">';
      } else {
        html += esc('(' + match[1] + ')');
        wrapNextAsG03AfterMiniHerz = false;
      }
      last = re.lastIndex;
    }
    if (last < raw.length) appendTextSegment(raw.substring(last), wrapNextAsG03AfterMiniHerz);
    return html;
  }

  function ensurePreviewShell() {
    var $host = $('.up-Fenster-p-personalization-1 .fenster-content-contentin');
    if (!$host.length) return;
    if (!$host.find('.mk006-preview-wrap').length) {
      var shellHtml =
        '<div class="mk006-preview-wrap">' +
          '<div class="mk006-preview-label">Vorschau</div>' +
          '<div class="mk006-preview-stage" data-mk006-preview-stage>' +
            /* NIE loading="lazy" (GOTCHAS 27): das Fenster faehrt von ausserhalb des
               Viewports herein — dort laedt der Browser ein lazy-Bild nicht, und er
               prueft es beim Hereinfahren auch nicht neu. Das Basisbild bliebe grau,
               ohne Fehler in der Konsole (complete=false, naturalWidth 0). Real
               gemessen bei KS017, A203 und A227; Bestand am 2026-09-15 bereinigt. */
            '<img class="mk006-preview-base" alt="">' +
            '<img class="mk006-preview-gem" alt="" loading="lazy">' +
            '<div class="mk006-preview-layers"></div>' +
          '</div>' +
        '</div>';
      if (!isEngravingOnlyPopup) {
        shellHtml +=
          '<div class="mk006-geburtsstein-readonly">' +
            '<div class="mk006-geburtsstein-readonly-label">Geburtsstein</div>' +
            '<div class="mk006-geburtsstein-readonly-value" data-mk006-geburtsstein-label></div>' +
          '</div>';
      }
      $host.prepend(shellHtml);
    }
    if (!$host.find('.mk006-global-font').length) {
      var $fontAnchor = isPlaettchenPreviewPersonalization
        ? $host.find('.mk006-preview-wrap')
        : $host.find('.mk006-geburtsstein-readonly');
      $fontAnchor.after(
        '<div class="mk006-global-font">' +
          '<div class="mk006-global-font-label">Schriftart</div>' +
          '<div class="mk006-font-grid" data-mk006-font-grid></div>' +
        '</div>'
      );
      renderFontGrid();
    }
  }

  /* ---- Kontext-Schriftart (K530-Standard) ----------------------------------
     docs/KONTEXT-SCHRIFTART-STANDARD.md: die Schriftwahl haengt nicht mehr
     dauerhaft oben, sondern erscheint im Eingabe-Panel — und nur bei
     Gravurstilen, die ueberhaupt Text gravieren. Kriterium ist nicht das Auge,
     sondern ob die Zeile Buchstaben in der globalen Schrift rendert:
     nur_motiv legt ausschliesslich ein Symbolbild ab und bleibt draussen. */
  // Die neue Art graviert Text -> sie bekommt die Schriftzeile ebenfalls.
  var MK006_FONT_LAYOUTS = { '1_zeile': 1, '2_zeilen': 1, 'text_oben_motiv_unten': 1 };

  // Anfuehrungszeichen im Stack einfach machen: der Stack landet in einem
  // inline style="…" (GOTCHAS: doppelte Anfuehrungszeichen brechen das Attribut).
  function fontStackForCode(code, fallbackText) {
    var stack = MK006_FONT_STACK[code];
    if (!stack && fallbackText) {
      stack = String(fallbackText).indexOf(',') !== -1 ? fallbackText : fallbackText + ', sans-serif';
    }
    return String(stack || MK006_FONT_STACK.G02).replace(/"/g, "'");
  }

  /* [2] Jede Schriftzeile zeigt NUR ihren eigenen Code (G02 …), gerendert in
     ihrer eigenen Schrift (SS1.2 des Standards, Yin 2026-08-15). Die
     08-14-Fassung (Probewort = Kundeneingabe) ist verworfen: jede Zeile
     zeigte dasselbe Wort, die Liste taugte nicht mehr zum Schrift-Vergleich,
     und die gefuellte Zeile las sich wie ein zweites Eingabefeld. */
  function renderFontGrid() {
    var fonts = getSelectableFonts();
    var current = getGlobalFont();
    var html = '';
    for (var i = 0; i < fonts.length; i++) {
      var f = fonts[i];
      var gname = String(f.font_name || '');
      var active = gname === current.font_name ? ' class="is-active"' : '';
      var probeStyle = 'font-family:' + fontStackForCode(gname, f.text) + ';' +
        (gname === 'G08' ? 'text-transform:uppercase;' : '');
      html += '<button type="button"' + active + ' data-value="' + esc(gname) + '" data-font="' + esc(gname) + '" data-family="' + esc(f.text) + '">' +
        '<span class="mk006-font-probe" style="' + esc(probeStyle) + '">' + esc(gname) + '</span>' +
        '<span class="mk006-font-code">' + esc(gname) + '</span>' +
        '<span class="mk006-font-haken">&#10003;</span>' +
      '</button>';
    }
    $('[data-mk006-font-grid]').html(html);
    syncPanelFontUI();
  }

  /* Jede Probe zeigt ihren EIGENEN data-value; nur die Kopfzeilen zeigen die
     aktive Schrift. Nirgends die Eingabe der Kundin. */
  function mk006SyncFontProbe() {
    var aktiv = String(getGlobalFont().font_name || '');
    $('.up-Fenster-p-personalization-1 .mk006-font-probe').each(function() {
      var $zeile = $(this).closest('[data-value]');
      var name = $zeile.length ? String($zeile.attr('data-value') || '') : aktiv;
      if (name && $(this).text() !== name) $(this).text(name);
    });
  }

  // Kompakte Schrift-Zeile IM Panel. Zugeklappt zeigt der Kopf die aktuelle
  // Schrift als lebende Probe; das Raster klappt erst auf Tipp auf und nach der
  // Wahl wieder zu. Reine Ansicht auf denselben globalFont-Speicher.
  function buildPanelFontRow() {
    var font = getGlobalFont();
    var headStyle = 'font-family:' + fontStackForCode(font.font_name, font.text) + ';';
    return '<div class="mk006-panel-font">' +
      '<button type="button" class="mk006-panel-font-head" aria-expanded="false">' +
        '<span class="mk006-panel-font-title">Schriftart</span>' +
        '<span class="mk006-font-probe" style="' + esc(headStyle) + '">' + esc(font.font_name || '') + '</span>' +
        '<span class="mk006-font-code">' + esc(font.font_name || '') + '</span>' +
        '<span class="mk006-panel-font-chev" aria-hidden="true">&#9662;</span>' +
      '</button>' +
      '<div class="mk006-panel-font-hinweis">Eine Schrift f&uuml;r das ganze Schmuckst&uuml;ck &mdash; zum &Auml;ndern tippen.</div>' +
      '<div class="mk006-panel-font-body">' +
        '<div class="mk006-global-font-label">Schriftart w&auml;hlen</div>' +
        '<div class="mk006-font-grid" data-mk006-font-grid></div>' +
      '</div>' +
    '</div>';
  }

  // Alle Panel-Schriftzeilen an den globalen Speicher angleichen. Die Rollen
  // (waehlbar / Spiegel) werden bei JEDEM Lauf nach DOM-Reihenfolge neu
  // vergeben — nach einem Stilwechsel kann die "erste Text-Stelle" auf die
  // andere Seite wandern.
  function syncPanelFontUI() {
    var font = getGlobalFont();
    var name = String(font.font_name || '');
    var stack = fontStackForCode(font.font_name, font.text);
    $('.up-Fenster-p-personalization-1 .mk006-panel-font').each(function(i) {
      var $pf = $(this);
      /* Rollen bei JEDEM Lauf nach DOM-Reihenfolge neu vergeben; eine Zeile,
         die gerade erst Spiegel WIRD, startet zugeklappt (--zu). Eine schon
         aufgeklappte Spiegelzeile bleibt aufgeklappt (SS1.4b). */
      var wurdeSpiegel = i > 0 && !$pf.hasClass('mk006-panel-font--spiegel');
      $pf.toggleClass('mk006-panel-font--spiegel', i > 0);
      if (wurdeSpiegel) $pf.addClass('mk006-panel-font--zu');
      if (i === 0) $pf.removeClass('mk006-panel-font--zu');
      if (i > 0 && $pf.hasClass('is-open')) {
        $pf.removeClass('is-open').find('.mk006-panel-font-head').attr('aria-expanded', 'false');
      }
      var $probe = $pf.find('.mk006-panel-font-head .mk006-font-probe').first();
      $probe.text(name);
      $probe.css({
        'font-family': stack,
        'text-transform': font.font_name === 'G08' ? 'uppercase' : 'none'
      });
      $pf.find('.mk006-panel-font-head .mk006-font-code').text(name);
    });
    mk006SyncFontProbe();
  }

  function buildSymbolGrid(sideIndex, lineNum) {
    var symbols = loadSymbols();
    /* In der TM-Vorlage nur die kurze Liste zeigen. Gefiltert wird erst hier,
       nicht in loadSymbols(): der Renderpfad und die Wiederherstellung alter
       Bestellungen muessen weiterhin JEDES Motiv aufloesen koennen, sonst
       faellt es im wiederhergestellten Warenkorb stillschweigend weg. */
    if (getSideLayout(sideIndex) === MK006_TM_LAYOUT) {
      symbols = symbols.filter(function (sy) {
        return MK006_TM_MOTIVE.indexOf(sy.code) !== -1;
      });
    }
    var selected = getLineSymbol(sideIndex, lineNum);
    var html = '<div class="mk006-symbol-grid" data-side="' + sideIndex + '" data-line="' + lineNum + '">';
    for (var i = 0; i < symbols.length; i++) {
      var sym = symbols[i];
      var activeAttr = sym.text === selected ? ' class="is-active"' : '';
      html += '<button type="button"' + activeAttr + ' data-symbol="' + esc(sym.text) + '">' +
        '<img src="' + esc(sym.image) + '" alt="' + esc(sym.text) + '" loading="lazy">' +
        '<span class="mk006-symbol-label">' + esc(sym.text) + '</span></button>';
    }
    return html + '</div>';
  }

  /* ohneRaster: die Art „Text oben, Motiv unten" hat EIN eigenes Motivraster
     unter dem Feld (Zeile 2). Das Feld darf dann kein zweites mitbringen. */
  function buildLineField(sideIndex, lineNum, label, ohneRaster) {
    var maxLen = getLineMaxLen(lineNum, sideIndex);
    return '<div class="mk006-line-block" data-line-block="' + lineNum + '">' +
      '<div class="mk006-line-label">' + esc(label) + '</div>' +
      '<div class="mk006-line-input-wrap">' +
        '<input type="text" class="mk006-line-input" data-side="' + sideIndex + '" data-line="' + lineNum + '" data-max="' + maxLen + '">' +
        '<div class="mk006-line-clear" style="display:none"></div>' +
        '<span class="mk006-line-counter"><span class="mk006-count">0</span> / ' + maxLen + '</span>' +
      '</div>' +
      (ohneRaster ? '' : buildSymbolGrid(sideIndex, lineNum)) +
    '</div>';
  }

  // Huelle um den Panel-Bau: Stile mit Text bekommen die Schrift-Zeile direkt
  // nach dem oeffnenden .mk006-panel-Tag eingeschoben. Einzige Einschubstelle —
  // alle Aufrufer (Stilwechsel, Erstaufbau) laufen hier durch.
  function buildLayoutPanel(sideIndex, layout) {
    var html = buildLayoutPanelCore(sideIndex, layout);
    if (MK006_FONT_LAYOUTS[layout] && html) {
      var cut = html.indexOf('>') + 1;
      html = html.slice(0, cut) + buildPanelFontRow() + html.slice(cut);
    }
    return html;
  }

  function buildLayoutPanelCore(sideIndex, layout) {
    if (layout === '1_zeile') {
      return '<div class="mk006-panel" data-panel="1_zeile">' + buildLineField(sideIndex, 1, '1. ZEILE', true) + '</div>';
    }
    if (layout === '2_zeilen') {
      // Kein Motivraster mehr an Zeile 1/2 (Yin 2026-08-18: „一行刻字 两行刻字的
      // 情况下是没有图标的" — Icon-Wahl gibt es nur bei „Nur Motiv" und
      // „Text oben, Motiv unten").
      return '<div class="mk006-panel" data-panel="2_zeilen">' +
        buildLineField(sideIndex, 1, '1. ZEILE', true) +
        buildLineField(sideIndex, 2, '2. ZEILE', true) +
      '</div>';
    }
    // TEXT OBEN, MOTIV UNTEN: Name im Feld der 1. Zeile (max. 8), darunter
    // genau EIN Motivraster (data-line="2").
    if (layout === MK006_TM_LAYOUT) {
      return '<div class="mk006-panel" data-panel="' + MK006_TM_LAYOUT + '">' +
        buildLineField(sideIndex, 1, 'TEXT OBEN', true) +
        '<div class="mk006-line-label" style="margin-top:16px">MOTIV UNTEN</div>' +
        buildSymbolGrid(sideIndex, 2) +
      '</div>';
    }
    if (layout === MK006_KOORD_LAYOUT) {
      return '<div class="mk006-panel" data-panel="' + MK006_KOORD_LAYOUT + '">' +
        '<div class="mk006-line-label">Adresse / Ort</div>' +
        '<div class="mk006-koord-row">' +
          '<input type="text" class="mk006-koord-input" placeholder="z. B. Marienplatz 1, M\u00fcnchen" autocomplete="off">' +
          '<button type="button" class="mk006-koord-btn">Suchen</button>' +
        '</div>' +
        '<div class="mk006-koord-status" aria-live="polite"></div>' +
        '<div class="mk006-koord-result" style="display:none">' +
          '<div class="mk006-koord-found"></div>' +
          '<div class="mk006-koord-confirm-row">' +
            '<button type="button" class="mk006-koord-confirm">\u00dcbernehmen</button>' +
            '<span class="mk006-koord-gmshint"></span>' +
          '</div>' +
        '</div>' +
        '<input type="hidden" class="mk006-koord-pending-gms">' +
        '<input type="hidden" class="mk006-koord-pending-address">' +
        '<span class="mk006-char-hint">Graviert wird kompakt in zwei Zeilen, Grad und Minuten \u2014 z. B. 53\u00b033\'N \u00fcber 10\u00b000\'E.</span>' +
      '</div>';
    }
    /* Das Datumsfeld traegt BEWUSST nicht die Klasse mk006-line-input: an ihr
       haengen der Zeichenzaehler, die Motiv-Klammerlogik und die
       Schrift-Kuerzung — die wuerden „28.12.2024" umschreiben. */
    if (layout === MK006_ROMAN_LAYOUT) {
      return '<div class="mk006-panel" data-panel="' + MK006_ROMAN_LAYOUT + '">' +
        '<div class="mk006-line-label">Datum</div>' +
        '<input type="text" class="mk006-roman-input" maxlength="' + MK006_ROMAN_MAX + '" placeholder="TT.MM.JJJJ" autocomplete="off">' +
        '<span class="mk006-char-hint">z. B. 28.12.2024 &rarr; XXVIII\u00b7XII\u00b7MMXXIV</span>' +
        '<div class="mk006-roman-status" aria-live="polite"></div>' +
      '</div>';
    }
    return '<div class="mk006-panel" data-panel="nur_motiv">' +
      '<div class="mk006-line-label">Motiv</div>' +
      '<div class="mk006-line-input-wrap">' +
        '<input type="text" class="mk006-line-input mk006-motiv-display" data-side="' + sideIndex + '" data-line="1" readonly placeholder="Symbol wählen">' +
        '<div class="mk006-line-clear" style="display:none"></div>' +
      '</div>' +
      buildSymbolGrid(sideIndex, 1) +
    '</div>';
  }

  /* Eine Stelle fuer den Umrechnungs-Hinweis: der Tipp-Handler und die
     Wiederherstellung nach dem Panel-Neuaufbau muessen dasselbe sagen. */
  function mk006RomanStatusZeigen($scope, raw) {
    var $st = $scope.find('.mk006-roman-status').removeClass('is-bad');
    if (!$st.length) return;
    if (!String(raw || '').trim()) { $st.text(''); return; }
    var res = mk006RomanDatumErgebnis(raw);
    if (!res.anyGood) {
      $st.addClass('is-bad').text('Bitte Zahlen zwischen 1 und 3999 eingeben, z. B. 28.12.2024.');
    } else if (res.anyBad) {
      $st.addClass('is-bad').text('Graviert wird: ' + res.text +
        ' \u2014 ein Teil lag ausserhalb 1\u20133999 und f\u00e4llt weg.');
    } else {
      $st.text('Graviert wird: ' + res.text);
    }
  }

  /* Nach jedem Kartenwechsel baut setSideLayout .mk006-dynamic neu. Die
     Zeilenfelder der alten Stile leben im DOM und sind dann leer — das ist
     gewollt. Die zwei neuen Stile merken sich ihren Wert an der SEITE; hier
     wandert er zurueck in das frische Feld, sonst waere die Eingabe nach
     einem Blick auf eine andere Karte weg. */
  function mk006PanelWiederherstellen(sideIndex, layout) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (layout === MK006_KOORD_LAYOUT) {
      var gms = mk006KoordGms(sideIndex);
      if (!gms) return;
      $side.find('.mk006-koord-input').val(mk006KoordOrt(sideIndex));
      $side.find('.mk006-koord-status').removeClass('is-bad')
        .text('\u2713 \u00dcbernommen: ' + mk006KoordEinzeilig(gms));
      return;
    }
    if (layout === MK006_ROMAN_LAYOUT) {
      var datum = mk006RomanDatum(sideIndex);
      if (!datum) return;
      $side.find('.mk006-roman-input').val(datum);
      mk006RomanStatusZeigen($side, datum);
    }
  }

  function updateLineCounter($input) {
    var lineNum = $input.attr('data-line');
    var idx = getSideIndexFromEl($input);
    var maxLen = getLineMaxLen(lineNum, idx);
    $input.attr('data-max', maxLen);
    var len;
    if (isUppercaseOnlyFont()) {
      len = weightedLength(getG08LineRaw($input, idx, lineNum));
    } else {
      var parsed = parseLineValue($input.val() || '');
      var sym = parsed.symbol || getLineSymbol(idx, lineNum);
      len = weightedLength(composeLine(parsed.text, sym));
    }
    $input.closest('.mk006-line-block').find('.mk006-count').text(len);
    $input.closest('.mk006-line-input-wrap').find('.mk006-line-counter').html('<span class="mk006-count">' + len + '</span> / ' + maxLen);
    toggleLineClear($input, $input.val());
  }

  function applyLineLimitsForFont() {
    $('.mk006-line-input:not([readonly])').each(function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      var lineNum = $input.attr('data-line');
      var maxLen = getLineMaxLen(lineNum, idx);
      if (isUppercaseOnlyFont()) {
        setG08LineRaw($input, idx, lineNum, getG08LineRaw($input, idx, lineNum), maxLen);
        syncSymbolGridForLine(idx, lineNum);
        updateLineCounter($input);
        return;
      }
      var parsed = parseLineValue($input.val() || '');
      var symbol = parsed.symbol || getLineSymbol(idx, lineNum);
      var text = normalizeLineTextForFont(parsed.text);
      while (weightedLength(composeLine(text, symbol)) > maxLen && text.length) {
        text = text.slice(0, -1);
      }
      if (symbol && weightedLength(composeLine(text, symbol)) > maxLen) {
        symbol = '';
      }
      setLineSymbol(idx, lineNum, symbol);
      syncLineInputComposed($input, text, symbol);
      syncSymbolGridForLine(idx, lineNum);
      updateLineCounter($input);
    });
  }

  function syncSymbolGridForLine(sideIndex, lineNum) {
    var selected = getLineSymbol(sideIndex, lineNum);
    if (!selected && isUppercaseOnlyFont()) {
      var raw = normalizeG08RawLine(getLineInputVal(sideIndex, lineNum));
      if (!hasInlineSymbolTokens(raw)) {
        var trailing = raw.match(/\(([^)]+)\)$/);
        if (trailing && isValidSymbolToken(trailing[1])) {
          selected = normalizeStoredSymbol(trailing[1]);
        }
      }
    }
    var $grid = $('.product_info_main_' + sideIndex).find('.mk006-symbol-grid[data-line="' + lineNum + '"]');
    $grid.find('button').removeClass('is-active');
    if (selected) $grid.find('button[data-symbol="' + selected + '"]').addClass('is-active');
  }

  function setSideLayout(sideIndex, layout) {
    /* Der Motiv-Speicher der 2. Zeile hat ZWEI Besitzer: „2 Zeilen" legt dort
       das Symbol seiner zweiten Zeile ab, und „Text oben, Motiv unten" legt
       dort sein einziges Motiv ab (buildSymbolGrid(sideIndex, 2) in beiden
       Vorlagen). Wer von TM auf 2 Zeilen wechselte und die zweite Zeile leer
       liess, sah das TM-Motiv weiter auf dem Plaettchen: getLineParts faellt
       fuer Zeile 2 auf denselben Speicher zurueck. Gemeldet von Yin am
       2026-09-03 mit Screenshot, gemessen reproduziert auf origin/main.
       Beim Wechsel ZWISCHEN diesen beiden Besitzern wird der Platz geraeumt.
       Das Motiv ist danach weg, und das ist gewollt: lieber neu waehlen als
       eine Gravur bestellen, die man nicht gewaehlt hat. */
    var vorherigesLayout = sideLayouts[sideIndex];
    if (vorherigesLayout && vorherigesLayout !== layout &&
        (vorherigesLayout === MK006_TM_LAYOUT || layout === MK006_TM_LAYOUT)) {
      setLineSymbol(sideIndex, 2, '');
    }
    sideLayouts[sideIndex] = layout;
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    $side.attr('data-mk006-layout', layout);
    $side.find('.mk006-layout-switch button').removeClass('is-active');
    $side.find('.mk006-layout-switch button[data-layout="' + layout + '"]').addClass('is-active');
    $side.find('.mk006-dynamic').html(buildLayoutPanel(sideIndex, layout));
    mk006PanelWiederherstellen(sideIndex, layout);
    mk006SyncLayoutCollapse($side);
    // Immer neu rendern: das frisch gebaute Panel bringt ein leeres
    // Schrift-Raster mit, und renderFontGrid vergibt ueber syncPanelFontUI
    // gleich die Rollen (waehlbar / Spiegel) neu.
    ensureAs022GlobalFontForLayout();
    renderFontGrid();
    applyFontToInputs();
    $side.removeClass('has-error');
    $side.find('.mk006-side-error').hide();
    window.lw043UpdatePreview();
  }

  // ---- Gravurstil icon cards (Plaettchen-Umriss + Beispielgravur) ---------
  var MK006_CARD_LAYOUTS = [
    { key: '1_zeile',   label: '1 Zeile',   sub: 'z.B. ein Name' },
    { key: '2_zeilen',  label: '2 Zeilen',  sub: 'z.B. Name + Datum' },
    { key: 'nur_motiv', label: 'Nur Motiv', sub: 'nur ein Symbol' },
    { key: 'text_oben_motiv_unten', label: 'Text oben, Motiv unten', sub: 'z.B. Name \u00fcber Herz' },
    { key: MK006_KOORD_LAYOUT, label: 'Koordinaten', sub: 'Ort suchen' },
    { key: MK006_ROMAN_LAYOUT, label: 'R\u00f6mische Zahlen', sub: 'Datum in Ziffern' }
  ];
  /* Stil-Karten-Icon — 1:1 die K530-Loesung (Yin 2026-08-23: „展示的挂坠形状
     应该是 k530 的展示图标", plus zwei rot markierte Karten „文字和图标都要放大").

     Inline-SVG statt PNG + HTML-Overlay. Der Vorteil ist nicht Kosmetik: im
     SVG stehen Kreis, Beispieltext und Motiv in DENSELBEN Nutzereinheiten,
     der Text skaliert also zwangslaeufig mit dem Plaettchen mit. Die alte
     Loesung mass den Text in cqw der Icon-BOX, das Plaettchen war aber nur
     47.9 % dieser Box — daher rutschte alles zu klein.

     Geometrie und Groessen aus K530 (Serie „gross") uebernommen, ohne eigene
     Erfindung: viewBox 88x92, Mitte (44, 54), Radius 30, Oese 6x13.
       „Emma" 1 Zeile     12   = 20.0 % des Durchmessers  (vorher rund 15 %)
       Nur-Motiv-Herz     22   = 36.7 %                   (vorher rund 26 %)
     MK006 ist wie K530 eine runde Scheibe, die Form passt also direkt —
     die FOKUS-Regel „Kartenform folgt dem echten Produkt" bleibt gewahrt. */
  function buildMk006LayoutIcon(key) {
    var cx = 44, cy = 54, r = 30, bailW = 6, bailH = 13;
    var sym = getSymbolByName('Mini Herz');
    var herz = sym && sym.image ? sym.image : '';
    function img(href, x, y, w, h) {
      if (!href) return '';
      var u = esc(href);
      return '<image href="' + u + '" xlink:href="' + u + '" x="' + x + '" y="' + y +
        '" width="' + w + '" height="' + h + '" preserveAspectRatio="xMidYMid meet"/>';
    }
    function txt(t, x, y, size) {
      return '<text x="' + x + '" y="' + y + '" font-size="' + size + '" text-anchor="middle">' + esc(t) + '</text>';
    }
    var body;
    if (key === '2_zeilen') {
      body = txt('Emma', cx, cy - 3, 10.5) + txt('2024', cx, cy + 10.5, 9.5);
    } else if (key === 'nur_motiv') {
      body = img(herz, cx - 11, cy - 11, 22, 22);
    } else if (key === MK006_TM_LAYOUT) {
      body = txt('Emma', cx, cy - 3, 10.5) + img(herz, cx - 6, cy + 2, 12, 12);
    } else if (key === MK006_KOORD_LAYOUT) {
      /* Zeigt, was WIRKLICH graviert wird: zwei kompakte Zeilen, so wie es
         mk006KoordGmsAus() liefert. Kein Kartenbild, das etwas anderes
         verspricht als das Ergebnis. */
      body = txt('53\u00b033\'N', cx, cy - 2, 8) + txt('10\u00b000\'E', cx, cy + 10, 8);
    } else if (key === MK006_ROMAN_LAYOUT) {
      body = txt('I\u00b7I\u00b7MMXXVI', cx, cy + 4, 7);
    } else {
      body = txt('Emma', cx, cy + 4, 12);
    }
    return '<svg class="mk006-layout-icon" viewBox="0 0 88 92" aria-hidden="true">' +
      '<rect class="kli-stroke" x="' + (cx - bailW / 2) + '" y="' + (cy - r - bailH + 2) +
        '" width="' + bailW + '" height="' + bailH + '" rx="' + (bailW / 2) + '"/>' +
      '<circle class="kli-stroke" cx="' + cx + '" cy="' + cy + '" r="' + r + '"/>' +
      body +
    '</svg>';
  }
  function buildMk006LayoutCards() {
    /* [1] Mehr als drei Stile: am Handy startet die Liste zugeklappt (erste
       Reihe sichtbar), der Rest hinter dem Aufklapp-Knopf. Bei genau drei
       Stilen bleibt die Liste offen — die Faltung waere reine Kulisse. Die
       Desktop-CSS ignoriert beide Klassen. */
    var faltbar = MK006_CARD_LAYOUTS.length > 3;
    var html = '<div class="mk006-layout-switch' + (faltbar ? ' is-collapsed' : '') + '">';
    for (var i = 0; i < MK006_CARD_LAYOUTS.length; i++) {
      var L = MK006_CARD_LAYOUTS[i];
      html += '<button type="button" class="' + (i === 0 ? 'is-active' : '') +
        (!faltbar || i < 3 ? ' mk006-chip-visible' : '') + '" data-layout="' + L.key + '">' +
        buildMk006LayoutIcon(L.key) +
        '<span class="mk006-layout-name">' + esc(L.label) + '</span>' +
        '<span class="mk006-layout-sub">' + esc(L.sub) + '</span>' +
      '</button>';
    }
    html += '</div>';
    if (faltbar) {
      html += '<button type="button" class="mk006-layout-more">Weitere Gravur-Arten (' +
        (MK006_CARD_LAYOUTS.length - 3) + ') &#9662;</button>';
    }
    return html;
  }

  /* [1] Nach jeder Wahl: aktive Karte sichtbar halten und mit Nachbarn auf
     drei auffuellen. Sortiert wird per CSS (order:-1) — die DOM-Reihenfolge
     bleibt unangetastet, sonst wandern Karten unter den Fingern der Kundin
     weg (K530-Regel). */
  function mk006SyncLayoutCollapse($scope) {
    ($scope && $scope.length ? $scope : $('.up-Fenster-p-personalization-1'))
      .find('.mk006-layout-switch').each(function() {
        var $row = $(this);
        var $more = $row.next('.mk006-layout-more');
        var $chips = $row.find('button[data-layout]');
        if (!$row.hasClass('is-collapsed')) {
          $chips.addClass('mk006-chip-visible');
          if ($more.length) $more.html('Weniger Gravur-Arten &#9652;');
          return;
        }
        var $aktiv = $chips.filter('.is-active');
        $chips.removeClass('mk006-chip-visible');
        $aktiv.addClass('mk006-chip-visible');
        $chips.not($aktiv).slice(0, $aktiv.length ? 2 : 3).addClass('mk006-chip-visible');
        if ($more.length) {
          $more.html('Weitere Gravur-Arten (' + ($chips.length - 3) + ') &#9662;');
        }
      });
  }

  function setupSide(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (!$side.length) return;
    $side.find('.pattles-tab-header').hide();

    if (!$side.find('.mk006-layout-switch').length) {
      /* [3] Alles unterhalb der Kopfzeile steckt in .mk006-side-body — das
         Akkordeon klappt genau diesen einen Knoten zu, der Baum bleibt sonst
         unveraendert (Zaehler, Schriftzeilen und Vorschau laufen weiter). */
      $side.find('.pattles-message-header').after(
        '<div class="mk006-side-body">' +
          buildMk006LayoutCards() +
          '<div class="mk006-dynamic"></div>' +
          '<p class="mk006-side-error">Bitte fülle die Gravur für diese Seite aus.</p>' +
        '</div>'
      );
    }
    setSideLayout(sideIndex, sideLayouts[sideIndex] || '1_zeile');
  }

  function renderAllPreviewEngravings() {
    var $layers = $('[data-mk006-preview-stage] .mk006-preview-layers');
    $layers.empty();
    var zu = getActiveSideCount();

    for (var i = 0; i < zu; i++) {
      var d = getSideData(i);
      var previewMode = getPreviewMode(d);
      var physicalSide = getPhysicalSideIndex(i);
      var sideClass = physicalSide === 1 ? ' mk006-preview-text--back' : ' mk006-preview-text--front';

      /* Koordinaten: zwei Marken uebereinander, aber KEINE Motivlogik und
         kein composeLine — der Text kommt fertig aus dem eigenen Speicher. */
      if (d.layout === MK006_KOORD_LAYOUT) {
        if (!d.line1 && !d.line2) continue;
        appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, d.line1), d.line1, previewMode, 1);
        appendPreviewLine($layers, sideClass + ' mk006-preview-line2', buildPreviewStyle(physicalSide, previewMode, 2, d.line2), d.line2, previewMode, 2);
        continue;
      }

      if (d.layout === MK006_ROMAN_LAYOUT) {
        if (!d.line1) continue;
        appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, d.line1), d.line1, previewMode, 1);
        continue;
      }

      if (d.layout === '2_zeilen') {
        var c1 = composeLine(d.line1, d.sym1);
        var c2 = composeLine(d.line2, d.sym2);
        if (!c1 && !c2) continue;
        if (c1 && c2) {
          appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, c1), c1, previewMode, 1);
          appendPreviewLine($layers, sideClass + ' mk006-preview-line2', buildPreviewStyle(physicalSide, previewMode, 2, c2), c2, previewMode, 2);
          continue;
        }
        if (c1) appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, c1), c1, previewMode, 1);
        else appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, c2), c2, previewMode, 1);
        continue;
      }

      if (d.layout === MK006_TM_LAYOUT) {
        // Zwei eigenstaendige Ebenen: Text oben, Motiv darunter. Fehlt eine,
        // rueckt die andere NICHT nach.
        if (d.line1) {
          appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, d.line1), d.line1, previewMode, 1);
        }
        if (d.sym2) {
          var tmRaw = composeLine('', d.sym2);
          appendPreviewLine($layers, sideClass + ' mk006-preview-line2', buildPreviewStyle(physicalSide, previewMode, 2, tmRaw), tmRaw, previewMode, 2);
        }
        continue;
      }

      var raw = d.layout === 'nur_motiv' ? composeLine('', d.symOnly) : composeLine(d.line1, d.sym1);
      appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, raw), raw, previewMode, 1);
    }
    scheduleFitPreviewTextWidths();
    $layers.find('.mk006-preview-text img').off('load.mk006Fit').on('load.mk006Fit', fitPreviewTextWidths);
    if ($layers.find('.mk006-preview-text img').filter(function() { return this.complete; }).length) {
      fitPreviewTextWidths();
    }
  }


  /* =====================================================================
     FOKUS-Maschinerie (2026-08-19) — Vorbild K530, in der angepassten Form
     von LW041 (dieselbe Vorlagen-Generation, dasselbe Theme-Popup-DOM).
     ===================================================================== */

  function mk006AlleSeiten() {
    return $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
  }

  function mk006SideEl(index) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
  }

  /* Der Scrollkasten ist der Fenster-WURZELknoten (position: fixed,
     overflow-y: auto) — NICHT .fenster-content-inner, die scrollt nie.
     Auf LW100 hat genau diese Verwechslung das Ausweichen tot gelegt. */
  function mk006ScrollEl() {
    return $('.up-Fenster-p-personalization-1').get(0);
  }

  /* Programmatische Spruenge duerfen nichts verstecken: 600 ms Sperre und die
     Vorschau vorher zurueckholen. Der Versatz zieht die angepinnte Vorschau
     ab, damit der Seitenkopf nicht dahinter verschwindet. */
  function mk006ScrollSideIntoView($side) {
    var scrollEl = mk006ScrollEl();
    if (!scrollEl || !$side || !$side.length) return;
    var versatz = 8;
    var $pv = $('.mk006-preview-wrap').first();
    if ($pv.length && $pv.css('position') === 'sticky') versatz += ($pv.outerHeight() || 0);
    var top = $side[0].getBoundingClientRect().top
      - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - versatz;
    scrollEl.scrollTop = Math.max(0, top);
  }

  /* [3] Seiten-Akkordeon: nur bei zwei Gravurflaechen, dann ist immer genau
     eine offen. Der Zustand ueberlebt den Neuaufbau des Fensters. */
  var mk006OffeneSeite = 0;

  function mk006EnsureChevron($side) {
    var $head = $side.children('.pattles-message-header');
    /* Der Titel-<span> bleibt das ERSTE Kind — getSideLabel liest ihn per
       .first(), das Chevron haengt dahinter. */
    if ($head.length && !$head.children('.mk006-side-chev').length) {
      $head.append('<span class="mk006-side-chev" aria-hidden="true">&#9662;</span>');
    }
  }

  function mk006OpenSide(index, scrollen) {
    var $sides = mk006AlleSeiten();
    if (!$sides.filter('.mk006-side--klappbar').length) return;
    mk006OffeneSeite = index;
    $sides.removeClass('is-side-open');
    var $ziel = mk006SideEl(index).addClass('is-side-open');
    /* ★ 2026-09-03: seit die Lagetabellen eine Seiten-Ebene haben, haengt
       JEDER Kontext-Regler an der gerade GEOEFFNETEN Flaeche
       (mk006TunerAuswahl -> ctx.seite -> kontextKey). Ohne diesen Anstoss
       zeigte das Panel nach dem Umklappen noch die Werte der alten Seite und
       schriebe beim naechsten Dreh dorthin zurueck — der Neuaufbau geschieht
       sonst erst beim naechsten updatePreview. */
    if (window.VivTuner && window.VivTuner.refresh) window.VivTuner.refresh('mk006');
    if (scrollen) mk006ScrollSideIntoView($ziel);
  }

  function mk006ApplyAkkordeon(zu) {
    var $sides = mk006AlleSeiten();
    if (zu < 2) {
      /* Eine Flaeche: kein Akkordeon — die Klasse wegnehmen, damit die
         Zuklapp-Regeln nichts verstecken koennen. */
      $sides.removeClass('mk006-side--klappbar').addClass('is-side-open');
      return;
    }
    $sides.addClass('mk006-side--klappbar').each(function() { mk006EnsureChevron($(this)); });
    var ziel = (mk006OffeneSeite >= 0 && mk006OffeneSeite < zu) ? mk006OffeneSeite : 0;
    $sides.removeClass('is-side-open');
    mk006SideEl(ziel).addClass('is-side-open');
    mk006OffeneSeite = ziel;
  }

  function mk006BindAkkordeon() {
    var $popup = $('.up-Fenster-p-personalization-1');
    $popup.off('click.mk006Side', '.mk006-side--klappbar > .pattles-message-header')
      .on('click.mk006Side', '.mk006-side--klappbar > .pattles-message-header', function() {
        var $side = $(this).parent();
        if ($side.hasClass('is-side-open')) return;
        var treffer = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
        if (!treffer) return;
        mk006OpenSide(parseInt(treffer[1], 10), true);
      });
  }

  /* ---- Reglerfenster. Panel-Id endet auf -tuner, Griff traegt .kt-title:
     Ziehen und DE/中 kommen von den gemeinsamen Snippets. ---- */
  function mk006TunerEnabled() {
    return /mk006tuner=1/.test(window.location.search + window.location.hash);
  }

  function mk006TunerApply() {
    var b = document.querySelectorAll('[class*="preview-stage"], [class*="preview-layers"]');
    for (var i = 0; i < b.length; i++) {
      b[i].style.setProperty('--tuner-block-scale', MK006_TUNE.blockScale);
      b[i].style.setProperty('--tuner-motiv-scale', MK006_TUNE.motivScale);
    }
  }

  /* ---- Reglerfenster: feste Vorlage (harte Regel 5), migriert 2026-08-15
     nach lw064/lw100/lw108-Vorbild; Alt-Regler unveraendert im statischen Teil. */
  function mk006TunerSichtbar() {
    var b = document.querySelector('[class*="preview-stage"]');
    if (!b) return false;
    var r = b.getBoundingClientRect();
    return r.width > 0 && r.height > 0
      && r.left < window.innerWidth && r.right > 0
      && r.top < window.innerHeight && r.bottom > 0;
  }
  function mk006Pfad(wurzel, k1, k2) {
    if (!wurzel[k1]) wurzel[k1] = {};
    if (!wurzel[k1][k2]) wurzel[k1][k2] = {};
    return wurzel[k1][k2];
  }
  function mk006IconRegler(seite, modus, slug, feld, standard) {
    /* Beide Wege durch mk006IconAdj/-Setzen: derselbe Schluessel wie im
       Renderpfad. Vorher stand hier der ROHE Layout-Key. */
    return { get: function () {
               var o = mk006IconAdj(seite, modus, slug);
               return o[feld] != null ? o[feld] : standard;
             },
             set: function (v) {
               mk006IconAdjSetzen(seite, modus, slug)[feld] = v;
             } };
  }
  function mk006LuftRegler(modus, font, slug) {
    return { get: function () {
               var v = ((MK006_LUFT_ADJ[modus] || {})[font] || {})[slug];
               if (v != null) return v;
               return (MK006_LUFT_ADJ[font] || {})[slug] || 0;   /* Altwert */
             },
             set: function (v) {
               var o = mk006Pfad(MK006_LUFT_ADJ, modus, font);
               o[slug] = v;
             } };
  }

  /* ══════════════ REGLERFENSTER — VOLLAUSBAU (Ladenstandard) ══════════════
     Bis 2026-08-23 war das hier ein handgeschriebenes Panel (VivTuner.register
     mit selbst zusammengesetzten Listen), aus LW043 abgeschrieben. Genau davor
     warnt snippets/tuner-vorlage.liquid: „Abschriften vererben Luecken" —
     welche Regler existieren, entschied jedes Produkt fuer sich, und was fehlte,
     fiel niemandem auf.

     vollausbau() dreht das um: hier steht nur noch der STECKBRIEF (Schriften,
     Motive, Layouts) und je Reglerfamilie ein ZUGRIFF auf die Konfigtabelle.
     WELCHE Familien es geben muss, steht in der Vorlage — deckungsgleich mit
     scripts/tuner_audit.py. Fehlt ein Zugriff, zeigt das Panel eine rote
     FEHLT-Zeile; ein begruendetes „gibt es hier nicht" wird als grauer Text
     zurueckgegeben und ist damit eine Entscheidung im Fenster statt im Kopf.
     Die Beschriftungen baut die Vorlage kanonisch, nicht dieses Snippet. */

  /* Beim Umbau auf vollausbau versehentlich mitgeloescht und sofort von der
     Pruefung gefangen (ReferenceError im Panelaufbau). Steht deshalb bewusst
     direkt ueber seinem einzigen Aufrufer. */
  function mk006AnzahlSeiten() {
    var dom = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return dom > 0 ? dom : previewSideCount;
  }

  function mk006TunerAuswahl() {
    var sichtbar = mk006TunerSichtbar();
    var font = getGlobalFont().font_name || 'G02';
    var n = mk006AnzahlSeiten();
    /* Bezugspunkt ist die zuletzt GEOEFFNETE Flaeche; bei zugeklappter
       Rueckseite waere ein Regler fuer sie unsichtbar wirkungslos. */
    var uiIdx = 0;
    for (var i = 0; i < n; i++) {
      var $s = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      if ($s.length && $s.hasClass('is-side-open')) { uiIdx = i; break; }
    }
    var seite = getPhysicalSideIndex(uiIdx) === 1 ? 'back' : 'front';
    var modus = getSideLayout(uiIdx) || '1_zeile';
    /* Motivtraeger: bei „Text oben, Motiv unten" liegt das Motiv auf Zeile 2,
       bei „Nur Motiv" auf Zeile 1. */
    /* Stile ohne Motiv duerfen keinen Slug melden — sonst stuende D1
       („Detail je Motiv") im Fenster und regelte ein Bild, das dieser Stil
       gar nicht zeigt. Der Speicher der 1. Zeile kann aus einem frueheren
       Stil noch belegt sein. */
    var symbol = mk006IstFesteSchriftStil(modus)
      ? '' : getLineSymbol(uiIdx, modus === MK006_TM_LAYOUT ? 2 : 1);
    return {
      titel: (seite === 'back' ? 'Rückseite' : 'Vorderseite') + ' · ' + modus + ' · ' + font,
      sichtbar: sichtbar, font: font, uiIdx: uiIdx, seite: seite, modus: modus,
      symbol: symbol, slug: symbol ? symbolSlug(symbol) : ''
    };
  }

  var MK006_TUNER_ZUGRIFF = {
    /* --- Gesamtebene: liegt ueber allem, unabhaengig von der Auswahl ------ */
    G3: function () { return [
      { achse: 'x', step: 0.25, get: function () { return MK006_TUNE.blockDx; },
        set: function (v) { MK006_TUNE.blockDx = v; } },
      { achse: 'y', step: 0.25, get: function () { return MK006_TUNE.blockDy; },
        set: function (v) { MK006_TUNE.blockDy = v; } }
    ]; },
    G4: function () { return [
      { step: 0.02, get: function () { return MK006_TUNE.blockScale; },
        set: function (v) { MK006_TUNE.blockScale = v; } }
    ]; },
    G1: function () { return [
      { achse: 'x', step: 0.02, get: function () { return MK006_TUNE.motivDx; },
        set: function (v) { MK006_TUNE.motivDx = v; } },
      { achse: 'y', step: 0.02, get: function () { return MK006_TUNE.motivDy; },
        set: function (v) { MK006_TUNE.motivDy = v; } }
    ]; },
    G2: function () { return [
      { step: 0.02, get: function () { return MK006_TUNE.motivScale; },
        set: function (v) { MK006_TUNE.motivScale = v; } }
    ]; },

    /* --- Kontextebene: folgt der Auswahl im Fenster ----------------------- */
    D2: function (ctx) {
      if (!ctx || !ctx.sichtbar) return [];
      if (ctx.modus === 'nur_motiv') {
        return 'Bei \u201eNur Motiv" gibt es keine Schriftebene — istSchriftEbene() '
             + 'liefert dort immer false, es steht kein Zeichen auf der Scheibe, '
             + 'das eine Textgroesse skalieren koennte. Der Regler stand hier bis '
             + '2026-09-03 trotzdem und schrieb still in die Zelle der fremden '
             + 'Vorlage \u201e1 Zeile".';
      }
      if (mk006IstFesteSchriftStil(ctx.modus)) {
        return 'Koordinaten und r\u00f6mische Zahlen gravieren in FESTER Schrift ('
             + MK006_FESTE_SCHRIFT + ') — Gradzeichen und Zahlzeichen sehen in den '
             + 'Schreibschriften unruhig aus (Regel von K532/HK004 uebernommen). Ein '
             + 'Regler je Schrift h\u00e4tte hier nichts zu regeln: die Schrift wechselt nie. '
             + 'Gr\u00f6\u00dfe und Lage laufen ueber G3/G4 und die Breitenkappe LB.';
      }
      var f = ctx.font;
      var vN = MK006_MODUS_NAME[ctx.modus] || ctx.modus;
      /* Auch die GROESSE haengt an (Vorlage, Schrift) — sonst waere sie das
         letzte vorlagenuebergreifend gekoppelte Stueck. */
      var sD2 = ctx.seite;
      return [{ suffix: vN + ' · ' + f, step: 0.02,
        get: function () { var o = mk006SchriftLage(sD2, ctx.modus, f); return o.scale != null ? o.scale : 1; },
        set: function (v) { mk006SchriftLageSetzen(sD2, ctx.modus, f).scale = v; } }];
    },
    D1: function (ctx) {
      if (!ctx || !ctx.sichtbar) return [];
      if (!ctx.slug) return [];
      var r = mk006IconRegler(ctx.seite, ctx.modus, ctx.slug, 'scale', 1);
      return [{ suffix: ctx.symbol, step: 0.05, get: r.get, set: r.set }];
    },
    D3: function (ctx) {
      if (!ctx || !ctx.sichtbar) return [];
      if (ctx.modus === 'nur_motiv') {
        return 'Bei „Nur Motiv" steht kein Text neben dem Bild — ein Abstand '
             + 'zwischen Schrift und Motiv existiert in diesem Stil nicht.';
      }
      if (mk006IstFesteSchriftStil(ctx.modus)) {
        return 'In diesen zwei Stilen steht \u00fcberhaupt kein Motiv auf der Scheibe — '
             + 'es gibt nichts, wozu die Schrift Abstand halten k\u00f6nnte.';
      }
      if (!ctx.slug) return [];
      if (ctx.modus === MK006_TM_LAYOUT) {
        var rt = mk006TmAbstandRegler(ctx.font, ctx.slug);
        return [{ suffix: ctx.font + '×' + ctx.symbol, step: 0.1, get: rt.get, set: rt.set }];
      }
      var r = mk006LuftRegler(ctx.modus, ctx.font, ctx.slug);
      return [{ suffix: ctx.font + '×' + ctx.symbol, step: 0.02, get: r.get, set: r.set }];
    },

    /* K1/K2 tragen im Ladenstandard die Lage von Text bzw. Motiv im
       Kombi-Layout. Bei MK006 ist das „Text oben, Motiv unten". */
    K1: function (ctx) {
      if (!ctx || !ctx.sichtbar) return [];
      if (ctx.modus !== MK006_TM_LAYOUT) return [];
      var f = ctx.font, s = ctx.seite;
      return [
        { achse: 'x', step: 0.25, get: function () { return mk006TmTextNudge(s, f).dx || 0; },
          set: function (v) { mk006TmTextNudgeSetzen(s, f).dx = v; } },
        { achse: 'y', step: 0.25, get: function () { return mk006TmTextNudge(s, f).dy || 0; },
          set: function (v) { mk006TmTextNudgeSetzen(s, f).dy = v; } }
      ];
    },
    K2: function (ctx) {
      if (!ctx || !ctx.sichtbar) return [];
      if (ctx.modus !== MK006_TM_LAYOUT) return [];
      var f = ctx.font, s = ctx.seite;
      return [
        { achse: 'x', step: 0.25, get: function () { return mk006Kombi(s, MK006_TM_LAYOUT, f).motivDx || 0; },
          set: function (v) { mk006KombiSetzen(s, MK006_TM_LAYOUT, f).motivDx = v; } },
        { achse: 'y', step: 0.25, get: function () { return mk006Kombi(s, MK006_TM_LAYOUT, f).motivDy || 0; },
          set: function (v) { mk006KombiSetzen(s, MK006_TM_LAYOUT, f).motivDy = v; } }
      ];
    },

    LB: function (ctx) {
      if (!ctx || !ctx.sichtbar) return [];
      if (ctx.modus === 'nur_motiv') {
        return 'Die Breitenkappe fasst nur Textzeilen an: fitPreviewTextWidths() '
             + 'waehlt .mk006-preview-text--1-zeile und --2-zeilen aus, '
             + '\u201eNur Motiv" traegt --nur-motiv und wird nie erfasst. Ein '
             + 'Deckel ohne etwas zu deckeln — die Motivgroesse regeln D1 '
             + '(dieses Motiv) und G2 (alle Motive).';
      }
      return [{ step: 0.5, get: function () { return MK006_TUNE.limitBreite; },
                set: function (v) { MK006_TUNE.limitBreite = v; } }];
    },
    /* Der Renderpfad kappt nur die BREITE. Eine Hoehenkappe gaebe es nur mit
       einer zweiten Messung im Zeilenumbruch — die gibt es hier nicht, und ein
       Regler ohne Wirkung waere schlimmer als keiner (E367). */
    LH: function () {
      return 'MK006 kappt nur die Breite (fitPreviewTextWidths). Eine Hoehenkappe '
           + 'ist im Renderpfad nicht vorgesehen.';
    }
  };

  /* Produkteigene Regler, die in keine der neun Familien gehoeren. Sie stehen
     bewusst NACH den Familien, damit der Standardteil oben immer gleich
     aussieht — egal welches Produkt. */
  function mk006TunerStatischExtra() {
    var T = MK006_TUNE;
    var it = [
      { h: 'Geburtsstein' },
      { label: 'Stein ↔ X %', step: 0.1, get: function () { return T.stein.dx; }, set: function (v) { T.stein.dx = v; } },
      { label: 'Stein ↕ Y %', step: 0.1, get: function () { return T.stein.dy; }, set: function (v) { T.stein.dy = v; } },
      { label: 'Stein-Größe ×', step: 0.02, get: function () { return T.stein.scale; }, set: function (v) { T.stein.scale = v; } },
      { label: 'Stein-Drehung °', step: 1, get: function () { return T.stein.rot; }, set: function (v) { T.stein.rot = v; } },
      { h: '2. Zeile — global (ueber allen Schriften)' },
      { label: '2. Zeile ↔ X %', step: 0.25, get: function () { return T.zeile2.dx; }, set: function (v) { T.zeile2.dx = v; } },
      { label: '2. Zeile ↕ Y %', step: 0.25, get: function () { return T.zeile2.dy; }, set: function (v) { T.zeile2.dy = v; } },
      { label: 'Limit: Breite Zeile 2 ×', step: 0.02,
        get: function () { return T.limitBreiteZeile2; }, set: function (v) { T.limitBreiteZeile2 = v; } }
    ];
    return it;
  }

  function mk006TunerKontextExtra(ctx) {
    if (!ctx || !ctx.sichtbar) return [];
    var it = [];
    var f = function () { return getGlobalFont().font_name || 'G02'; };
    /* ★ Die Seite, die im Panel GERADE bearbeitet wird (mk006TunerAuswahl
       nimmt die aufgeklappte Flaeche). Alle Lage-Regler haengen daran —
       sonst schoebe ein Dreh an der Rueckseite die Vorderseite mit. */
    var seite = ctx.seite;
    var sN = (seite === 'back' ? 'Rückseite' : 'Vorderseite');

    if (isZeilenLikeMode(ctx.modus)) {
      var zl = function () { return mk006ZeilenLageSetzen(seite, f()); };
      it.push({ h: '2 Zeilen · ' + ctx.font + ' · ' + sN });
      it.push({ label: '1. Zeile ↔ X %', step: 0.25,
        get: function () { return mk006ZeilenLage(seite, f()).z1dx || 0; }, set: function (v) { zl().z1dx = v; } });
      it.push({ label: '1. Zeile ↕ Y %', step: 0.25,
        get: function () { return mk006ZeilenLage(seite, f()).z1dy || 0; }, set: function (v) { zl().z1dy = v; } });
      it.push({ label: '2. Zeile ↔ X %', step: 0.25,
        get: function () { return mk006ZeilenLage(seite, f()).z2dx || 0; }, set: function (v) { zl().z2dx = v; } });
      it.push({ label: '2. Zeile ↕ Y %', step: 0.25,
        get: function () { return mk006ZeilenLage(seite, f()).z2dy || 0; }, set: function (v) { zl().z2dy = v; } });
      it.push({ label: 'Zeilenabstand %', step: 0.25,
        get: function () { return mk006ZeilenLage(seite, f()).abstand || 0; }, set: function (v) { zl().abstand = v; } });
      it.push({ label: 'Größe 1. Zeile ×', step: 0.02,
        get: function () { var v = mk006ZeilenGroesse(f()).zeile1; return v == null ? 1 : v; },
        set: function (v) { mk006ZeilenGroesseSetzen(f()).zeile1 = v; } });
      it.push({ label: 'Größe 2. Zeile ×', step: 0.02,
        get: function () { var v = mk006ZeilenGroesse(f()).zeile2; return v == null ? 1 : v; },
        set: function (v) { mk006ZeilenGroesseSetzen(f()).zeile2 = v; } });
    }

    /* Eigene Regler statt Mitbenutzung der „2 Zeilen"-Reihe: diese Stile
       lesen keine Schriftzelle, die dortigen Regler waeren hier tot. */
    if (ctx.modus === MK006_KOORD_LAYOUT) {
      var kl = mk006SeitenTeilSetzen(MK006_KOORD_LAGE, seite);
      it.push({ h: 'Koordinaten (feste Schrift ' + MK006_FESTE_SCHRIFT + ') · ' + sN });
      it.push({ label: 'Koord. 1. Zeile ↔ X %', step: 0.25,
        get: function () { return kl.z1dx || 0; }, set: function (v) { kl.z1dx = v; } });
      it.push({ label: 'Koord. 1. Zeile ↕ Y %', step: 0.25,
        get: function () { return kl.z1dy || 0; }, set: function (v) { kl.z1dy = v; } });
      it.push({ label: 'Koord. 2. Zeile ↔ X %', step: 0.25,
        get: function () { return kl.z2dx || 0; }, set: function (v) { kl.z2dx = v; } });
      it.push({ label: 'Koord. 2. Zeile ↕ Y %', step: 0.25,
        get: function () { return kl.z2dy || 0; }, set: function (v) { kl.z2dy = v; } });
      it.push({ label: 'Koord. Zeilenabstand %', step: 0.25,
        get: function () { return kl.abstand || 0; }, set: function (v) { kl.abstand = v; } });
      it.push({ label: 'Koord. Gr\u00f6\u00dfe \u00d7', step: 0.02,
        get: function () { return kl.groesse == null ? 1 : kl.groesse; }, set: function (v) { kl.groesse = v; } });
    }

    if (ctx.modus === MK006_ROMAN_LAYOUT) {
      var rl = mk006SeitenTeilSetzen(MK006_ROMAN_LAGE, seite);
      it.push({ h: 'R\u00f6mische Zahlen (feste Schrift ' + MK006_FESTE_SCHRIFT + ') · ' + sN });
      it.push({ label: 'R\u00f6m. Zahlen ↔ X %', step: 0.25,
        get: function () { return rl.dx || 0; }, set: function (v) { rl.dx = v; } });
      it.push({ label: 'R\u00f6m. Zahlen ↕ Y %', step: 0.25,
        get: function () { return rl.dy || 0; }, set: function (v) { rl.dy = v; } });
    }

    if (ctx.modus === MK006_TM_LAYOUT) {
      it.push({ h: 'Text oben, Motiv unten · ' + ctx.font + ' · ' + sN });
      it.push({ label: 'Kombi: Motiv-Größe ×', step: 0.02,
        get: function () { var w = mk006Kombi(seite, MK006_TM_LAYOUT, f()).motivMult; return w == null ? 1 : w; },
        set: function (v) { mk006KombiSetzen(seite, MK006_TM_LAYOUT, f()).motivMult = v; } });
      it.push({ label: 'Kombi: Abstand (Font)', step: 0.1,
        get: function () { return mk006Kombi(seite, MK006_TM_LAYOUT, f()).gap || 0; },
        set: function (v) { mk006KombiSetzen(seite, MK006_TM_LAYOUT, f()).gap = v; } });
    }

    /* Lage des einzelnen Motivs. Die GROESSE dazu ist D1 und steht oben im
       Standardteil — hier nur, was dort keinen Platz hat. */
    if (ctx.slug) {
      var ix = mk006IconRegler(ctx.seite, ctx.modus, ctx.slug, 'dx', 0),
          iy = mk006IconRegler(ctx.seite, ctx.modus, ctx.slug, 'dy', 0);
      it.push({ h: 'Motiv · ' + ctx.symbol });
      it.push({ label: 'Motiv ↔ X %', step: 0.02, get: ix.get, set: ix.set });
      it.push({ label: 'Motiv ↕ Y %', step: 0.02, get: iy.get, set: iy.set });
    }

    /* Lage je Schriftart — ALLE VIER nebeneinander, aber fuer die gerade
       gewaehlte Gravur-Art. Der Vorlagenname steht in jeder Beschriftung:
       zwei Sitzungen zuvor stand hier nur die aktive Schrift (Yin: „Fenster
       verschwunden"), davor galten die Werte fuer alle Vorlagen zugleich
       (Yin: „调完文字后再去调图标，它的位置就又变了"). Beides behoben:
       vier Schriften sichtbar, Vorlagen getrennt, Zugehoerigkeit lesbar. */
    var vName = MK006_MODUS_NAME[ctx.modus] || ctx.modus;
    /* Nicht fuer die Stile mit fester Schrift: mk006SchriftModus() gibt fuer
       sie NULL, mk006SchriftLageSetzen() liefert dann ein Wegwerf-Objekt —
       acht Regler, die sich drehen lassen und nichts bewegen. */
    if (ctx.modus !== 'nur_motiv' && !mk006IstFesteSchriftStil(ctx.modus)) {
      it.push({ h: 'Schriftlage · ' + vName + ' · ' + sN + ' (gilt NUR hier)' });
      ['G02', 'G04', 'G05', 'G06'].forEach(function (code) {
        it.push({ label: vName + ' · ' + code + ': Text ↔ X %', step: 0.25,
          get: function () { return mk006SchriftLage(seite, ctx.modus, code).dx || 0; },
          set: function (v) { mk006SchriftLageSetzen(seite, ctx.modus, code).dx = v; } });
        it.push({ label: vName + ' · ' + code + ': Text ↕ Y %', step: 0.25,
          get: function () { return mk006SchriftLage(seite, ctx.modus, code).dy || 0; },
          set: function (v) { mk006SchriftLageSetzen(seite, ctx.modus, code).dy = v; } });
      });
    }
    return it;
  }

  function mk006TunerExport() {
    return { TUNE: MK006_TUNE, ICON_ADJ: MK006_ICON_ADJ, LUFT_ADJ: MK006_LUFT_ADJ,
             KOMBI_BY_FONT: MK006_KOMBI_BY_FONT,
             TM_TEXT_NUDGE_BY_FONT: MK006_TM_TEXT_NUDGE_BY_FONT,
             ZEILEN_GROESSE_BY_FONT: MK006_ZEILEN_GROESSE_BY_FONT,
             ZEILEN_LAGE_BY_FONT: MK006_ZEILEN_LAGE_BY_FONT,
             TM_ABSTAND_BY_FONT_ICON: MK006_TM_ABSTAND_BY_FONT_ICON,
             SCHRIFT_LAGE_BY_MODUS: MK006_SCHRIFT_LAGE_BY_MODUS,
             KOORD_LAGE: MK006_KOORD_LAGE, ROMAN_LAGE: MK006_ROMAN_LAGE };
  }

  /* Zwei Schritte, nicht einer: ein fremder ALT-Stub (ein anderes Produkt hat
     zuerst geladen, ohne vollausbau) wuerde den Aufruf sonst werfen. */
  window.VivTuner = window.VivTuner || { q: [], refresh: function () {},
    register: function () { this.q.push(arguments); return { refresh: function () {} }; } };
  if (!window.VivTuner.vollausbau) {
    window.VivTuner.vollausbau = function () { this.q.push({ va: arguments }); return { refresh: function () {} }; };
  }
  window.VivTuner.vollausbau('mk006', {
    titel: 'MK006 Tuner',
    schriften: ['G02', 'G04', 'G05', 'G06'],
    motive: MK006_SYMBOLS_FIXED.map(function (s2) { return s2.code; }),
    layouts: { kombi: [MK006_TM_LAYOUT] },
    auswahl: mk006TunerAuswahl,
    zugriff: MK006_TUNER_ZUGRIFF,
    statischExtra: mk006TunerStatischExtra,
    kontextExtra: mk006TunerKontextExtra,
    update: function () { window.lw043UpdatePreview(); },
    exportiere: mk006TunerExport
  });

  window.lw043UpdatePreview = function() {
    /* Ohne diesen Refresh bleibt der Kontext-Teil des Panels beim ersten
       Zustand stehen (A184-Lektion). */
    if (window.VivTuner) VivTuner.refresh('mk006');
    mk006TunerApply();
    ensurePreviewShell();
    var baseUrl = getColorPreviewUrl();
    var $stage = $('[data-mk006-preview-stage]');
    $stage.find('.mk006-preview-base').attr('src', baseUrl);
    var $gem = $stage.find('.mk006-preview-gem');
    if (isEngravingOnlyPopup) {
      $gem.hide();
    } else {
      var gemUrl = MK006_GEBURTSSTEIN_FILES[getSelectedGeburtssteinValue()] || '';
      if (gemUrl) {
        /* Der Stein sitzt IMMER auf der Vorderseite (linke Kette bzw. das
           einzel-Bild). Die rechte Kette zeigt die glatte Herzrueckseite —
           dort gehoert kein Stein hin, deshalb gibt es bewusst nur EINE
           Gem-Ebene und keine je Slot. Beide Modi teilen sich diese Lage,
           weil das einzel-Bild die byteidentische linke Haelfte des
           paar-Bilds ist (docs/PREVIEW-UPLOAD-MK006.md). */
        var ST = MK006_TUNE.stein || { dx: 0, dy: 0, scale: 1, rot: 0 };
        var gemStyle = 'top:' + (PREVIEW_GEM.top + (ST.dy || 0)) + '%;' +
          'left:' + (PREVIEW_GEM.left + (ST.dx || 0)) + '%;' +
          'width:' + (PREVIEW_GEM.width * (ST.scale == null ? 1 : ST.scale)) + '%;' +
          'transform:translate(-50%,-50%) rotate(' + ((PREVIEW_GEM.rotate || 0) + (ST.rot || 0)) + 'deg);';
        $gem.attr('src', gemUrl).attr('style', gemStyle).show();
      } else {
        $gem.hide();
      }
      $('[data-mk006-geburtsstein-label]').text(formatGeburtssteinLabel(getSelectedGeburtssteinValue()) || '—');
    }
    renderAllPreviewEngravings();
    mk006SyncFontProbe();   // lebende Probe folgt der Eingabe
  };

  function bindEvents() {
    var $popup = $('.up-Fenster-p-personalization-1');

    $popup.off('click.mk006Layout', '.mk006-layout-switch button').on('click.mk006Layout', '.mk006-layout-switch button', function() {
      var idx = getSideIndexFromEl($(this));
      if (isNaN(idx)) return;
      /* [1] Nach der Wahl faltet die Liste wieder zu (K530-Verhalten): die
         gewaehlte Karte rutscht per CSS-order nach vorn und bleibt sichtbar,
         die uebrigen verschwinden wieder hinter dem Knopf. */
      $(this).closest('.mk006-layout-switch').addClass('is-collapsed');
      setSideLayout(idx, $(this).data('layout'));
    });

    $popup.off('click.mk006Font', '[data-mk006-font-grid] button').on('click.mk006Font', '[data-mk006-font-grid] button', function() {
      var $pf = $(this).closest('.mk006-panel-font');
      globalFont = { font_name: $(this).data('font'), text: $(this).data('family') };
      // renderFontGrid setzt den aktiven Zustand in ALLEN Rastern (global +
      // jedes Panel) und zieht ueber syncPanelFontUI die neue Schrift in die
      // Koepfe. Danach die eigene Zeile zuklappen — der Kopf zeigt jetzt die
      // gewaehlte Schrift als lebende Probe.
      renderFontGrid();
      if ($pf.length) {
        $pf.removeClass('is-open').find('.mk006-panel-font-head').attr('aria-expanded', 'false');
      }
      applyFontToInputs();
      applyLineLimitsForFont();
      window.lw043UpdatePreview();
    });

    /* [2] Schriftzeile im Panel. Spiegel-Zeilen waehlen NICHT selbst:
       1. Tipp klappt den Hinweis auf (--zu faellt), 2. Tipp springt zur
       waehlbaren Zeile — und oeffnet vorher deren Gravurflaeche [3]. */
    $popup.off('click.mk006PanelFont', '.mk006-panel-font-head').on('click.mk006PanelFont', '.mk006-panel-font-head', function() {
      var $pf = $(this).closest('.mk006-panel-font');
      if ($pf.hasClass('mk006-panel-font--spiegel')) {
        if ($pf.hasClass('mk006-panel-font--zu')) {
          $pf.removeClass('mk006-panel-font--zu');
          return;
        }
        var $primary = $popup.find('.mk006-panel-font').not('.mk006-panel-font--spiegel').first();
        if (!$primary.length) return;
        var $pSide = $primary.closest('[class*="product_info_main_"]');
        var treffer = String($pSide.attr('class') || '').match(/product_info_main_(\d+)/);
        if (treffer) mk006OpenSide(parseInt(treffer[1], 10), false);
        $primary.addClass('is-open').find('.mk006-panel-font-head').attr('aria-expanded', 'true');
        mk006ScrollSideIntoView($primary);
        return;
      }
      var open = !$pf.hasClass('is-open');
      $pf.toggleClass('is-open', open);
      $(this).attr('aria-expanded', open ? 'true' : 'false');
    });

    // „zum Ändern tippen" auf dem Hinweistext selbst → gleicher Sprung
    $popup.off('click.mk006PanelFontHinweis', '.mk006-panel-font--spiegel .mk006-panel-font-hinweis')
      .on('click.mk006PanelFontHinweis', '.mk006-panel-font--spiegel .mk006-panel-font-hinweis', function() {
        $(this).closest('.mk006-panel-font').find('.mk006-panel-font-head').trigger('click');
      });

    /* [1] Aufklapp-Knopf unter den Stilkarten (nur am Handy sichtbar). */
    $popup.off('click.mk006More', '.mk006-layout-more').on('click.mk006More', '.mk006-layout-more', function() {
      $(this).prev('.mk006-layout-switch').toggleClass('is-collapsed');
      mk006SyncLayoutCollapse($(this).closest('[class*="product_info_main_"]'));
    });

    $popup.off('input.mk006Line', '.mk006-line-input:not([readonly])').on('input.mk006Line', '.mk006-line-input:not([readonly])', function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      var lineNum = $input.attr('data-line');
      var maxLen = getLineMaxLen(lineNum, idx);
      if (isUppercaseOnlyFont()) {
        setG08LineRaw($input, idx, lineNum, $input.val(), maxLen);
        syncSymbolGridForLine(idx, lineNum);
        updateLineCounter($input);
        window.lw043UpdatePreview();
        return;
      }
      var parsed = parseLineValue(($input.val() || '').replace(/[\r\n]/g, ''));
      setLineSymbol(idx, lineNum, parsed.symbol);
      var text = normalizeLineTextForFont(parsed.text);
      var symbol = parsed.symbol || getLineSymbol(idx, lineNum);
      while (weightedLength(composeLine(text, symbol)) > maxLen && text.length) {
        text = text.slice(0, -1);
      }
      syncLineInputComposed($input, text, symbol);
      syncSymbolGridForLine(idx, lineNum);
      updateLineCounter($input);
      window.lw043UpdatePreview();
    });

    $popup.off('click.mk006Symbol', '.mk006-symbol-grid button').on('click.mk006Symbol', '.mk006-symbol-grid button', function() {
      var $grid = $(this).closest('.mk006-symbol-grid');
      var idx = parseInt($grid.attr('data-side'), 10);
      var lineNum = $grid.attr('data-line');
      var symName = normalizeStoredSymbol($(this).data('symbol'));
      var layout = getSideLayout(idx);
      var maxLen = getLineMaxLen(lineNum, idx);

      if (layout === 'nur_motiv') {
        setLineSymbol(idx, 1, symName);
        syncSymbolGridForLine(idx, 1);
        var $display = $('.product_info_main_' + idx).find('.mk006-motiv-display');
        syncLineInputComposed($display, '', symName);
        window.lw043UpdatePreview();
        return;
      }

      if (layout === MK006_TM_LAYOUT) {
        // Kein Textfeld dahinter — nochmal tippen waehlt ab, sonst kaeme man
        // nie wieder auf „kein Motiv" zurueck.
        var schonDa = getLineSymbol(idx, 2) === symName;
        setLineSymbol(idx, 2, schonDa ? '' : symName);
        syncSymbolGridForLine(idx, 2);
        window.lw043UpdatePreview();
        return;
      }

      var $input = $('.product_info_main_' + idx).find('.mk006-line-input[data-line="' + lineNum + '"]');
      if (isUppercaseOnlyFont()) {
        var g08Raw = getG08LineRaw($input, idx, lineNum);
        var g08Next = appendOrReplaceTrailingG08Symbol(g08Raw, symName);
        if (weightedLength(g08Next) > maxLen) return;
        setG08LineRaw($input, idx, lineNum, g08Next, maxLen);
        syncSymbolGridForLine(idx, lineNum);
        updateLineCounter($input);
        window.lw043UpdatePreview();
        return;
      }

      var parsed = parseLineValue($input.val() || '');
      if (weightedLength(composeLine(parsed.text, symName)) > maxLen) return;

      setLineSymbol(idx, lineNum, symName);
      syncLineInputComposed($input, parsed.text, symName);
      syncSymbolGridForLine(idx, lineNum);
      updateLineCounter($input);
      window.lw043UpdatePreview();
    });

    $popup.off('click.mk006Clear', '.mk006-line-clear').on('click.mk006Clear', '.mk006-line-clear', function() {
      var $input = $(this).siblings('.mk006-line-input');
      var idx = getSideIndexFromEl($input);
      var lineNum = $input.attr('data-line') || '1';
      setLineSymbol(idx, lineNum, '');
      $input.val('');
      toggleLineClear($input, '');
      syncSymbolGridForLine(idx, lineNum);
      if ($input.attr('data-max')) updateLineCounter($input);
      window.lw043UpdatePreview();
    });

    /* ---- Koordinaten: Suchen -> Fund zeigen -> Uebernehmen ---------------
       Zweistufig wie bei K532/R002 und aus gutem Grund: die Kundin muss den
       gefundenen ORT lesen koennen, bevor die Gradangabe zur Gravur wird.
       Der Wecker kommt von R002 — bleibt die Antwort aus (Maps-Skript
       blockiert, Netz weg, Schluessel nicht fuer diese Domain freigegeben),
       darf „Suche …" nicht ewig stehen bleiben. */
    $popup.off('keydown.mk006Koord', '.mk006-koord-input').on('keydown.mk006Koord', '.mk006-koord-input', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); $(this).closest('.mk006-panel').find('.mk006-koord-btn').trigger('click'); }
    });
    $popup.off('click.mk006KoordSuche', '.mk006-koord-btn').on('click.mk006KoordSuche', '.mk006-koord-btn', function() {
      var $panel = $(this).closest('.mk006-panel');
      var adr = $.trim($panel.find('.mk006-koord-input').val() || '');
      var $status = $panel.find('.mk006-koord-status').removeClass('is-bad');
      var $ergebnis = $panel.find('.mk006-koord-result');
      if (!adr) { $ergebnis.hide(); $status.addClass('is-bad').text('Bitte einen Ort eingeben.'); return; }
      $status.text('Suche \u2026');
      var fertig = false;
      var wecker = setTimeout(function() {
        if (fertig) return; fertig = true;
        $ergebnis.hide();
        $status.addClass('is-bad').text('Die Suche ist gerade nicht erreichbar. Bitte sp\u00e4ter noch einmal.');
      }, 12000);
      mk006GeocodeAddress(adr, function(lat, lon, gefunden) {
        if (fertig) return; fertig = true; clearTimeout(wecker);
        var gms = mk006KoordGmsAus(lat, lon);
        $panel.find('.mk006-koord-pending-gms').val(gms);
        $panel.find('.mk006-koord-pending-address').val(gefunden || adr);
        $panel.find('.mk006-koord-found').text(gefunden || adr);
        $panel.find('.mk006-koord-gmshint').text(mk006KoordEinzeilig(gms));
        $status.text('');
        $ergebnis.show();
      }, function(grund) {
        if (fertig) return; fertig = true; clearTimeout(wecker);
        $ergebnis.hide();
        $status.addClass('is-bad').text(grund === 'not-found'
          ? 'Diesen Ort haben wir nicht gefunden \u2014 bitte anders schreiben.'
          : 'Die Suche ist gerade nicht erreichbar. Bitte sp\u00e4ter noch einmal.');
      });
    });
    $popup.off('click.mk006KoordUeber', '.mk006-koord-confirm').on('click.mk006KoordUeber', '.mk006-koord-confirm', function() {
      var $panel = $(this).closest('.mk006-panel');
      var gms = $.trim($panel.find('.mk006-koord-pending-gms').val() || '');
      if (!gms) return;
      var idx = getSideIndexFromEl($panel);
      if (isNaN(idx)) return;
      /* Ab hier liegt der Wert im EIGENEN Speicher der Seite, nicht in einem
         Zeilenfeld: der Kartenwechsel raeumt das Panel weg, den Speicher
         nicht. Der gesuchte Ort faehrt mit, wird aber nicht graviert. */
      mk006SetKoord(idx, gms, $.trim($panel.find('.mk006-koord-pending-address').val() || ''));
      $panel.find('.mk006-koord-result').hide();
      $panel.find('.mk006-koord-status').removeClass('is-bad')
        .text('\u2713 \u00dcbernommen: ' + mk006KoordEinzeilig(gms));
      $panel.closest('[class*="product_info_main_"]').removeClass('has-error').find('.mk006-side-error').hide();
      window.lw043UpdatePreview();
    });

    /* ---- Roemische Zahlen: Umrechnung live beim Tippen (K532) ----------- */
    $popup.off('input.mk006Roman', '.mk006-roman-input').on('input.mk006Roman', '.mk006-roman-input', function() {
      var $in = $(this);
      var idx = getSideIndexFromEl($in);
      if (isNaN(idx)) return;
      mk006SetRomanDatum(idx, $in.val() || '');
      mk006RomanStatusZeigen($in.closest('.mk006-panel'), $in.val() || '');
      $in.closest('[class*="product_info_main_"]').removeClass('has-error').find('.mk006-side-error').hide();
      window.lw043UpdatePreview();
    });
    $popup.off('keydown.mk006Roman', '.mk006-roman-input').on('keydown.mk006Roman', '.mk006-roman-input', function(e) {
      if (e.key === 'Enter') e.preventDefault();
    });

    if (!window._mk006PreviewFitResize) {
      window._mk006PreviewFitResize = true;
      $(window).on('resize.mk006PreviewFit', fitPreviewTextWidths);
    }
  }

  window.lw043ValidateBeforeOpen = function() {
    if (isEngravingOnlyPopup) {
      return true;
    }
    if (!getSelectedGeburtssteinValue()) {
      alert('Bitte wähle zuerst einen Geburtsstein aus.');
      return false;
    }
    return true;
  };

  window.lw043AfterUpdateSize = function(zu) {
    var gravurConfig = getActiveGravurConfig();
    if (gravurConfig && gravurConfig.physicalSides) {
      setPhysicalSideMap(gravurConfig.physicalSides);
    } else {
      var parsedZu = parseInt(zu, 10) || 0;
      var defaultMap = [];
      for (var mapIndex = 0; mapIndex < parsedZu; mapIndex++) defaultMap.push(mapIndex);
      setPhysicalSideMap(defaultMap);
    }

    zu = parseInt(zu, 10) || 0;
    if (zu < 1) {
      return;
    }
    zu = Math.min(zu, 2);
    previewSideCount = zu;
    ensurePreviewShell();
    for (var i = 0; i < zu; i++) setupSide(i);
    ensureAs022GlobalFontForLayout();
    renderFontGrid();
    applyFontToInputs();
    bindEvents();
    mk006ApplyAkkordeon(zu);
    mk006BindAkkordeon();
    mk006SyncLayoutCollapse();
    window.lw043UpdatePreview();
  };

  window.lw043OnPopupOpen = function() {
    symbolsCache = null;
    fontsCache = null;
    if (window.lw043RefreshPopupSides) lw043RefreshPopupSides();
    ensurePreviewShell();
    previewSideCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length || previewSideCount;
    if (window.lw043AfterUpdateSize) lw043AfterUpdateSize(previewSideCount);
    else { bindEvents(); window.lw043UpdatePreview(); }
  };

  window.lw043OnPopupClose = function() {
    $('.product-info--mk006 [class*="product_info_main_"]').removeClass('has-error');
  };

  /* [6] Fehler-Fokus: die Kundin wird zum ERSTEN Problem gebracht — nur
     dessen Flaeche wird aufgeklappt und angescrollt; die uebrigen tragen ein
     rotes „!" am zugeklappten Kopf und kommen beim naechsten Klick auf „In
     den Warenkorb" der Reihe nach dran. */
  window.lw043ValidateSides = function(zu) {
    zu = Math.min(Math.max(parseInt(zu, 10) || 1, 1), 2);
    var erstesProblem = -1;
    for (var i = 0; i < zu; i++) {
      var $side = mk006SideEl(i);
      $side.removeClass('has-error');
      $side.find('.mk006-side-error').hide();
      if (!sideHasContent(i)) {
        $side.addClass('has-error');
        $side.find('.mk006-side-error').show();
        if (erstesProblem < 0) erstesProblem = i;
      }
    }
    if (erstesProblem < 0) return true;
    mk006OpenSide(erstesProblem, true);
    alert('Bitte fülle die Gravur für jede Seite aus.');
    return false;
  };

  window.lw043AppendSideProperties = function(properies_arr, zu, popup_title) {
    var fontName = getGlobalFont().font_name;
    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }
      var d = getSideData(i);
      if (d.layout === 'nur_motiv' && d.symOnly) {
        properies_arr.push([title + ' Motiv', formatSymbolOrderValue(d.symOnly)]);
        continue;
      }
      /* Eigene Etiketten, damit die Werkstatt sieht, WAS zu gravieren ist:
         die Gradangabe ist die Gravur, der Ort nur die Herkunft. Beim Datum
         umgekehrt herum wichtig — ohne die Eingabe waere „XXVIII·XII·MMXXIV"
         nicht mehr gegenzupruefen. Beide tragen ihre FESTE Schrift mit; sie
         steht nicht in der allgemeinen Font-Zeile, weil die die vom Kunden
         gewaehlte Schrift meint. */
      if (d.layout === MK006_KOORD_LAYOUT) {
        var koordText = [d.line1, d.line2].filter(Boolean).join(' ');
        if (koordText) {
          properies_arr.push([title + ' Koordinaten', koordText]);
          if (d.koordOrt) properies_arr.push([title + ' Ort', d.koordOrt]);
          properies_arr.push([title + ' Font', MK006_FESTE_SCHRIFT]);
        }
        continue;
      }
      if (d.layout === MK006_ROMAN_LAYOUT) {
        if (d.line1) {
          properies_arr.push([title + ' R\u00f6mische Zahlen', d.line1]);
          if (d.romanDatum) properies_arr.push([title + ' Datum', d.romanDatum]);
          properies_arr.push([title + ' Font', MK006_FESTE_SCHRIFT]);
        }
        continue;
      }
      if (d.layout === MK006_TM_LAYOUT) {
        // Getrennte Namen wie auf A221 — nicht das schlichte „Motiv".
        if (d.line1) properies_arr.push([title + ' Text oben', d.line1]);
        if (d.sym2) properies_arr.push([title + ' Motiv unten', formatSymbolOrderValue(d.sym2)]);
        if (d.line1) properies_arr.push([title + ' Font', fontName]);
        continue;
      }
      if (d.layout === '2_zeilen') {
        var r1 = lineOrderRow(title, '1 ZEILEN', '1. Zeile Text + Motiv', d.line1, d.sym1, true);
        var r2 = lineOrderRow(title, '2 ZEILE', '2. Zeile Text + Motiv', d.line2, d.sym2, true);
        if (r1.value) properies_arr.push([r1.name, r1.value]);
        if (r2.value) properies_arr.push([r2.name, r2.value]);
        if (sideHasText(d)) properies_arr.push([title + ' Font', fontName]);
        continue;
      }
      var row1 = lineOrderRow(title, 'Text', 'Text + Motiv', d.line1, d.sym1, true);
      if (row1.value) {
        properies_arr.push([row1.name, row1.value]);
        if (sideHasText(d)) properies_arr.push([title + ' Font', fontName]);
      }
    }
  };

  window.lw043ConfirmHtml = function(zu, popup_title) {
    var html = '';
    var template = $('#form_message_option2').html() || $('#form_message_option').html();
    if (!template) return '';
    var fontName = getGlobalFont().font_name;

    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }
      var d = getSideData(i);
      if (d.layout === 'nur_motiv' && d.symOnly) {
        html += template.replaceAll('{option_name}', title + ' Motiv').replaceAll('{option_value}', normalizeStoredSymbol(d.symOnly));
        continue;
      }
      if (d.layout === MK006_KOORD_LAYOUT) {
        var kText = [d.line1, d.line2].filter(Boolean).join(' ');
        if (kText) {
          html += template.replaceAll('{option_name}', title + ' Koordinaten').replaceAll('{option_value}', kText);
          if (d.koordOrt) html += template.replaceAll('{option_name}', title + ' Ort').replaceAll('{option_value}', d.koordOrt);
          html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', MK006_FESTE_SCHRIFT);
        }
        continue;
      }
      if (d.layout === MK006_ROMAN_LAYOUT) {
        if (d.line1) {
          html += template.replaceAll('{option_name}', title + ' R\u00f6mische Zahlen').replaceAll('{option_value}', d.line1);
          if (d.romanDatum) html += template.replaceAll('{option_name}', title + ' Datum').replaceAll('{option_value}', d.romanDatum);
          html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', MK006_FESTE_SCHRIFT);
        }
        continue;
      }
      if (d.layout === MK006_TM_LAYOUT) {
        if (d.line1) html += template.replaceAll('{option_name}', title + ' Text oben').replaceAll('{option_value}', d.line1);
        if (d.sym2) html += template.replaceAll('{option_name}', title + ' Motiv unten').replaceAll('{option_value}', normalizeStoredSymbol(d.sym2));
        if (d.line1) html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', fontName);
        continue;
      }
      if (d.layout === '2_zeilen') {
        var c1 = lineOrderRow(title, '1 ZEILEN', '1. Zeile Text + Motiv', d.line1, d.sym1, false);
        var c2 = lineOrderRow(title, '2 ZEILE', '2. Zeile Text + Motiv', d.line2, d.sym2, false);
        if (c1.value) html += template.replaceAll('{option_name}', c1.name).replaceAll('{option_value}', c1.value);
        if (c2.value) html += template.replaceAll('{option_name}', c2.name).replaceAll('{option_value}', c2.value);
        if (sideHasText(d)) html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', fontName);
        continue;
      }
      var cRow = lineOrderRow(title, 'Text', 'Text + Motiv', d.line1, d.sym1, false);
      if (cRow.value) {
        html += template.replaceAll('{option_name}', cRow.name).replaceAll('{option_value}', cRow.value);
        if (sideHasText(d)) html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', fontName);
      }
    }
    // [7] FOKUS 2026-08-18: Vorschau-Streifen-Platzhalter voranstellen — Yin:
    // "确认页面的产品都没上,产品图没上". lw043FillConfirmVorschau fuellt ihn
    // einen Takt spaeter (siehe dort).
    if (html) html = '<div class="mk006-confirm-vorschau" aria-hidden="true"></div>' + html;
    return html;
  };

  /* [7] Vorschau-Streifen auf der Bestaetigungsseite: klont die live
     gerenderte Buehne. Beim Bestaetigen ist das Fenster zu, die Buehne also
     0px breit — darum vorher unsichtbar messbar machen (fixed, -9999px),
     alle Flaechen aufklappen (seit dem Akkordeon [3], 2026-08-19), frisch
     rendern, klonen, alles zurueckdrehen. */
  /* Zuschnittrahmen fuer den Vorschau-Streifen auf der Bestaetigungsseite.
     An den MK006-Bildern gemessen, NICHT von LW043 uebernommen (dort umschloss
     die Box einen Engel, der deutlich tiefer haengt: bottom 88.5 statt 75.31).

     Messverfahren: Kette und Anhaenger haengen als EIN Metallteil zusammen,
     eine reine Schwellwertsuche wuerde die Kette bis zum Bildrand mitnehmen.
     Darum morphologisches Opening (Scheibe r = 20 px) — das duenne Kettenglied
     faellt weg, Plaettchen + Herz + Oesen bleiben stehen. Der Schlagschatten
     (ab y = 1240) ist vorher ausmaskiert.

     Gemessen auf der VEREINIGUNG der drei Farbbilder: es ist dieselbe Aufnahme,
     nur umgefaerbt, aber Silber allein verliert beim Opening die duenne
     Herzfassung (zu wenig Kontrast) und lieferte einen zu kleinen Rahmen.

       front (linke Kette):  x[229,626] y[813,1205] px
       back  (rechte Kette): x[984,1375] y[817,1205] px

     In der Klonquelle hiess diese Konstante ENGEL_BOX. Hier umbenannt: MK006
     hat keinen Engel, und ein Name, der auf das falsche Schmuckteil zeigt,
     schickt die naechste Sitzung in die Irre. */
  var MK006_ANHAENGER_BOX = {
    top: 50.81, bottom: 75.31, rand: 3,
    front: { left: 14.31, right: 39.12 },
    back: { left: 61.50, right: 85.94 }
  };

  function lw043FillConfirmVorschau() {
    /* Der Selektor sieht nach Verschachtelung aus, IST es auch: die Seite hat
       einen einzelnen AEUSSEREN Container mit der Klasse message-confirm-item-2
       (sections/main-product.liquid), den das Event-File per .html(main_html2)
       befuellt — main_html2 enthaelt unseren Platzhalter UND, verwirrenderweise,
       lauter innere Zeilen-<div>, die zufaellig dieselbe Klasse tragen. .last()
       traefe sonst auch treffer aus fremden Personalisierungs-Modulen auf
       derselben Seite. */
    var $ziel = $('.message-confirm-item-2 .mk006-confirm-vorschau').last();
    if (!$ziel.length || $ziel.children().length) return;
    var $popup = $('.up-Fenster-p-personalization-1');
    if (!$popup.length) return;

    var altStyle = $popup.attr('style') || '';
    var $zu = mk006AlleSeiten().not('.is-side-open');
    $popup.css({ display: 'block', visibility: 'hidden', position: 'fixed', left: '-9999px', top: '0' });
    $zu.addClass('is-side-open');
    window.lw043UpdatePreview();

    var $stage = $('[data-mk006-preview-stage]').first();
    var sw = $stage.length ? $stage[0].offsetWidth : 0;
    var sh = $stage.length ? $stage[0].offsetHeight : 0;
    if (sw && sh) {
      var zweiFlaechen = getActiveSideCount() > 1 && !usesEinzelPreviewBase();
      var flaechen = zweiFlaechen
        ? ['front', 'back']
        : [getPhysicalSideIndex(0) === 1 ? 'back' : 'front'];
      var GAP = 8, spalte = $ziel.width() || 320;
      var pro = Math.floor((spalte - GAP * (flaechen.length - 1)) / flaechen.length);
      var ZIEL_B = Math.max(64, Math.min(150, pro));

      flaechen.forEach(function(side) {
        var box = MK006_ANHAENGER_BOX[side] || MK006_ANHAENGER_BOX.front;
        var R = MK006_ANHAENGER_BOX.rand;
        var fx = Math.max(box.left - R, 0);
        var fy = Math.max(MK006_ANHAENGER_BOX.top - R, 0);
        var fw = Math.min(box.right + R, 100) - fx;
        var fh = Math.min(MK006_ANHAENGER_BOX.bottom + R, 100) - fy;

        var $klon = $stage.clone();
        if (zweiFlaechen) {
          var fremd = side === 'back' ? 'front' : 'back';
          $klon.find('.mk006-preview-text--' + fremd).remove();
        }

        var fensterPx = sw * fw / 100;
        var f = ZIEL_B / fensterPx;
        var $clip = $('<div class="mk006-cv-clip"></div>').css({
          width: ZIEL_B + 'px',
          height: Math.ceil(sh * fh / 100 * f) + 'px',
          overflow: 'hidden'
        });
        var $scale = $('<div class="mk006-cv-scale"></div>').css({
          width: sw + 'px',
          transform: 'scale(' + f + ') translate(' + (-sw * fx / 100) + 'px,' + (-sh * fy / 100) + 'px)',
          'transform-origin': 'top left'
        });
        $scale.append($klon);
        $clip.append($scale);

        $ziel.append($('<div class="mk006-cv-item"></div>')
          .css('width', ZIEL_B + 'px')
          .append($clip)
          .append('<div class="mk006-cv-name">'
            + esc(side === 'back' ? 'Rückseite' : 'Vorderseite') + '</div>'));
      });
    }

    $zu.removeClass('is-side-open');
    $popup.attr('style', altStyle);
  }
  window.lw043FillConfirmVorschau = lw043FillConfirmVorschau;

  window.lw043EnhanceConfirmOptions = function() {
    // laeuft im Event-File VOR dem Einhaengen von .message-confirm-item-2 —
    // der Handler dort ist synchron, ein Takt Verzoegerung reicht.
    setTimeout(lw043FillConfirmVorschau, 0);
  };

  if (!isEngravingOnlyPopup) {
    $(document).on('change.mk006Geburtsstein', '[name="properies"]', function() {
      if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.lw043UpdatePreview();
    });
  }
  $(document).on('change.mk006Color', '[name="option1"]', function() {
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.lw043UpdatePreview();
  });
  $(document).on('change.mk006GravurOption', '[name="option2"]', function() {
    window.lw043GravurConfig = null;
    window.lw100GravurConfig = null;
    window.lwGravurConfig = null;
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.lw043UpdatePreview();
  });

  /* ---- Wave 0 SS4.4 (2026-08-15): Warnbanner im Reglerfenster, solange die
     Vorschau zugeklappt neben dem Sichtfeld parkt. Hintergrund: das
     Personalisierungsfenster ist immer im DOM und immer display:block —
     zugeklappt steht es nur rechts NEBEN dem Viewport. Die Regler schrieben
     ihre Werte auch dann, die Vorschau aenderte sich auch — nur unsichtbar.
     Yin hat auf as022 einen Nachmittag lang "tote" Regler gesucht, die
     keine waren. Poll statt Hook: die fuenf handgebauten Panels haben
     verschieden geformte Open/Close-Pfade, ein 800-ms-Intervall hinter dem
     URL-Tor ist uniform, billig und kann keinen davon verpassen. */
  if (mk006TunerEnabled()) (function () {
    function vorschauSichtbar() {
      var b = document.querySelector('[class*="preview-stage"]');
      if (!b) return false;
      var r = b.getBoundingClientRect();
      return r.width > 0 && r.height > 0
        && r.left < window.innerWidth && r.right > 0
        && r.top < window.innerHeight && r.bottom > 0;
    }
    setInterval(function () {
      var panel = document.getElementById('mk006-tuner');
      if (!panel) return;
      var h = document.getElementById('mk006-tuner-zu-hinweis');
      if (!h) {
        h = document.createElement('div');
        h.id = 'mk006-tuner-zu-hinweis';
        h.textContent = '\u201EJetzt personalisieren\u201C \u00F6ffnen \u2014 die Vorschau ist zugeklappt; Regler wirken sonst unsichtbar.';
        h.style.cssText = 'display:none;background:#7a2e22;color:#fff;padding:6px 8px;border-radius:4px;margin:4px 0;font-size:11px;line-height:1.35';
        var kopf = panel.querySelector('.kt-title');
        if (kopf && kopf.nextSibling) panel.insertBefore(h, kopf.nextSibling);
        else panel.appendChild(h);
      }
      h.style.display = vorschauSichtbar() ? 'none' : 'block';
    }, 800);
  })();

})(jQuery);
